import React, { useState, useEffect, useContext, useRef } from "react"
import Section from "../sections/section"
import RightSideBar from "../sections/section-right-side-bar"
import { SectionContext } from "../context/sectionContext"
import { PageContext } from "../context/pageContext"
import { JourneyContext } from "../context/journeyContext"
import { ErrorContext } from "../context/errorContext"
import { ConditionContext } from "../context/conditionContext"
import { componentRenderCheck, multiConditionComponentRenderCheck } from "../services/componentRenderCheck"
import { refreshToken } from "../../interceptors/jwt-interceptor"
// import { window, document } from "browser-monads";
import {
  saveApplication,
  saveApplicationDetailsOverall,
  generateBI,
  fetchApplicationDetails,
  getAllInputQuotations,
  saveTransactionDetails,
  getIpAddress,
  getJWTTokenForIp,
  checkPaymentStatus,
  paymentTextDecrypt,
  saveEnachTransactionDetails,
  digilocker,
  checkTPA,
  updateUserTrackerDetails,
  verifyCaptcha,
  saveBasbaTransactionLogs,
  getConfigByType
} from "../../services/apiservice"
import { findCurrentJourneyCode, getKeyFromValueLookup, getValueFromLookup, getLastPageAndLastSection, getAge, DataLayerIntegration } from "../services/helperFunctions"
import * as callBiKeyJson from "../../../static/callBiKey.json"
import * as freezeJson from "../../../static/freezeDataOnApiCalls.json"
import * as lookup from "../../../static/lookup.json"
import * as moment from "moment"

//static pages
import InsureSmartYourFundValue from "../sections/insureSmart/insureSmartYourFundValue"
import ProvideYourConsent from "../sections/provide-your-consent"
import Ekyc from "../sections/ekyc/ekyc"
import EkycProposer from "../sections/ekyc/ekycProposer"
import Ckyc from "../sections/ckyc"
import BiGIAP from "../sections/giap/biGIAP"
import ProvideYourConsentProposer from "../sections/provide-your-consent-proposer"
import BenefitIllustration from "../sections/benefit-illustration"
import Payment from "../sections/payment"
import UploadDocuments from "../sections/upload-documents"
import ChooseYourPlan from "../sections/choose-your-plan"
import SuccessfulTransactions from "../sections/successful-transaction"
import Declaration from "../sections/declaration"
import Submission from "../sections/submission"
import UnsuccessfulTransaction from "../sections/unsuccessful-transaction"
import PendingTransaction from "../sections/pending-transaction"
import BenefitIllustrationPos from "../sections/BI-POS"
import BenefitIllustrationUlip from "../sections/BI-ULIP"
import BIFlexiSaving from "../sections/flexiEdge/biFlexiEdge"
import BiGsp from "../sections/gsp/biGsp"
import BIGopaLAPlan from "../sections/gopa/biGopaLA "
import BiTitaniumPlusPlan from "../sections/titaniumPlus/biTitaniumPlus"
import EasyBachatPremium from "../sections/easyBachatPremium"
import Invest4GFundValue from "../sections/invest4gFundValue"
import ReviewDetails from "../sections/review-details"
import ReviewDetailsflexiEdge from "../sections/flexiEdge/review-details-flexiEdge"
import BiMoneyBack from "../sections/moneyBack/biMoneyBack"
import { element } from "prop-types"
import { errorToastr, successToastr, clearToastr } from "../../services/error-handler"
import { success } from "toastr"
import BenefitIllustrationGSP from "../sections/BenefitIllustrationGSP"
import ENachPhysicalMandate from "../sections/Enach-physicalMandate"
import CkycProposer from "../sections/ckycProposer"
import YourPremiumMoneyBack from "../sections/moneyBack/premiumQuoteMoneyBack"
import YourPremiumQuotation from "../sections/titaniumPlus/premiumQuoteTitanium"
import YourPremiumQuotationGIAP from "../sections/giap/premiumQuotationGIAP"
import YourPremiumQuotationGSP from "../sections/gsp/premiumQuotationGsp"
import { ConsoleView } from "react-device-detect"
import BiYourFound from "../sections/insureSmart/biYourFund"
import YourPremiumQuotationJeevanNivesh from "../sections/jeevanNivesh/yourPremiumQuotaionJeevanNivesh"
import BiJeevanNivesh from "../sections/jeevanNivesh/biJeevanNivesh"
import SmartJuniorBenefitIllustration from "../sections/smartJunior/SmartJuniorBenefitIllustration"
import SmartJuniorPremiumQuotation from "../sections/smartJunior/SmartJuniorPremiumQuotation"
import PremiumQuoteInvest4g from "../sections/invest4g/premiumQuoteInvest4g"
import BIInvest4g from "../sections/invest4g/biInvest4g"
import GuaranteedFortunePQ from "../sections/guaranteedFortune/guaranteedFortunePQ"
import GuaranteedFortuneBI from "../sections/guaranteedFortune/guaranteedFortuneBI"
import SecureBhavishyaFund from "../sections/secureBhavishya/Secure_Bhavishya_fund"
import Secure_Bhavishya_BI from "../sections/secureBhavishya/Secure_Bhavishya_BI"
import YourPremiumQuotationGuaranteedFuture from "../sections/guranteedFuture/premiumQuotationGuaranteedFuture"
import BIGuaranteedFuture from "../sections/guranteedFuture/guranteedFutureBI"
import BiGI4L from "../sections/gi4l/biGI4L"
import SalesConfidentialReport from "../sections/salesConfidentialReport"
import BiGAIN from "../sections/gain/gain-BI"
import ThankYou from "../sections/Thank-You"
import YourPremiumQuotationAlphaWealth from "../sections/alphaWealth/alphaWealth_PremiumQuotation"
import BIalphaWealthPlan from "../sections/alphaWealth/alphaWealth_BI"
import BookTPASlot from "../sections/bookTPASlot"
import BookTPASlotSA from "../sections/bookTPASlotSA"
import { TpaContext } from "../context/tpaContext"
import { navigate } from "gatsby"
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import PendingTransactionBasba from "../sections/pending-transaction-basba"
import { convertJson, dataLayerConvertJson } from "../services/dataLayerMapper"

const Page = props => {

  //{local component states}
  // const sections = props.sections;
  const [currentSectionIndex, setCurrentSectionIndex] = useState(0)
  const [showError, setShowError] = useState(false)
  const [nvestFilterResult, setNvestFilterResult] = useState()
  const [saveApplicationCounter, setSaveApplicationCounter] = useState(0)

  //handeling context{context states}
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [pageState, setPageState] = useContext(PageContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [errorState, setErrorState] = useContext(ErrorContext)
  const [conditionState, setConditionState] = useContext(ConditionContext)
  const [firstPassForFreezingDataSections, setFirstPassForFreezingDataSections] = useState({
    "personalDetailsSection": true,
    "residenceDetailsSection": true,
    "professionalDetailSection": true,
    "sectionISelect360ProfessionalDetail": true,
    "healthAndLifeStyleDetailSection": true,
    "spouseQuestionnaire": true,
    "spouseMedicalQuestionnaire": true,
    "SectionPOSFPSPersonalDetails": true,
    "SectionPOSCommunicationAddress": true,
    "SectionPOSOccupationDetails": true,
    "SectionPOSProposerDetails": true,
    "SectionFlexiEdgeFillProposalPersonalDetail": true,
    "SectionFlexiEdgeFillProposalProposerDetails": true,
    "SectionFlexiEdgeFillproposalOccupationDetails": true,
    "SectionFlexiEdgeFillProposalCommunicationAddress": true,
    "SectionFlexiEdgeBankDetailsOfProposer": true,
    "sectionGOPAJointLifeQuestionnaire": true
  })
  const [firstPassForPremiumPaymentBicall, setFirstPassForPremiumPaymentBicall] = useState(true)
  const [firstPageAutoFillApiCall, setFirstPageAutoFillApiCall] = useState(false)
  const [showMainButtonFlexiEdgePlan, setShowMainButtonFlexiEdgePlan] = useState(true)
  const ProductJourneyId = [ 
     "FlexiEdgeJourney",
     "titaniumPlusJourney",
     "alphaWealthPlanJourney",
     "guaranteedSavingsOption",
     "guaranteedIncomeAdvantage",
     "GuarateedOnePayJourney",
     "insureSmart",
     "moneyBackAdvantage",
     "jeevanNivesh",
     "invest4GJourney",
     "secureBhavishyaJourney",
     "smartJuniorPlan",
     "guaranteedFortuneJourney",
     "guaranteedFutureJourney",
     "guaranteedIncome4LifeJourney",
     "GAINjourney"
    ]

  const [callBi, setCallBi] = useState(false)
  const {setTpaState,tpaState, tpaStateSA,setTpaStateSA} = useContext(TpaContext)
  const { executeRecaptcha } = useGoogleReCaptcha();
  
  const [callJl,setCallJl] = useState(false)
  const callJlref = useRef("nocall")
  const products_to_be_closed = ["invest4GJourney","healthFirstJourney","GuarateedOnePayJourney","guaranteedIncome4LifeJourney","guaranteedIncomeAdvantage","guaranteedSavingsOption","FlexiEdgeJourney","secureBhavishyaJourney","jeevanNivesh","insureSmart","moneyBackAdvantage","smartJuniorPlan"]

  const sections = props.sections?.filter(element => {
    if (element.conditions.length === 1) {
      if (componentRenderCheck(element.conditions[0], conditionState[element.conditions[0].watchKey], journeyState)) {
        return element
      }
    } else if (element.conditions.length > 1) {
      if (multiConditionComponentRenderCheck(element.conditions, conditionState, journeyState)) {
        return element
      }
    } else {
      return element
    }
  })

  function applicationDataInJourneyFormat(value, typeOfMandate, statusOfMandate) {
    if (!sectionState) {
      return {}
    }
    let sectionStateToPass = JSON.parse(JSON.stringify(sectionState))
    if (!sectionStateToPass.sectionId) {
      sectionStateToPass.sectionId = sections?.[currentSectionIndex]?.sectionId
    }
    if (value && value.length) {
      sectionStateToPass.sectionData[value[0]] = value[1]
    }

    let pageData = pageState?.pageData.filter(
      element => element.sectionId !== sectionStateToPass?.sectionId
    )
    let journeyData = journeyState.journeyData.filter(
      element =>
        element.pageId !== props.pages?.[props.currentPageIndex]?.pageId
    )

    let LoadPaylod = [
      ...journeyData,
      {
        pageId: props.pages?.[props.currentPageIndex]?.pageId,
        pageData: [...pageData, sectionStateToPass],
      },
    ]
    // console.log(LoadPaylod, " LoadPaylodForDataLayer")
    let loadPayloadJson = convertJson(LoadPaylod)
    console.log(loadPayloadJson)
    let journeyFormatData = dataLayerConvertJson(
      loadPayloadJson,
      journeyState.journeyIdFromStrapi,
      props.pages[props.currentPageIndex].pageId,
      sections[currentSectionIndex]?.sectionId
    )
    journeyFormatData["basicDetails"] = {
      paymentMode: journeyState.paymentMode,
      premium: journeyState.premium,
      applicationNumber: journeyState.applicationNo,
      illustrationNumber: journeyState.illustrationNumber,
      paymentOption:
        props.currentPageIndex > 1 ? journeyState.paymentStep : "",
      existingCustomer: props.currentPageIndex >= 1 ? "N" : "",
      isPhysicalMandateOpt:
        typeOfMandate === "physicalMandate"
          ? true
          : typeOfMandate === "enach"
            ? false
            : journeyState.isPhysicalMandateOpt,
      enachSuccess:
        statusOfMandate === "enachSuccess"
          ? true
          : statusOfMandate === "enachFail"
            ? false
            : journeyState.enachSuccess,
      nachStatus:
        statusOfMandate === "nachSuccess" ? true : journeyState.nachStatus,
    }

    console.log(journeyFormatData, "journeyFormatData")
    return journeyFormatData
  }

  //Code to call datalayer fn in every landing page only for HSBC channel in future plan
  useEffect(() => {
    if(journeyState?.channel && !["HSBC", "A"].includes(journeyState?.channel)){
      return;
    }
    let journeyFormatData =  applicationDataInJourneyFormat()
    const isPaymentData = Boolean(props.paymentData || props.lienData)
    if (isPaymentData && ["SectionGuaranteedFuturePersonelDetails","SectionFlexiEdgeFillProposalPersonalDetail"].includes(sections?.[currentSectionIndex]?.sectionId)){
      return;
    }
    if (props.resumeJourneyData && currentSectionIndex === 0 && ["SectionGuaranteedFuturePersonelDetails"].includes(sections?.[currentSectionIndex]?.sectionId)){
      return;
    }
    if (["SectionGuaranteedFuturePersonelDetails"].includes(sections?.[currentSectionIndex]?.sectionId)){
      const events = window.dataLayer
      if (events && events.length > 0){
        let lastManualEvent = null;
        for (let i = events.length - 1; i >= 0; i--) {
          if (events[i]?.ProductName) {
            lastManualEvent = events[i];
            break;
          }
        }
        if (lastManualEvent?.event === "IGFP_Buy_Residence&Occu_Back"){
          DataLayerIntegration(journeyFormatData,"",sections?.[currentSectionIndex]?.sectionId,"secondPageLanded", journeyState)
          return;
        }
      }
    }
    if (["SectionGuaranteedFuturePersonelDetails"].includes(sections?.[currentSectionIndex]?.sectionId)){
      const events = window.dataLayer
      if (events && events.length > 0){
        let lastManualEvent = null;
        for (let i = events.length - 1; i >= 0; i--) {
          if (events[i]?.ProductName) {
            lastManualEvent = events[i];
            break;
          }
        }
        if (lastManualEvent?.event === "IGFP_Buy_BenefitIllus_ReCalculate"){
          DataLayerIntegration(journeyFormatData,"",sections?.[currentSectionIndex]?.sectionId,"secondPageLanded", journeyState)
          return;
        }
      }
    }
    if (["sectionBookSlot"].includes(sections?.[currentSectionIndex]?.sectionId)){
      if (!tpaState?.medicalType || !tpaState?.tpaName){
        return;
      }
    }

    if (["sectionBookSlotSA"].includes(sections?.[currentSectionIndex]?.sectionId)){
      if (!tpaStateSA?.medicalType || !tpaStateSA?.tpaName){
        return;
      }
    }

    if(!journeyState.journeyId){
      DataLayerIntegration(journeyFormatData,"",sections?.[currentSectionIndex]?.sectionId,"landing", journeyState)
    }else{
      DataLayerIntegration(journeyFormatData, "landing", sections?.[currentSectionIndex]?.sectionId, "", journeyState)
    }
   }, [currentSectionIndex])

  //Code to scroll to top
  useEffect(() => {
    window.scroll(0, 0);
  }, [currentSectionIndex])

  //Code for decryptData
  useEffect(() => {
    //case of redirection from bank source
    if (props.decryptData) {
      setPageState(props.decryptData?.journeyPayload[0])
      setSectionState(prev => {
        return ({
          ...prev,
          sectionId: props.decryptData?.journeyPayload[0].pageData[0].sectionId,
          sectionFirstPass: true,
          sectionData: { ...prev.sectionData, ...props.decryptData?.journeyPayload[0].pageData[0].sectionData }
        })
      })
      if (props.decryptData.rmData) {
        setJourneyState(prev => {
          return ({
            ...prev,
            subChannel: props.decryptData?.subChannel,
            planName: props.decryptData?.planName,
            agentDetails: {
              "rmLedJourneyInd": "01",
              "rmLedFNAInd": "N",
              "hsbcRMName": props.decryptData?.rmData?.FULLNAME,
              "hsbcRMMobileNo": props.decryptData?.rmData?.RMMOBILE,
              "rmLedAgentId": props.decryptData?.rmData?.RMCODE,
              "hsbcRMEmailId": props.decryptData?.rmData?.RMEMAIL,
              "rmName": props.decryptData?.rmData?.FULLNAME,
              "rmContactNo": props.decryptData?.rmData?.RMMOBILE,
              "rmLedAgentBRCode": "",
              "agentBankName": ""
            },
            rmLedJourney: "Y"

          })
        })
      } else if (props.decryptData.fnaData) {
        setJourneyState(prev => {
          return ({
            ...prev,
            fnaData: props.decryptData.fnaData
          })
        })
      } else {
        setJourneyState(prev => {
          return ({
            ...prev,
            subChannel: props.decryptData?.subChannel,
            planName: props.decryptData?.planName
          })
        })
      }


    }
    // const urlParams = new URLSearchParams(window.location.search)
    // let urlPart  =window.location.search.toLowerCase()
    // if(urlPart.includes('hsbc')){
    //   document.body.style.backgroundColor = "#ededed";
    // }
  }, [])

  //Code for redirection from payment page
  useEffect(() => {
    //case of redirection from payment page
    let lastPage
    let status
    if (props.paymentData && props.paymentData.payloadJson) {
      status = props.paymentData.payloadJson.status
      let payloadForSaveTransaction = {
        journeyId: props.paymentData.payloadJson.journeyId,
        ...props.paymentData.decryptData
      }
      console.log(payloadForSaveTransaction, "payloadForSaveTransaction-redirectCase")
      saveTransactionDetails(payloadForSaveTransaction).then((res) => {
        console.log("save transaction details 'res'")
        let payload = {
          _id: props.paymentData.payloadJson.journeyId
        }
        fetchApplicationDetails(payload)
          .then(res => {

            const biJsonFirstYear = res?.journeyData?.productDetails?.BIJson
              ? JSON.parse(res.journeyData.productDetails.BIJson)[0]
              : {}

             const dataLayerObj = {
              annualPremiumEquivalent:
                res?.journeyData?.productDetails?.annulizedPremium ??
                biJsonFirstYear?.ANN_PREM_YEARLY ??
                "",
              premium:
                res?.journeyData?.productDetails?.premWithOutTax != null
                  ? Math.floor(
                      res.journeyData.productDetails.premWithOutTax
                    ).toString()
                  : biJsonFirstYear?.MODAL_PREM_DISP ?? "",
              totalPremium:
                res?.journeyData?.productDetails?.paymentKey ??
                biJsonFirstYear?.MODAL_PREM_DISP ??
                "",
              proceedWith : res?.journeyData?.lifeAssuredDetails?.proceedWith || "",
              maturityValue: biJsonFirstYear?.FINAL_FV || ""
            }
            // Save to sessionStorage
            sessionStorage.setItem("dataLayer", JSON.stringify(dataLayerObj))
            sessionStorage.setItem("isResidentDetailsSubmitted", true)
            sessionStorage.setItem("isNomineeDetailsSubmitted", true)
            sessionStorage.setItem("isCustomiseDetailsSubmitted",true)
            sessionStorage.setItem("isPortfolioDetailsSubmitted", true)
            sessionStorage.setItem("isInsuranceDetailsSubmitted", true)



            lastPage = res.journeyData.lastPage
            let temp = journeyState.journeySteps
            let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "makePayment")
            let pageShowWithTransactionStatus
            if (status === "Success") {
              pageShowWithTransactionStatus = temp.pages[tempPageIndexToChange].sections.filter(element => { return (element.sectionId !== "unsuccessful-transaction" && element.sectionId !== "pending-transaction" && element.sectionId !== "pending-transaction-basba") })
            } else if (status === "Pending") {
              pageShowWithTransactionStatus = temp.pages[tempPageIndexToChange].sections.filter(element => { return (element.sectionId !== "unsuccessful-transaction" && element.sectionId !== "successful-transaction" && element.sectionId !== "pending-transaction-basba") })
            } else if (status === "Failed") {
              pageShowWithTransactionStatus = temp.pages[tempPageIndexToChange].sections.filter(element => { return (element.sectionId !== "successful-transaction" && element.sectionId !== "pending-transaction" && element.sectionId !== "pending-transaction-basba") })
            }
            console.log(pageShowWithTransactionStatus, "pageShowWithTransactionStatus")
            temp.pages[tempPageIndexToChange].sections = pageShowWithTransactionStatus
            /*Helper Function  For RMJourney Freeze State*/

            // Canara POS Logic Remove SCR section for normal journey
            if (props?.resumeJourneyData?.journeyData?.journeyType?.toLowerCase() === "canarapos") {
              const pageIndex = temp.pages.findIndex(page => page.pageId === "makePayment");
              temp.pages[pageIndex].sections = temp.pages[pageIndex].sections.filter(
                section => section.sectionId === "eNach-physicalMandate"
              )          } else {
              // Remove SCR section for normal journey
              const pageIndex = temp.pages.findIndex(page => page.pageId === "PageFlexiEdgeUploadDocuments");
              temp.pages[pageIndex].sections = temp.pages[pageIndex].sections.filter(section => section.sectionId !== "salesConfidentialReport");
            }

            const changeJourneySteps = (pageId, sectionId, componentGroup, componentFormControlKey, key, value) => {
              try {
                let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
                let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
                let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentGroup)
                let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === componentFormControlKey)
                console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "======>ImpTemp0")
                temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange][key] = value
              } catch (err) {
                console.log(err, "=====>ErrorInPage.js===Line-152")
              }
            }
            let fillProposalPageId
            let firstPageId
            if (journeyState.journeyIdFromStrapi === "iSelectJourney") {
              fillProposalPageId = "fillProposalForm"
              firstPageId = "calculatePremiumPage"
            } else if (journeyState.journeyIdFromStrapi === "ISelect360Journey") {
              fillProposalPageId = "pageISelect360FillProposalForm"
              firstPageId = "PageISelect360CalculatePremium"
            } else if (journeyState.journeyIdFromStrapi === "FlexiEdgeJourney") {
              fillProposalPageId = "PageFlexiEdgeFillProposalForm"
              firstPageId = "PageFlexiEdgeCalculatePremium"
            } else if (journeyState.journeyIdFromStrapi === "titaniumPlusJourney") {
              fillProposalPageId = "PageFlexiEdgeFillProposalForm"
              firstPageId = "PageTitaniumPlusCalculateFundValue"
            } else if (journeyState.journeyIdFromStrapi === "alphaWealthPlanJourney") {
              fillProposalPageId = "PageFlexiEdgeFillProposalForm"
              firstPageId = "AlphaWealthPlanCalculateFundValuePage"
            } else if (journeyState.journeyIdFromStrapi === "guaranteedSavingsOption") {
              fillProposalPageId = "PageFlexiEdgeFillProposalForm"
              firstPageId = "PageGuaranteedSavingsCalculatePremium"
            } else if (journeyState.journeyIdFromStrapi === "guaranteedIncomeAdvantage") {
              fillProposalPageId = "PageFlexiEdgeFillProposalForm"
              firstPageId = "PageGuaranteedIncomeAdvantageCalculatePremium"
            } else if (journeyState.journeyIdFromStrapi === "insureSmart") {
              fillProposalPageId = "PageFlexiEdgeFillProposalForm"
              firstPageId = "PageInsureSmartCalculateFundValue"
            } else if (journeyState.journeyIdFromStrapi === "GuarateedOnePayJourney") {
              fillProposalPageId = "PageFlexiEdgeFillProposalForm"
              firstPageId = "PageGuaranteedOnePayCalculatePremium"
            } else if (journeyState.journeyIdFromStrapi === "jeevanNivesh") {
              fillProposalPageId = "PageFlexiEdgeFillProposalForm"
              firstPageId = "PageJeevenNiveshCalculatePremium"
            } else if (journeyState.journeyIdFromStrapi === "moneyBackAdvantage") {
              fillProposalPageId = "PageFlexiEdgeFillProposalForm"
              firstPageId = "PageMoneyBackCalculatePremium"
            } else if (journeyState.journeyIdFromStrapi === "invest4GJourney") {
              fillProposalPageId = "PageFlexiEdgeFillProposalForm"
              firstPageId = "PageInvest4GCalculateFundValue"
            } else if (journeyState.journeyIdFromStrapi === "smartJuniorPlan") {
              fillProposalPageId = "PageFlexiEdgeFillProposalForm"
              firstPageId = "PageSmartJuniorCalculatePremium"
            } else if (journeyState.journeyIdFromStrapi === "secureBhavishyaJourney") {
              fillProposalPageId = "PageFlexiEdgeFillProposalForm"
              firstPageId = "PageSecureBhavishyaCalculatePremium"
            } else if (journeyState.journeyIdFromStrapi === "guaranteedFortuneJourney") {
              fillProposalPageId = "PageFlexiEdgeFillProposalForm"
              firstPageId = "PageGuaranteedFortuneCalculatePremium"
            } else if (journeyState.journeyIdFromStrapi === "guaranteedFutureJourney") {
              fillProposalPageId = "PageFlexiEdgeFillProposalForm"
              firstPageId = "PageGuaranteedFutureCalculatePremium"
            } else if (journeyState.journeyIdFromStrapi === "guaranteedIncome4LifeJourney") {
              fillProposalPageId = "PageFlexiEdgeFillProposalForm"
              firstPageId = "PageGuaranteedIncome4LifeCalculatePremium"
            } else if (journeyState.journeyIdFromStrapi === "GAINjourney") {
              fillProposalPageId = "PageFlexiEdgeFillProposalForm"
              firstPageId = "GAINcalculatePremiumPage"
            }
            if (res.journeyData?.agentDetails?.rmLedJourneyInd === "01") {
              changeJourneySteps(firstPageId, "CPPersonalDetailsSection", "contactNo", "contactCountryCode", "disabled", true)

              if (journeyState.journeyIdFromStrapi === "iSelectJourney") {
                changeJourneySteps(firstPageId, "CPResidentAndOccupationDetailSection", "CPResidentAndOccupationDetail", "country", "disabled", true)
                changeJourneySteps(firstPageId, "CPResidentAndOccupationDetailSection", "CPResidentAndOccupationDetail", "state", "lookupKey", "state_RM")
              } else if (journeyState.journeyIdFromStrapi === "ISelect360Journey") {
                changeJourneySteps(firstPageId, "iSelect360CPResidentAndOccupationDetailSection", "iSelect360CPResidentAndOccupationDetail", "country", "disabled", true)
                changeJourneySteps(firstPageId, "iSelect360CPResidentAndOccupationDetailSection", "iSelect360CPResidentAndOccupationDetail", "state", "lookupKey", "state_RM")
              }
              else if (journeyState.journeyIdFromStrapi === "FlexiEdgeJourney") {
                changeJourneySteps(fillProposalPageId, "SectionFlexiEdgeFillProposalPersonalDetail", "currentCountryofResidence", "currentCountryofResidence", "disabled", true)
                changeJourneySteps(fillProposalPageId, "SectionFlexiEdgeFillProposalPersonalDetail", "currentState", "state", "lookupKey", "state_RM")
                changeJourneySteps(fillProposalPageId, "SectionFlexiEdgeFillProposalPersonalDetail", "residentialStatus", "residentialStatus", "disabled", true)
                changeJourneySteps(fillProposalPageId, "SectionFlexiEdgeFillProposalPersonalDetail", "citizenship", "citizenship", "disabled", true)
                changeJourneySteps(fillProposalPageId, "SectionFlexiEdgeFillProposalPersonalDetail", "nationality", "nationality", "disabled", true)
                changeJourneySteps(fillProposalPageId, "SectionFlexiEdgeFillProposalPersonalDetail", "taxResidenceCountry", "taxResidenceCountry", "disabled", true)
                changeJourneySteps(fillProposalPageId, "SectionFlexiEdgeFillProposalPersonalDetail", "countryOfBirth", "countryOfBirth", "disabled", true)

              }

              changeJourneySteps(fillProposalPageId, "personalDetailsSection", "alternateMobileNo", "AlternateMobCountryCode", "disabled", true)

              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentStatus", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialCountryOfBirth", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialCitizenship", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialNationality", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialTaxResidentialCountry", "disabled", true)

              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "permanentResidentialDetails", "PRCountry", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "permanentResidentialDetails", "PRState", "lookupKey", "state_RM")
            }
            setJourneyState(prev => {
              return ({
                ...prev,
                journeySteps: temp,
                journeyData: res.applicationData,
                journeyId: props.paymentData.payloadJson.journeyId,
                applicationNo: props.paymentData.payloadJson.applicationNumber,
                paymentDecryptData: props.paymentData.decryptData,
                paymentStep: res?.journeyData?.paymentStep,
                premium: res?.journeyData?.premium,
                channel: props.paymentData.payloadJson.source
              })
            })
            props.setCurrentPageIndex(lastPage)
            setCurrentSectionIndex(0)
            setConditionState(prev => {
              return {
                ...prev,
                ...res?.conditionData
              }
            })
            // setFirstPassForFreezingDataSections({
            //   "personalDetailsSection": false,
            //   "residenceDetailsSection": false,
            //   "professionalDetailSection": false
            // })
          })
      })
    }
  }, [props.paymentData])

  //Code for redirection from enach page
  useEffect(() => {
    //case of redirection from enach page
    let lastPage
    let status
    if (props.enachData && props.enachData.enachPayloadJson) {
      status = props.enachData.enachPayloadJson.status
      let payloadForSaveTransaction = {
        journeyId: props.enachData.enachPayloadJson.journeyId,
        ...props.enachData.enachDecryptData
      }
      console.log(payloadForSaveTransaction, "payloadForSaveTransaction-redirectCase")
      saveEnachTransactionDetails(payloadForSaveTransaction).then((res) => {
        console.log("save transaction details 'res'")
        let payload = {
          _id: props.enachData.enachPayloadJson.journeyId
        }
        fetchApplicationDetails(payload)
          .then(res => {
            lastPage = res.journeyData.lastPage
            let temp = journeyState.journeySteps
            let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "makePayment")
            let pageShowWithTransactionStatus = temp.pages[tempPageIndexToChange].sections.filter(element => { return (element.sectionId !== "unsuccessful-transaction" && element.sectionId !== "successful-transaction" && element.sectionId !== "pending-transaction" && element.sectionId !== "pending-transaction-basba") })
            props.setCurrentPageIndex(lastPage)
            setCurrentSectionIndex(1)
            temp.pages[tempPageIndexToChange].sections = pageShowWithTransactionStatus


            // Canara POS Logic Remove SCR section for normal journey
            if(res.journeyData?.journeyType?.toLowerCase() !== "canarapos") {
              const pageIndex = temp.pages.findIndex(page => page.pageId === "PageFlexiEdgeUploadDocuments");
              temp.pages[pageIndex].sections = temp.pages[pageIndex].sections.filter(section => section.sectionId !== "salesConfidentialReport");
            }
            /*Helper Function  For RMJourney Freeze State*/
            const changeJourneySteps = (pageId, sectionId, componentGroup, componentFormControlKey, key, value) => {
              try {
                let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
                let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
                let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentGroup)
                let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === componentFormControlKey)
                console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "======>ImpTemp0")
                temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange][key] = value
              } catch (err) {
                console.log(err, "=====>ErrorInPage.js===Line-152")
              }
            }
            let fillProposalPageId
            let firstPageId
            if (journeyState.journeyIdFromStrapi === "iSelectJourney") {
              fillProposalPageId = "fillProposalForm"
              firstPageId = "calculatePremiumPage"
            } else if (journeyState.journeyIdFromStrapi === "ISelect360Journey") {
              fillProposalPageId = "pageISelect360FillProposalForm"
              firstPageId = "PageISelect360CalculatePremium"
            } else if (journeyState.journeyIdFromStrapi === "FlexiEdgeJourney") {
              fillProposalPageId = "PageFlexiEdgeFillProposalForm"
              firstPageId = "PageFlexiEdgeCalculatePremium"
            } else if (journeyState.journeyIdFromStrapi === "titaniumPlusJourney") {
              fillProposalPageId = "PageFlexiEdgeFillProposalForm"
              firstPageId = "PageTitaniumPlusCalculateFundValue"
            } else if (journeyState.journeyIdFromStrapi === "alphaWealthPlanJourney") {
              fillProposalPageId = "PageFlexiEdgeFillProposalForm"
              firstPageId = "AlphaWealthPlanCalculateFundValuePage"
            } else if (journeyState.journeyIdFromStrapi === "guaranteedSavingsOption") {
              fillProposalPageId = "PageFlexiEdgeFillProposalForm"
              firstPageId = "PageGuaranteedSavingsCalculatePremium"
            } else if (journeyState.journeyIdFromStrapi === "guaranteedIncomeAdvantage") {
              fillProposalPageId = "PageFlexiEdgeFillProposalForm"
              firstPageId = "PageGuaranteedIncomeAdvantageCalculatePremium"
            } else if (journeyState.journeyIdFromStrapi === "insureSmart") {
              fillProposalPageId = "PageFlexiEdgeFillProposalForm"
              firstPageId = "PageInsureSmartCalculateFundValue"
            } else if (journeyState.journeyIdFromStrapi === "GuarateedOnePayJourney") {
              fillProposalPageId = "PageFlexiEdgeFillProposalForm"
              firstPageId = "PageGuaranteedOnePayCalculatePremium"
            } else if (journeyState.journeyIdFromStrapi === "jeevanNivesh") {
              fillProposalPageId = "PageFlexiEdgeFillProposalForm"
              firstPageId = "PageJeevenNiveshCalculatePremium"
            } else if (journeyState.journeyIdFromStrapi === "moneyBackAdvantage") {
              fillProposalPageId = "PageFlexiEdgeFillProposalForm"
              firstPageId = "PageMoneyBackCalculatePremium"
            } else if (journeyState.journeyIdFromStrapi === "invest4GJourney") {
              fillProposalPageId = "PageFlexiEdgeFillProposalForm"
              firstPageId = "PageInvest4GCalculateFundValue"
            } else if (journeyState.journeyIdFromStrapi === "smartJuniorPlan") {
              fillProposalPageId = "PageFlexiEdgeFillProposalForm"
              firstPageId = "PageSmartJuniorCalculatePremium"
            } else if (journeyState.journeyIdFromStrapi === "secureBhavishyaJourney") {
              fillProposalPageId = "PageFlexiEdgeFillProposalForm"
              firstPageId = "PageSecureBhavishyaCalculatePremium"
            } else if (journeyState.journeyIdFromStrapi === "guaranteedFortuneJourney") {
              fillProposalPageId = "PageFlexiEdgeFillProposalForm"
              firstPageId = "PageGuaranteedFortuneCalculatePremium"
            } else if (journeyState.journeyIdFromStrapi === "guaranteedFutureJourney") {
              fillProposalPageId = "PageFlexiEdgeFillProposalForm"
              firstPageId = "PageGuaranteedFutureCalculatePremium"
            } else if (journeyState.journeyIdFromStrapi === "guaranteedIncome4LifeJourney") {
              fillProposalPageId = "PageFlexiEdgeFillProposalForm"
              firstPageId = "PageGuaranteedIncome4LifeCalculatePremium"
            } else if (journeyState.journeyIdFromStrapi === "GAINjourney") {
              fillProposalPageId = "PageFlexiEdgeFillProposalForm"
              firstPageId = "GAINcalculatePremiumPage"
            }
            if (firstPageId && fillProposalPageId && res.journeyData?.agentDetails?.rmLedJourneyInd === "01") {
              changeJourneySteps(fillProposalPageId, "personalDetailsSection", "alternateMobileNo", "AlternateMobCountryCode", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentStatus", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialCountryOfBirth", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialCitizenship", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialNationality", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialTaxResidentialCountry", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "permanentResidentialDetails", "PRCountry", "disabled", true)
              changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "permanentResidentialDetails", "PRState", "lookupKey", "state_RM")
            }
            setJourneyState(prev => {
              return ({
                ...prev,
                journeySteps: temp,
                journeyData: res.applicationData,
                journeyId: props.enachData.enachPayloadJson.journeyId,
                applicationNo: props.enachData.enachPayloadJson.applicationNumber,
                paymentDecryptData: props.enachData.enachDecryptData,
                paymentStep: res?.journeyData?.paymentStep,
                premium: res?.journeyData?.premium,
                channel: props.enachData.enachPayloadJson.source
              })
            })
            setConditionState(prev => {
              return {
                ...prev,
                ...res?.conditionData
              }
            })
          })
      })
    }
  }, [props.enachData])

  //case of redirection from digilocker page
  useEffect(() => {
    if (props.digilockerdata && props.digilockerdata.digilockerPayloadJson && props.digilockerdata.digilockerDecryptData) {
        let payload = {
          _id: props.digilockerdata.digilockerPayloadJson.journeyId
        }
        fetchApplicationDetails(payload)
          .then(async res => {
            try {
              let data = await digilocker(props.digilockerdata.digilockerDecryptData)
            }catch(err){
              console.log(err)
            }finally{
              setJourneyState(prev => {
                return ({
                  ...prev,
                  journeyData: res.applicationData,
                  journeyId: props?.digilockerdata?.digilockerPayloadJson?.journeyId,
                  applicationNo: props?.digilockerdata?.digilockerPayloadJson?.applicationNumber,
                  paymentStep: res?.journeyData?.paymentStep,
                  premium: res?.journeyData?.premium,
                  digiLockerOption: props?.digilockerdata?.digilockerDecryptData?.option,
                  channel: props?.digilockerdata?.digilockerPayloadJson?.source
                })
              })
              props.setCurrentPageIndex(4)
              const temp = journeyState?.journeySteps
              const tempPageIndex = temp?.pages?.findIndex(page => page.pageId === "PageFlexiEdgeUploadDocuments")
              const tempSectionIndex = temp?.pages[tempPageIndex]?.sections?.findIndex(section => section.sectionId === "UploadDocuments")
              setCurrentSectionIndex(tempSectionIndex !== -1 ? tempSectionIndex : 2)
            }
          })
    }
  }, [props.digilockerdata])

    //Code for redirection from lien registeration page
    useEffect(() => {
      let lastPage
      let status
      if (props.lienData && props.lienData.lienPayloadJson) {
        status = props.lienData.lienPayloadJson.status?.toLowerCase()
        let payloadForSaveTransaction = {
          journeyId: props.lienData.lienPayloadJson.journeyId,
          ...props.lienData.lienDecryptData
        }
        saveBasbaTransactionLogs(payloadForSaveTransaction).then((res) => {
          console.log("save transaction details 'res'")
          let payload = {
            _id: props.lienData.lienPayloadJson.journeyId
          }
       
          fetchApplicationDetails(payload)
            .then(res => {

              const biJsonFirstYear = res?.journeyData?.productDetails?.BIJson
              ? JSON.parse(res.journeyData.productDetails.BIJson)[0]
              : {}

             const dataLayerObj = {
              annualPremiumEquivalent:
                res?.journeyData?.productDetails?.annulizedPremium ??
                biJsonFirstYear?.ANN_PREM_YEARLY ??
                "",
              premium:
                res?.journeyData?.productDetails?.premWithOutTax != null
                  ? Math.floor(
                      res.journeyData.productDetails.premWithOutTax
                    ).toString()
                  : biJsonFirstYear?.MODAL_PREM_DISP ?? "",
              totalPremium:
                res?.journeyData?.productDetails?.paymentKey ??
                biJsonFirstYear?.MODAL_PREM_DISP ??
                "",
              proceedWith : res?.journeyData?.lifeAssuredDetails?.proceedWith || "",
              maturityValue: biJsonFirstYear?.FINAL_FV || ""
            }
            // Save to sessionStorage
            sessionStorage.setItem("dataLayer", JSON.stringify(dataLayerObj))
            sessionStorage.setItem("isResidentDetailsSubmitted", true)
            sessionStorage.setItem("isNomineeDetailsSubmitted", true)
            sessionStorage.setItem("isCustomiseDetailsSubmitted",true)
            sessionStorage.setItem("isPortfolioDetailsSubmitted", true)
            sessionStorage.setItem("isInsuranceDetailsSubmitted", true)

              let temp = journeyState.journeySteps
              lastPage = res.journeyData.lastPage
                 // remove scr from normal journey
                let pageIndex = temp.pages.findIndex(page => page.pageId === "PageFlexiEdgeUploadDocuments");
                console.info("pageindex",pageIndex);
                if(pageIndex && pageIndex!==-1 && res.journeyData?.agentDetails?.rmLedJourneyInd === "02"){
                  temp.pages[pageIndex].sections = temp.pages[pageIndex].sections.filter(section => section.sectionId !== "salesConfidentialReport");
                }
              let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "makePayment")
              let pageShowWithTransactionStatus = temp.pages[tempPageIndexToChange].sections.filter(element => { return (element.sectionId !== "unsuccessful-transaction" && element.sectionId !== "successful-transaction" && element.sectionId !== "pending-transaction") }) || [];
              let tempSectionIndex=pageShowWithTransactionStatus.findIndex(section=>section.sectionId==="pending-transaction-basba")//pending-transaction-basba 
              temp.pages[tempPageIndexToChange].sections = pageShowWithTransactionStatus
              /*Helper Function  For RMJourney Freeze State*/
              const changeJourneySteps = (pageId, sectionId, componentGroup, componentFormControlKey, key, value) => {
                try {
                  let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
                  let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
                  let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentGroup)
                  let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === componentFormControlKey)
                  console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "======>ImpTemp0")
                  temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange][key] = value
                } catch (err) {
                  console.log(err, "=====>ErrorInPage.js===Line-152")
                }
              }
              let fillProposalPageId
              let firstPageId
              if (journeyState.journeyIdFromStrapi === "iSelectJourney") {
                fillProposalPageId = "fillProposalForm"
                firstPageId = "calculatePremiumPage"
              } else if (journeyState.journeyIdFromStrapi === "ISelect360Journey") {
                fillProposalPageId = "pageISelect360FillProposalForm"
                firstPageId = "PageISelect360CalculatePremium"
              } else if (journeyState.journeyIdFromStrapi === "FlexiEdgeJourney") {
                fillProposalPageId = "PageFlexiEdgeFillProposalForm"
                firstPageId = "PageFlexiEdgeCalculatePremium"
              } else if (journeyState.journeyIdFromStrapi === "titaniumPlusJourney") {
                fillProposalPageId = "PageFlexiEdgeFillProposalForm"
                firstPageId = "PageTitaniumPlusCalculateFundValue"
              } else if (journeyState.journeyIdFromStrapi === "alphaWealthPlanJourney") {
                fillProposalPageId = "PageFlexiEdgeFillProposalForm"
                firstPageId = "AlphaWealthPlanCalculateFundValuePage"
              } else if (journeyState.journeyIdFromStrapi === "guaranteedSavingsOption") {
                fillProposalPageId = "PageFlexiEdgeFillProposalForm"
                firstPageId = "PageGuaranteedSavingsCalculatePremium"
              } else if (journeyState.journeyIdFromStrapi === "guaranteedIncomeAdvantage") {
                fillProposalPageId = "PageFlexiEdgeFillProposalForm"
                firstPageId = "PageGuaranteedIncomeAdvantageCalculatePremium"
              } else if (journeyState.journeyIdFromStrapi === "insureSmart") {
                fillProposalPageId = "PageFlexiEdgeFillProposalForm"
                firstPageId = "PageInsureSmartCalculateFundValue"
              } else if (journeyState.journeyIdFromStrapi === "GuarateedOnePayJourney") {
                fillProposalPageId = "PageFlexiEdgeFillProposalForm"
                firstPageId = "PageGuaranteedOnePayCalculatePremium"
              } else if (journeyState.journeyIdFromStrapi === "jeevanNivesh") {
                fillProposalPageId = "PageFlexiEdgeFillProposalForm"
                firstPageId = "PageJeevenNiveshCalculatePremium"
              } else if (journeyState.journeyIdFromStrapi === "moneyBackAdvantage") {
                fillProposalPageId = "PageFlexiEdgeFillProposalForm"
                firstPageId = "PageMoneyBackCalculatePremium"
              } else if (journeyState.journeyIdFromStrapi === "invest4GJourney") {
                fillProposalPageId = "PageFlexiEdgeFillProposalForm"
                firstPageId = "PageInvest4GCalculateFundValue"
              } else if (journeyState.journeyIdFromStrapi === "smartJuniorPlan") {
                fillProposalPageId = "PageFlexiEdgeFillProposalForm"
                firstPageId = "PageSmartJuniorCalculatePremium"
              } else if (journeyState.journeyIdFromStrapi === "secureBhavishyaJourney") {
                fillProposalPageId = "PageFlexiEdgeFillProposalForm"
                firstPageId = "PageSecureBhavishyaCalculatePremium"
              } else if (journeyState.journeyIdFromStrapi === "guaranteedFortuneJourney") {
                fillProposalPageId = "PageFlexiEdgeFillProposalForm"
                firstPageId = "PageGuaranteedFortuneCalculatePremium"
              } else if (journeyState.journeyIdFromStrapi === "guaranteedFutureJourney") {
                fillProposalPageId = "PageFlexiEdgeFillProposalForm"
                firstPageId = "PageGuaranteedFutureCalculatePremium"
              } else if (journeyState.journeyIdFromStrapi === "guaranteedIncome4LifeJourney") {
                fillProposalPageId = "PageFlexiEdgeFillProposalForm"
                firstPageId = "PageGuaranteedIncome4LifeCalculatePremium"
              } else if (journeyState.journeyIdFromStrapi === "GAINjourney") {
                fillProposalPageId = "PageFlexiEdgeFillProposalForm"
                firstPageId = "GAINcalculatePremiumPage"
              }
              if (firstPageId && fillProposalPageId && res.journeyData?.agentDetails?.rmLedJourneyInd === "01") {
                changeJourneySteps(fillProposalPageId, "personalDetailsSection", "alternateMobileNo", "AlternateMobCountryCode", "disabled", true)
                changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentStatus", "disabled", true)
                changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialCountryOfBirth", "disabled", true)
                changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialCitizenship", "disabled", true)
                changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialNationality", "disabled", true)
                changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialTaxResidentialCountry", "disabled", true)
                changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "permanentResidentialDetails", "PRCountry", "disabled", true)
                changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "permanentResidentialDetails", "PRState", "lookupKey", "state_RM")
              }
              setJourneyState(prev => {
                return ({
                  ...prev,
                  journeySteps: temp,
                  journeyData: res.applicationData,
                  journeyId: props.lienData.lienPayloadJson.journeyId,
                  applicationNo: props.lienData.lienPayloadJson.applicationNumber,
                  paymentDecryptData: props.lienData.lienDecryptData,
                  paymentStep: res?.journeyData?.paymentStep,
                  premium: res?.journeyData?.premium,
                  channel: props.lienData.lienPayloadJson.source,
                  dedupeResult: res?.journeyData?.lifeAssuredDetails?.matchTypeDedupe,
                  premiumOption: res?.journeyData?.basicDetails?.premiumOption,
                  lastPage: lastPage,
                  lastSection: res?.journeyData?.lastSection,
                  lienStatus: true
                })
              })
              setConditionState(prev => {
                return {
                  ...prev,
                  ...res?.conditionData
                }
              })

              props.setCurrentPageIndex(lastPage)
              if (tempSectionIndex !== null) {
                setCurrentSectionIndex(tempSectionIndex)
              }
            })
        })
      }
    }, [props.lienData])

  //Code for resume journey
  useEffect(() => {
    if (props.resumeJourneyData && !journeyState.journeyId) {
         // journey resumed
    try {
      const payload = {
        journeyId: journeyState.journeyId, 
        buttonClicked:  "Resume journey", 
      };
      updateUserTrackerDetails(payload)
        .then((response) => {
          if (response?.status) {
            console.log("UserTracker updated successfully:", response.message);
          } else {
            console.error("Error in updating UserTracker:", response?.message);
          }
        })
        .catch((error) => {
          console.error("Error in updateUserTrackerDetails API call:", error);
        })
    } catch (error) {
      console.error("Error in resumeJourney", error);
    }
    
      let lastTransaction = props?.resumeJourneyData?.applicationData?.journeyData?.transactionDetails
      let srcTraceId = props?.resumeJourneyData?.applicationData?.journeyData?.transactionDetails?.srcTraceId ?? ''
      let paymentStatus = props?.resumeJourneyData?.applicationData?.journeyData?.transactionDetails?.paymentStatus ?? ''

      console.log("lastTransaction", lastTransaction)

      const resumeJourneyCall = (paymentStatus) => {

        const biJsonFirstYear = props.resumeJourneyData?.journeyData?.productDetails?.BIJson ? JSON.parse(props.resumeJourneyData?.journeyData?.productDetails?.BIJson)[0] : {}
        const dataLayerObj = {
          annualPremiumEquivpalent:
            props.resumeJourneyData?.journeyData?.productDetails
              ?.annulizedPremium ?? biJsonFirstYear?.ANN_PREM_YEARLY ?? "",
          premium:
            props.resumeJourneyData?.journeyData?.productDetails
              ?.premWithOutTax != null
              ? Math.floor(
                  props.resumeJourneyData.journeyData.productDetails
                    .premWithOutTax
                ).toString()
              : biJsonFirstYear?.MODAL_PREM_DISP ?? "",
          totalPremium:
            props.resumeJourneyData?.journeyData?.productDetails?.paymentKey ?? biJsonFirstYear?.MODAL_PREM_DISP ??
            "",
          proceedWith : props.resumeJourneyData?.journeyData?.lifeAssuredDetails?.proceedWith || "",
          maturityValue: biJsonFirstYear?.FINAL_FV || "",
          paymentFrequency: props.resumeJourneyData?.journeyData?.productDetails?.premiumFrequency || ""
        }

        // Save to sessionStorage
        sessionStorage.setItem("dataLayer", JSON.stringify(dataLayerObj))
        const lastPage = props?.resumeJourneyData?.journeyData?.lastPage
        const lastSection = props?.resumeJourneyData?.journeyData?.lastSection
        const isProposer = props?.resumeJourneyData?.journeyData?.lifeAssuredDetails?.isLaAndPropSame === "N"
        if (isProposer){
          if ((lastPage >= 0 && lastSection > 4) || (lastPage > 0 && lastSection >= 0)){
            sessionStorage.setItem("isPortfolioDetailsSubmitted", true)
          }
          if ((lastPage >=0 && lastSection > 3) || (lastPage > 0 && lastSection >= 0)){
            sessionStorage.setItem("isCustomiseDetailsSubmitted",true)
          }
        }else{
          if ((lastPage >= 0 && lastSection > 3) || (lastPage > 0 && lastSection >= 0)){
            sessionStorage.setItem("isPortfolioDetailsSubmitted", true)
          }
          if ((lastPage >=0 && lastSection > 2) || (lastPage > 0 && lastSection >= 0)){
            sessionStorage.setItem("isCustomiseDetailsSubmitted",true)
          }
        }
        if ((lastPage >= 0 && lastSection > 1) || (lastPage > 0 && lastSection >= 0)){
          sessionStorage.setItem("isResidentDetailsSubmitted", true)
        }
        if ((lastPage >= 2 && lastSection > 6) || (lastPage > 2 && lastSection >= 0)){
          sessionStorage.setItem("isNomineeDetailsSubmitted", true)
        }
        if ((lastPage >= 2 && lastSection > 2) || (lastPage > 2 && lastSection >= 0)){
          sessionStorage.setItem("isInsuranceDetailsSubmitted", true)
        }

        if (props.resumeJourneyData?.journeyData?.paymentStatus?.toLowerCase() === "success") {
          const transactions = props.resumeJourneyData?.transactionDetails?.transactions
          if (transactions?.length) {
            const lastTransaction = transactions[transactions.length - 1]
            const isActive = lastTransaction?.mandate?.status === "active";
            const paymentDatalayerDetails = {
              order_id: lastTransaction?.receiptNo || lastTransaction?.mandateId || lastTransaction?.mandateTokenId || "",
              nachStatus: isActive ? "Success" : "",
              nachType: isActive ? "E-Mandate" : ""
            }
            sessionStorage.setItem("paymentDataLayer", JSON.stringify(paymentDatalayerDetails))
          }
        }

        if (props.resumeJourneyData.journeyData.lastPage !== props.currentPageIndex) {
          props.setCurrentPageIndex(props.resumeJourneyData.journeyData.lastPage)
        }
        setErrorState({})
        setCurrentSectionIndex(props.resumeJourneyData.journeyData.lastSection)

        if (journeyState.journeyId !== props.resumeJourneyData.journeyData._id) {
          let temp = journeyState.journeySteps
          let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "makePayment")
          let pageShowWithTransactionStatus
          if(props.resumeJourneyData.journeyData?.isBasbaAttempted==="Y"){
            pageShowWithTransactionStatus=temp.pages[tempPageIndexToChange].sections.filter(element => { return (element.sectionId !== "unsuccessful-transaction" && element.sectionId !== "pending-transaction" && element.sectionId !== "successful-transaction") })
            temp.pages[tempPageIndexToChange].sections = pageShowWithTransactionStatus
          }
          else{
            // handling-pending-payment
            if (paymentStatus === "Success") {
              pageShowWithTransactionStatus = temp.pages[tempPageIndexToChange].sections.filter(element => { return (element.sectionId !== "unsuccessful-transaction" && element.sectionId !== "pending-transaction") })
              temp.pages[tempPageIndexToChange].sections = pageShowWithTransactionStatus
            } else if (paymentStatus === "Pending") {
              pageShowWithTransactionStatus = temp.pages[tempPageIndexToChange].sections.filter(element => { return (element.sectionId !== "unsuccessful-transaction" && element.sectionId !== "successful-transaction") })
              temp.pages[tempPageIndexToChange].sections = pageShowWithTransactionStatus
            } else if (paymentStatus === "Failed") {
              pageShowWithTransactionStatus = temp.pages[tempPageIndexToChange].sections.filter(element => { return (element.sectionId !== "successful-transaction" && element.sectionId !== "pending-transaction") })
              temp.pages[tempPageIndexToChange].sections = pageShowWithTransactionStatus
            }
          }

          console.log("pageWithoutUnsuccessfulTransaction", pageShowWithTransactionStatus)
  
          // Make payment page remove for canaraPos
          let sendCaseToCustomerFirstResume
          if(props?.resumeJourneyData?.journeyData?.journeyType?.toLowerCase() === "canarapos" && props?.resumeJourneyData?.journeyData?.canaraPosCaseType === "sendLinktosales"){
            if(props?.resumeJourneyData?.journeyData?.scrFirstPass){
              temp.pages = temp.pages.filter(page => page.pageId !== "makePayment")
              const pageIndex = temp.pages.findIndex(page => page.pageId === "PageFlexiEdgeUploadDocuments");
              temp.pages[pageIndex].sections = temp.pages[pageIndex].sections.filter(section => section.sectionId !== "salesConfidentialReport");
              if(props?.resumeJourneyData?.journeyData?.sendCaseToCustomerFirstResume === true){
                props.setCurrentPageIndex(2)
                setCurrentSectionIndex(0)
                sendCaseToCustomerFirstResume = false
              }
            }else{
              temp.pages = temp.pages.filter(page => page.pageId !== "PageFlexiEdgeFillProposalForm" && page.pageId !== "makePayment" && page.pageId !== "PageFlexiEdgeUploadDocuments")
              temp.pages.push(...lookup.sendLinktosales)
              if(props?.resumeJourneyData?.journeyData?.productDetails?.premiumFrequency === "SG"){
                temp.pages = temp.pages.filter(page => page.pageId !== "makePayment")
              }
            }
          }else 
          if (props?.resumeJourneyData?.journeyData?.journeyType?.toLowerCase() === "canarapos" && props?.resumeJourneyData?.journeyData?.productDetails?.premiumFrequency === "SG") {
            temp.pages = temp.pages.filter(
              page => page.pageId !== "makePayment"
            )
          }else if (props?.resumeJourneyData?.journeyData?.journeyType?.toLowerCase() === "canarapos") {
            const pageIndex = temp.pages.findIndex(page => page.pageId === "makePayment");
            temp.pages[pageIndex].sections = temp.pages[pageIndex].sections.filter(
              section => section.sectionId === "eNach-physicalMandate"
            )
          } else {
            // Remove SCR section for normal journey
            const pageIndex = temp.pages.findIndex(page => page.pageId === "PageFlexiEdgeUploadDocuments");
            temp.pages[pageIndex].sections = temp.pages[pageIndex].sections.filter(section => section.sectionId !== "salesConfidentialReport");
          }

          if(props?.resumeJourneyData?.applicationData?.journeyData?.skippaymentcase){
            const pageIndex = temp.pages.findIndex(page => page.pageId === "makePayment");
            let makePaymentPageSections = temp.pages[pageIndex].sections;
            makePaymentPageSections = makePaymentPageSections.filter(section => section.sectionId === "eNach-physicalMandate");
            temp.pages[pageIndex].sections = makePaymentPageSections;
          }
          /*Helper Function  For RMJourney Freeze State*/
          const changeJourneySteps = (pageId, sectionId, componentGroup, componentFormControlKey, key, value) => {
            try {
              let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
              let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
              let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentGroup)
              let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === componentFormControlKey)
              console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "======>ImpTemp0")
              temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange][key] = value
            } catch (err) {
              console.log(err, "=====>ErrorInPage.js===Line-152")
            }
          }
          let fillProposalPageId
          let firstPageId
          let sectionId
          if (journeyState.journeyIdFromStrapi === "iSelectJourney") {
            fillProposalPageId = "fillProposalForm"
            firstPageId = "calculatePremiumPage"
          } else if (journeyState.journeyIdFromStrapi === "ISelect360Journey") {
            fillProposalPageId = "pageISelect360FillProposalForm"
            firstPageId = "PageISelect360CalculatePremium"
            sectionId = "CPPersonalDetailsSection"
          }
          else if (journeyState.journeyIdFromStrapi === "FlexiEdgeJourney") {
            fillProposalPageId = "PageFlexiEdgeFillProposalForm"
            firstPageId = "PageFlexiEdgeCalculatePremium"
            sectionId = "SectionFlexiEdgeCalculatePremiumPersonalDetails"
          } else if (journeyState.journeyIdFromStrapi === "titaniumPlusJourney") {
            fillProposalPageId = "PageFlexiEdgeFillProposalForm"
            firstPageId = "PageTitaniumPlusCalculateFundValue"
            sectionId = "CFSectionTitaniumPersonelDetails"
          } else if (journeyState.journeyIdFromStrapi === "alphaWealthPlanJourney") {
            fillProposalPageId = "PageFlexiEdgeFillProposalForm"
            firstPageId = "AlphaWealthPlanCalculateFundValuePage"
            sectionId = "AlphaWealthPlanCFpersonelDetailsSection"
          } else if (journeyState.journeyIdFromStrapi === "guaranteedSavingsOption") {
            fillProposalPageId = "PageFlexiEdgeFillProposalForm"
            firstPageId = "PageGuaranteedSavingsCalculatePremium"
            sectionId = "SectionGuaranteedSavingsPersonelDetails"
          } else if (journeyState.journeyIdFromStrapi === "guaranteedIncomeAdvantage") {
            fillProposalPageId = "PageFlexiEdgeFillProposalForm"
            firstPageId = "PageGuaranteedIncomeAdvantageCalculatePremium"
            sectionId = "SectionGuaranteedIncomeAdvantagePersonelDetails"
          } else if (journeyState.journeyIdFromStrapi === "insureSmart") {
            fillProposalPageId = "PageFlexiEdgeFillProposalForm"
            firstPageId = "PageInsureSmartCalculateFundValue"
            sectionId = "SectionInsureSmartPersonelDetails"
          } else if (journeyState.journeyIdFromStrapi === "GuarateedOnePayJourney") {
            fillProposalPageId = "PageFlexiEdgeFillProposalForm"
            firstPageId = "PageGuaranteedOnePayCalculatePremium"
            sectionId = "SectionGOPAPersonelDetails"
          } else if (journeyState.journeyIdFromStrapi === "jeevanNivesh") {
            fillProposalPageId = "PageFlexiEdgeFillProposalForm"
            firstPageId = "PageJeevenNiveshCalculatePremium"
            sectionId = "SectionJeevanNiveshCalculatePremiumPersonalDetails"
          } else if (journeyState.journeyIdFromStrapi === "moneyBackAdvantage") {
            fillProposalPageId = "PageFlexiEdgeFillProposalForm"
            firstPageId = "PageMoneyBackCalculatePremium"
            sectionId = "SectionMoneyBackPersonalDetails"
          } else if (journeyState.journeyIdFromStrapi === "invest4GJourney") {
            fillProposalPageId = "PageFlexiEdgeFillProposalForm"
            firstPageId = "PageInvest4GCalculateFundValue"
            sectionId = "SectionInvest4GPersonelDetails"
          }
          else if (journeyState.journeyIdFromStrapi === "smartJuniorPlan") {
            fillProposalPageId = "PageFlexiEdgeFillProposalForm"
            firstPageId = "PageSmartJuniorCalculatePremium"
            sectionId = "SectionSmartJuniorPersonelDetails"
          } else if (journeyState.journeyIdFromStrapi === "secureBhavishyaJourney") {
            fillProposalPageId = "PageFlexiEdgeFillProposalForm"
            firstPageId = "PageSecureBhavishyaCalculatePremium"
            sectionId = "SectionSecureBhavishyaPersonelDetails"
          } else if (journeyState.journeyIdFromStrapi === "guaranteedFortuneJourney") {
            fillProposalPageId = "PageFlexiEdgeFillProposalForm"
            firstPageId = "PageGuaranteedFortuneCalculatePremium"
            sectionId = "SectionGuaranteedFortunePersonelDetails"
          } else if (journeyState.journeyIdFromStrapi === "guaranteedFutureJourney") {
            fillProposalPageId = "PageFlexiEdgeFillProposalForm"
            firstPageId = "PageGuaranteedFutureCalculatePremium"
            sectionId = "SectionGuaranteedFuturePersonelDetails"
          } else if (journeyState.journeyIdFromStrapi === "guaranteedIncome4LifeJourney") {
            fillProposalPageId = "PageFlexiEdgeFillProposalForm"
            firstPageId = "PageGuaranteedIncome4LifeCalculatePremium"
            sectionId = "SectionGuaranteedIncome4LifePersonelDetails"
          } else if (journeyState.journeyIdFromStrapi === "GAINjourney") {
            fillProposalPageId = "PageFlexiEdgeFillProposalForm"
            firstPageId = "GAINcalculatePremiumPage"
            sectionId = "GAINpersonalDetailsSection"
          }
          if (props?.resumeJourneyData?.applicationData?.journeyData?.agentDetails?.rmLedJourneyInd === "01") {
            changeJourneySteps(firstPageId, "CPPersonalDetailsSection", "contactNo", "contactCountryCode", "disabled", true)

            if (journeyState.journeyIdFromStrapi === "iSelectJourney") {
              changeJourneySteps(firstPageId, "CPResidentAndOccupationDetailSection", "CPResidentAndOccupationDetail", "country", "disabled", true)
              changeJourneySteps(firstPageId, "CPResidentAndOccupationDetailSection", "CPResidentAndOccupationDetail", "state", "lookupKey", "state_RM")
            } else if (journeyState.journeyIdFromStrapi === "ISelect360Journey") {
              changeJourneySteps(firstPageId, "iSelect360CPResidentAndOccupationDetailSection", "iSelect360CPResidentAndOccupationDetail", "country", "disabled", true)
              changeJourneySteps(firstPageId, "iSelect360CPResidentAndOccupationDetailSection", "iSelect360CPResidentAndOccupationDetail", "state", "lookupKey", "state_RM")
              changeJourneySteps(firstPageId, "iSelect360CPResidentAndOccupationDetailSection", "iSelect360CPResidentAndOccupationDetail", "residentStatus", "disabled", true)
              // For Spouse
              changeJourneySteps(fillProposalPageId, "spouseQuestionnaire", "spouseMobile-No-order-5", "countryCode", "disabled", true)
              changeJourneySteps(fillProposalPageId, "spouseQuestionnaire", "residenceCountry-order-17", "reisdentialCountry", "disabled", true)
              changeJourneySteps(fillProposalPageId, "spouseQuestionnaire", "residentStatus-order-18", "residentStatus", "disabled", true)
              changeJourneySteps(fillProposalPageId, "spouseQuestionnaire", "nationality-order-19", "residentialNationality", "disabled", true)
              changeJourneySteps(fillProposalPageId, "spouseQuestionnaire", "countryOfBirth-order-20", "residentialCountryOfBirth", "disabled", true)
            }
            else if (journeyState.journeyIdFromStrapi === "FlexiEdgeJourney") {
              changeJourneySteps(fillProposalPageId, "SectionFlexiEdgeFillProposalPersonalDetail", "currentCountryofResidence", "currentCountryofResidence", "disabled", true)
              changeJourneySteps(fillProposalPageId, "SectionFlexiEdgeFillProposalPersonalDetail", "currentState", "state", "lookupKey", "state_RM")
              changeJourneySteps(fillProposalPageId, "SectionFlexiEdgeFillProposalPersonalDetail", "residentialStatus", "residentialStatus", "disabled", true)
              changeJourneySteps(fillProposalPageId, "SectionFlexiEdgeFillProposalPersonalDetail", "citizenship", "citizenship", "disabled", true)
              changeJourneySteps(fillProposalPageId, "SectionFlexiEdgeFillProposalPersonalDetail", "nationality", "nationality", "disabled", true)
              changeJourneySteps(fillProposalPageId, "SectionFlexiEdgeFillProposalPersonalDetail", "taxResidenceCountry", "taxResidenceCountry", "disabled", true)
              changeJourneySteps(fillProposalPageId, "SectionFlexiEdgeFillProposalPersonalDetail", "countryOfBirth", "countryOfBirth", "disabled", true)

            }

            changeJourneySteps(fillProposalPageId, "personalDetailsSection", "alternateMobileNo", "AlternateMobCountryCode", "disabled", true)

            changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentStatus", "disabled", true)
            changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialCountryOfBirth", "disabled", true)
            changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialCitizenship", "disabled", true)
            changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialNationality", "disabled", true)
            changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialTaxResidentialCountry", "disabled", true)

            changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "permanentResidentialDetails", "PRCountry", "disabled", true)
            changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "permanentResidentialDetails", "PRState", "lookupKey", "state_RM")
          }
          // changeJourneySteps("PageFlexiEdgeCalculatePremium", "SectionFlexiEdgeCalculatePremiumPersonalDetails", "privacypolicy-MD-12-order-21", "privacyPolicy", "display", false)
          // changeJourneySteps(firstPageId, "CPPersonalDetailsSection", "privacypolicy-MD-12-order-25", "privacyPolicy", "display", false)
          // console.log(props?.resumeJourneyData?.journeyData?.lastSection === 0 && props?.resumeJourneyData?.journeyData?.lastPage === 0 && props?.resumeJourneyData?.journeyData?.lastPage === 0 && props?.resumeJourneyData?.journeyData?.basicDetails?.applicationNumber);
          if (props?.resumeJourneyData?.journeyData?.lastSection === 0 && props?.resumeJourneyData?.journeyData?.lastPage === 0 && props?.resumeJourneyData?.journeyData?.lastPage === 0 && props?.resumeJourneyData?.journeyData?.basicDetails?.applicationNumber) {
            changeJourneySteps(firstPageId, sectionId, "privacypolicy-MD-12-order-21", "privacyPolicy", "display", true)
          } else {
            changeJourneySteps(firstPageId, sectionId, "privacypolicy-MD-12-order-21", "privacyPolicy", "display", false)
          }
          let paymentDecryptData = {
            ...props?.resumeJourneyData?.applicationData?.journeyData?.transactionDetails?.transactions[props?.resumeJourneyData?.applicationData?.journeyData?.transactionDetails?.transactions?.length - 1]
          }
          console.log(paymentDecryptData, "fdgijgigfggh")
          setJourneyState(prev => {
            // console.log("journey state")
            return {
              ...prev,
              journeyId: props?.resumeJourneyData?.journeyData?._id,
              applicationNo:
                props?.resumeJourneyData?.journeyData?.basicDetails
                  ?.applicationNumber,
              illustrationNumber:
                props?.resumeJourneyData?.journeyData?.basicDetails
                  ?.illustrationNumber,
              proposalEntryId:
                props?.resumeJourneyData?.journeyData?.basicDetails?.proposalEntryId,
              journeyData:
                props?.resumeJourneyData?.applicationData?.applicationData,
              premium: props?.resumeJourneyData?.applicationData?.journeyData?.premium,
              paymentDecryptData: paymentDecryptData,
              proposalFormLink: props?.resumeJourneyData?.applicationData?.journeyData?.proposalFormLink,
              paymentStep: props?.resumeJourneyData?.applicationData?.journeyData?.paymentStep,
              journeySteps: temp,
              residenceDetailEmailTrigger: props?.resumeJourneyData?.applicationData?.journeyData?.residenceDetailEmailTrigger === "true" ? true : false,
              channel: props?.resumeJourneyData?.applicationData?.journeyData?.basicDetails?.channel,
              paymentFrequency: props?.resumeJourneyData?.journeyData?.paymentFrequency ? props?.resumeJourneyData?.journeyData?.paymentFrequency : journeyState?.paymentFrequency,
              gstWaiverInd: props?.resumeJourneyData?.applicationData?.journeyData?.productDetails?.gstWaiverInd ?? "N",
              // channel: getKeyFromValueLookup("reverseChannelType", props?.resumeJourneyData?.applicationData?.journeyData?.basicDetails?.channel)?.toLowerCase()
              sendCaseToCustomerFirstResume: sendCaseToCustomerFirstResume
            }
          })
          if (!(props.resumeJourneyData.journeyData.lastPage === 0 && props.resumeJourneyData.journeyData.lastSection === 0)) {
            if (callBi === false) {
              setCallBi(true)
            }
          }
          console.log(props.resumeJourneyData, "fffdf")
          setConditionState({
            ...props?.resumeJourneyData?.applicationData?.conditionData
          })
        }
        let foundPageState = props.resumeJourneyData.applicationData.applicationData.filter(
          element =>
            element.pageId ===
            props.pages[props.resumeJourneyData.journeyData.lastPage].pageId
        )
        // console.log(foundPageState, "found page")
        // console.log(foundPageState[0].pageId, pageState, "page check")
        if (foundPageState[0] && foundPageState[0].pageId !== pageState.pageId) {
          setPageState(prev => {
            // console.log("page state")
            return {
              ...prev,
              pageId: foundPageState[0].pageId,
              pageData: foundPageState[0].pageData,
            }
          })
        }
        // setSectionState({
        //   sectionId: null,
        //   sectionData: {},
        // })
        let eligibleSections = props.pages[props.resumeJourneyData.journeyData.lastPage].sections?.filter(element => {
          if (element.conditions.length === 1) {
            if (componentRenderCheck(element.conditions[0], props?.resumeJourneyData?.applicationData?.conditionData[element.conditions[0].watchKey], journeyState)) {
              return element
            }
          } else if (element.conditions.length > 1) {
            if (multiConditionComponentRenderCheck(element.conditions, props?.resumeJourneyData?.applicationData?.conditionData, journeyState)) {
              return element
            }
          } else {
            return element
          }
        })
        console.log("dsjhfhfd=========>", eligibleSections[
          props.resumeJourneyData.journeyData.lastSection
        ].sectionId)
        let foundSectionState = foundPageState[0]?.pageData.filter(element => {
          if (
            element.sectionId === eligibleSections[props.resumeJourneyData.journeyData.lastSection].sectionId
          ) {
            return element
          }
        })
        // console.log(foundSectionState, "found section")

        if (
          foundSectionState && foundPageState[0] &&
          foundSectionState[0]?.sectionId !== sectionState.sectionId
        ) {
          setSectionState(prev => {
            // console.log("section state")
            return {
              ...prev,
              sectionId: foundSectionState[0]?.sectionId,
              sectionFirstPass: true,
              sectionData: foundSectionState[0]?.sectionData,
            }
          })
        }
        if (!(props.resumeJourneyData.journeyData.lastPage === 0 && props.resumeJourneyData.journeyData.lastSection === 0)) {
          props.setShowFirstSectionFields(true)
        }
        setFirstPageAutoFillApiCall(true)
      }
      if (paymentStatus === 'Pending' || paymentStatus === 'Aborted') {
        checkPaymentStatus(srcTraceId).then((res_str) => {
          const payload = {
            "encryptedtext": res_str
          }
          try {
            if(paymentStatus === "Aborted" && !res_str){
              resumeJourneyCall(paymentStatus)
              return
            }
            paymentTextDecrypt(payload).then(res => {
              console.log(res, "paymentTextDecrypt")
              const newPaymentStatus = res.data.status || paymentStatus
              let newTransactionToBeSaved = lastTransaction.transactions[lastTransaction.transactions?.length - 1]
              newTransactionToBeSaved.status = newPaymentStatus;
              let payloadForSaveTransaction = {
                journeyId: props.resumeJourneyData.journeyData._id,
                ...newTransactionToBeSaved
              }
              console.log(payloadForSaveTransaction, "payloadForSaveTransaction")
              saveTransactionDetails(payloadForSaveTransaction).then((res) => {
                console.log(res, "saveTransactionDetails")
                resumeJourneyCall(newPaymentStatus)
              })
            })
          } catch (err) {
            console.log("error in fields", err)
            resumeJourneyCall(paymentStatus)
          }

        }).catch((err) => {
          console.log("abortedTransactionWith-NoPayment-RedirectToPaymentPage", props.resumeJourneyData.journeyData)
          resumeJourneyCall(paymentStatus);
        })
      } else {
        resumeJourneyCall(paymentStatus);
      }
    }
  }, [props.resumeJourneyData])

  useEffect(() => {
    if(props?.hsbcBankData && props.hsbcBankData?.hsbcId){
      let data = props?.hsbcBankData
      let pageId = journeyState?.journeySteps?.pages?.[0]?.pageId
      let sectionId = journeyState?.journeySteps?.pages?.[0]?.sections?.[0]?.sectionId
      let thirdPageId = journeyState?.journeySteps?.pages?.[2]?.pageId
      let thirdSectionId = journeyState?.journeySteps?.pages?.[2]?.sections?.[0]?.sectionId
      if(!data){
        return
      }
      let fullname = fullNameConverter(data?.firstName, data?.middleName, data?.lastName)
      console.log(data);
      setJourneyState(prev => {
        return({
          ...prev,
          channel: "A",
          journeyType: "HSBC", 
          hsbcJourneyID: props.hsbcBankData?.hsbcId,
          hsbcCustomerNumber: props.hsbcBankData?.hsbcCustomerNumber,
        })
      })
      // setErrorState({})
      console.log(props);
      let temp = journeyState.journeySteps
        if(journeyState.journeyIdFromStrapi === "FlexiEdgeJourney" || journeyState.journeyIdFromStrapi === "titaniumPlusJourney" || journeyState.journeyIdFromStrapi === "alphaWealthPlanJourney" || journeyState.journeyIdFromStrapi === "guaranteedFutureJourney"){
          setSectionState(prev => {
            return {
              ...prev,
              sectionData: {
                ...prev.sectionData,
                "CPPersonalDetailName": fullname,
                "email": data?.email,
                "contactNo": data?.phone,
                "mobileNumber": data?.countryCode,
                "dateOfBirth": data?.dateOfBirth,
                "gender": data.gender,
                "laTitle": data?.title,
                "taxResidenceCountry1": data?.taxResidenceCountry1,
                "taxResidenceCountry2": data?.taxResidenceCountry2,
                "taxResidenceCountry3": data?.taxResidenceCountry3,
                "pan": data?.pan,
                "mobileNumber": data?.phoneCountryCode,
                "pincode": data?.pincode,
                "GOPApincode": data?.pincode
              }
            }
          })
          setConditionState(prev => {
            return {
              ...prev,
              [`${pageId}.${sectionId}.CPPersonalDetailName`]: fullname,
              [`${pageId}.${sectionId}.email`]: data?.email,
              [`${pageId}.${sectionId}.contactNo`]: data?.phone,
              [`${pageId}.${sectionId}.mobileNumber`]: data?.phoneCountryCode,
              [`${pageId}.${sectionId}.dateOfBirth`]: data?.dateOfBirth,
              [`${pageId}.${sectionId}.gender`]: data.gender,
              [`${pageId}.${sectionId}.laTitle`]: data?.title,
              [`${pageId}.${sectionId}.pincode`]: data?.pincode,
              [`${pageId}.${sectionId}.GOPApincode`]: data?.pincode,
              [`${thirdPageId}.${thirdSectionId}.taxResidenceCountry1`]: data?.taxResidenceCountry1,
              [`${thirdPageId}.${thirdSectionId}.taxResidenceCountry2`]: data?.taxResidenceCountry2,
              [`${thirdPageId}.${thirdSectionId}.taxResidenceCountry3`]: data?.taxResidenceCountry3,
              [`${thirdPageId}.${thirdSectionId}.pan`]: data?.pan
            }
          })
          let componentNameFreeze = temp.pages[0].sections[0].component_groups.findIndex(element => element.componentId === "CPPersonalDetailName")
          let componentEmailFreeze = temp.pages[0].sections[0].component_groups.findIndex(element => element.componentId === "email")
          let componentNumberFreeze = temp.pages[0].sections[0].component_groups.findIndex(element => element.componentId === "contactNo")
          temp.pages[0].sections[0].component_groups[componentNameFreeze].components[0]["disabled"] = true
          temp.pages[0].sections[0].component_groups[componentEmailFreeze].components[0]["disabled"] = true
          // temp.pages[0].sections[0].component_groups[componentNumberFreeze].components[1]["disabled"] = true
        } else{
          setSectionState(prev => {
            return {
              ...prev,
              sectionData: {
                ...prev.sectionData,
                "CPPersonalDetailName": fullname,
                "email": data?.email,
                "contactNo": data?.phone,
                "mobileNumber": data?.countryCode,
                "GOPAdob": data?.dateOfBirth,
                "GOPAgender": data?.gender
              }
            }
          })
          setConditionState(prev => {
            return {
              ...prev,
              [`${pageId}.${sectionId}.GOPAgender`]: data?.gender,
              [`${pageId}.${sectionId}.CPPersonalDetailName`]: fullname,
              [`${pageId}.${sectionId}.email`]: data?.email,
              [`${pageId}.${sectionId}.contactNo`]: data?.phone,
              [`${pageId}.${sectionId}.mobileNumber`]: data?.countryCode,
              [`${pageId}.${sectionId}.GOPAdob`]: data?.dateOfBirth
            }
          })
          let componentNameFreeze = temp?.pages[0]?.sections[0]?.component_groups?.findIndex(element => element.componentId === "CPPersonalDetailName")
          let componentEmailFreeze = temp?.pages[0]?.sections[0]?.component_groups?.findIndex(element => element.componentId === "email")
          let componentNumberFreeze = temp?.pages[0]?.sections[0]?.component_groups?.findIndex(element => element.componentId === "contactNo")
          temp.pages[0].sections[0].component_groups[componentNameFreeze].components[0]["disabled"] = true
          temp.pages[0].sections[0].component_groups[componentEmailFreeze].components[0]["disabled"] = true
          // temp.pages[0].sections[0].component_groups[componentNumberFreeze].components[1]["disabled"] = true
        }
      let tempName = journeyState.journeySteps
      let componentNameFreezetempName = tempName.pages[0].sections[0].component_groups.findIndex(element => element.componentId === "CPPersonalDetailName")
      let nameComponent = tempName.pages[0].sections[0].component_groups[componentNameFreezetempName].components.findIndex(el => el.formControlKey === "CPPersonalDetailName")
      tempName.pages[0].sections[0].component_groups[componentNameFreezetempName].components[nameComponent]["regex"] = "/^[a-zA-Z .']*$/"
      setJourneyState(prev => {
        return ({
          ...prev,
          journeySteps: tempName
        })
      })
    }
  },[props.hsbcBankData])

  //code for redirection from fna page
  useEffect(() => {
    console.log("Helloo");
    console.log(sectionState);
    console.log(journeyState);
    let pageId = journeyState?.journeySteps?.pages?.[0]?.pageId
    let sectionId = journeyState?.journeySteps?.pages?.[0]?.sections?.[0]?.sectionId
    if(props.fnaData){
      let fnaData = props?.fnaData?.fnaData?.fnaData?.fnaDetails
      let fullname = fullNameConverter(fnaData?.firstName, fnaData?.middleName, fnaData?.lastName)
      let a = lookup?.fnaGender?.[0][fnaData.title]
      setJourneyState(prev => {
        return({
          ...prev,
          channel: "A", //By-default channel is A (HSBC) in future we have to make it dynamic
          journeyType: "HSBC", 
          hsbcJourneyID: props?.fnaData?.fnaData?.hsbcJourneyID,
          hsbcCustomerNumber: props?.fnaData?.fnaData?.fnaData?.fnaDetails?.hsbc_data?.hsbcCustomerNumber,
          fnaData : {
            PROPOSERFULLNAME: fullname,
            BIRTHDATE: (moment.unix(fnaData?.birthDate).utcOffset("+05:30").format("YYYY-MM-DD")) ,
            PHONENUMBER: fnaData?.phoneNumber ,
            EMAILID: fnaData?.emailId ,
            ANNUALINCOME: fnaData?.annualIncome ,
            ANNUALEXPENSES: fnaData?.annualExpenses ,
            ANNUALDISPOSABLRINCOME: fnaData?.annualDisposableIncome ,
            EXISTINGLIFECOVER: fnaData?.existingLifecover ,
            LIFECOVERREQUIRED: fnaData?.lifeCoverRequired ,
            GOALTOACHIEVE: fnaData?.goalToAchieve ,
            TIMEHORIZON: fnaData?.timeHorizon ,
            CAPITALPROTECTION: fnaData?.capitalProtection ,
            PREFERREDPLAN: fnaData?.preferredPlan
          }
        })
      })
      setErrorState({})
      if(journeyState.journeyIdFromStrapi === "guaranteedSavingsOption" || journeyState.journeyIdFromStrapi === "guaranteedIncomeAdvantage" 
      || journeyState.journeyIdFromStrapi === "insureSmart" || journeyState.journeyIdFromStrapi === "guaranteedFutureJourney" 
      || journeyState.journeyIdFromStrapi === "GuarateedOnePayJourney" || journeyState.journeyIdFromStrapi === "GAINjourney"){
        setSectionState(prev => {
          return {
            ...prev,
            sectionFirstPass: true,
            sectionData: {
              ...prev.sectionData,
              "CPPersonalDetailName": fullname,
              "email": fnaData.emailId,
              "contactNo": fnaData.phoneNumber,
              "mobileNumber": fnaData.countryCode,
              "GOPAannualIncome": fnaData.annualIncome,
              "GOPAdob": fnaData.birthDate,
              "GOPAgender": lookup?.fnaGender?.[0][fnaData.title]
            }
          }
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${pageId}.${sectionId}.GOPAgender`]: lookup?.fnaGender?.[0][fnaData.title],
            [`${pageId}.${sectionId}.CPPersonalDetailName`]: fullname,
            [`${pageId}.${sectionId}.email`]: fnaData?.emailId,
            [`${pageId}.${sectionId}.contactNo`]: fnaData?.phoneNumber,
            [`${pageId}.${sectionId}.mobileNumber`]: fnaData?.countryCode,
            [`${pageId}.${sectionId}.GOPAannualIncome`]: fnaData?.annualIncome,
            [`${pageId}.${sectionId}.GOPAdob`]: fnaData?.birthDate
          }
        })
      }else if(journeyState.journeyIdFromStrapi === "pension4LifeJourney"){
        setSectionState(prev => {
          return {
            ...prev,
            sectionFirstPass: true,
            sectionData: {
              ...prev.sectionData,
              "namePension4life": fullname,
              "emailPension4life": fnaData.emailId,
              "contactNoPension4life": fnaData.phoneNumber,
              "CountryCodesPension4life": fnaData.countryCode,
              // "GOPAannualIncome": fnaData.annualIncome,
              "DOBPension4life": fnaData.birthDate,
              "genderPension4life": lookup?.fnaGender?.[0][fnaData.title]
            }
          }
        })
      }else if(journeyState.journeyIdFromStrapi === "titaniumPlusJourney" || journeyState.journeyIdFromStrapi === "alphaWealthPlanJourney" || journeyState.journeyIdFromStrapi === "FlexiEdgeJourney"){
        setSectionState(prev => {
          return {
            ...prev,
            sectionFirstPass: true,
            sectionData: {
              ...prev.sectionData,
              "CPPersonalDetailName": fullname,
              "email": fnaData.emailId,
              "contactNo": fnaData.phoneNumber,
              "mobileNumber": fnaData.countryCode,
              "annualIncome": fnaData.annualIncome,
              "dateOfBirth": fnaData.birthDate,
              "gender": lookup?.fnaGender?.[0][fnaData.title]
            }
          }
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${pageId}.${sectionId}.gender`]: lookup?.fnaGender?.[0][fnaData.title],
            [`${pageId}.${sectionId}.CPPersonalDetailName`]: fullname,
            [`${pageId}.${sectionId}.email`]: fnaData?.emailId,
            [`${pageId}.${sectionId}.contactNo`]: fnaData?.phoneNumber,
            [`${pageId}.${sectionId}.mobileNumber`]: fnaData?.countryCode,
            [`${pageId}.${sectionId}.annualIncome`]: fnaData?.annualIncome,
            [`${pageId}.${sectionId}.dateOfBirth`]: fnaData?.birthDate
          }
        })
      }
    }
  },[props.fnaData])

  //code for redirection from canara pos to fna 
  useEffect(() => {
    let data = props?.canaraPosData?.canaraPosData[0]?.fnaData?.fnaDetails
    let pageId = journeyState?.journeySteps?.pages?.[0]?.pageId
    let sectionId = journeyState?.journeySteps?.pages?.[0]?.sections?.[0]?.sectionId
    if(!data){
      return
    }
    let fullname = fullNameConverter(data?.firstName, data?.middleName, data?.lastName)
    console.log(data);
    setJourneyState(prev => {
      return({
        ...prev,
        channel: "C", //By-default channel is C (CANARA) in future we have to make it dynamic,
        journeyType: "CanaraPos",
        fnaData : {
          PROPOSERFULLNAME: fullname,
          BIRTHDATE: (moment.unix(data?.birthDate).utcOffset("+05:30").format("YYYY-MM-DD")) ,
          PHONENUMBER: data?.phoneNumber ,
          EMAILID: data?.emailId ,
          ANNUALINCOME: data?.annualIncome ,
          ANNUALEXPENSES: data?.annualExpenses ,
          ANNUALDISPOSABLRINCOME: data?.annualDisposableIncome ,
          EXISTINGLIFECOVER: data?.existingLifecover ,
          LIFECOVERREQUIRED: data?.lifeCoverRequired ,
          GOALTOACHIEVE: data?.goalToAchieve ,
          TIMEHORIZON: data?.timeHorizon ,
          CAPITALPROTECTION: data?.capitalProtection ,
          PREFERREDPLAN: data?.preferredPlan
        }
      })
    })
    // setErrorState({})
    console.log(props);
    let temp = journeyState.journeySteps
    if(data?.buyingFor === "self") {
      if(journeyState.journeyIdFromStrapi === "guaranteedSavingsOption" || journeyState.journeyIdFromStrapi === "guaranteedIncomeAdvantage" 
      || journeyState.journeyIdFromStrapi === "insureSmart" || journeyState.journeyIdFromStrapi === "guaranteedFutureJourney" 
      || journeyState.journeyIdFromStrapi === "GuarateedOnePayJourney" || journeyState.journeyIdFromStrapi === "jeevanNivesh" 
      || journeyState.journeyIdFromStrapi === "guaranteedFortuneJourney" || journeyState.journeyIdFromStrapi === "moneyBackAdvantage"
      || journeyState.journeyIdFromStrapi === "invest4GJourney" || journeyState.journeyIdFromStrapi === "healthFirstJourney"
      || journeyState.journeyIdFromStrapi === "guaranteedIncome4LifeJourney" || journeyState.journeyIdFromStrapi === "secureBhavishyaJourney"){
        setSectionState(prev => {
          return {
            ...prev,
            sectionFirstPass: true,
            sectionData: {
              ...prev.sectionData,
              "CPPersonalDetailName": fullname,
              "email": data?.emailId,
              "contactNo": data?.phoneNumber,
              "mobileNumber": data?.countryCode,
              "GOPAannualIncome": data?.annualIncome,
              "GOPAdob": data?.birthDate,
              "GOPAgender": lookup?.fnaGender?.[0][data.title]
            }
          }
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${pageId}.${sectionId}.GOPAgender`]: lookup?.fnaGender?.[0][data.title],
            [`${pageId}.${sectionId}.CPPersonalDetailName`]: fullname,
            [`${pageId}.${sectionId}.email`]: data?.emailId,
            [`${pageId}.${sectionId}.contactNo`]: data?.phoneNumber,
            [`${pageId}.${sectionId}.mobileNumber`]: data?.countryCode,
            [`${pageId}.${sectionId}.GOPAannualIncome`]: data?.annualIncome,
            [`${pageId}.${sectionId}.GOPAdob`]: data?.birthDate
          }
        })
        let componentNameFreeze = temp?.pages[0]?.sections[0]?.component_groups?.findIndex(element => element.componentId === "CPPersonalDetailName")
        let componentEmailFreeze = temp?.pages[0]?.sections[0]?.component_groups?.findIndex(element => element.componentId === "email")
        let componentNumberFreeze = temp?.pages[0]?.sections[0]?.component_groups?.findIndex(element => element.componentId === "contactNo")
        let componentIsLifeTiBeAssuredFreeze = temp?.pages[0]?.sections[0]?.component_groups?.findIndex(element => element.componentId === "GOPAslifetobeAssuredandProposer")
        temp.pages[0].sections[0].component_groups[componentNameFreeze].components[0]["disabled"] = true
        temp.pages[0].sections[0].component_groups[componentEmailFreeze].components[0]["disabled"] = true
        temp.pages[0].sections[0].component_groups[componentNumberFreeze].components[1]["disabled"] = true
        temp.pages[0].sections[0].component_groups[componentIsLifeTiBeAssuredFreeze].components[0]["disabled"] = true
      }else if(journeyState.journeyIdFromStrapi === "smartJuniorPlan"){
        setSectionState(prev => {
          return {
            ...prev,
            sectionFirstPass: true,
            sectionData: {
              ...prev.sectionData,
              "CPPersonalDetailName": fullname,
              "email": data?.emailId,
              "contactNo": data?.phoneNumber,
              "mobileNumber": data?.countryCode,
              "GOPAannualIncome": data?.annualIncome,
              "GOPAdob": data?.birthDate,
              "GOPAgender": lookup?.fnaGender?.[0][data.title]
            }
          }
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${pageId}.${sectionId}.GOPAgender`]: lookup?.fnaGender?.[0][data.title],
            [`${pageId}.${sectionId}.CPPersonalDetailName`]: fullname,
            [`${pageId}.${sectionId}.email`]: data?.emailId,
            [`${pageId}.${sectionId}.contactNo`]: data?.phoneNumber,
            [`${pageId}.${sectionId}.mobileNumber`]: data?.countryCode,
            [`${pageId}.${sectionId}.GOPAannualIncome`]: data?.annualIncome,
            [`${pageId}.${sectionId}.GOPAdob`]: data?.birthDate
          }
        })
        let componentNameFreeze = temp?.pages[0]?.sections[0]?.component_groups?.findIndex(element => element.componentId === "CPPersonalDetailName")
        let componentEmailFreeze = temp?.pages[0]?.sections[0]?.component_groups?.findIndex(element => element.componentId === "email")
        let componentNumberFreeze = temp?.pages[0]?.sections[0]?.component_groups?.findIndex(element => element.componentId === "contactNo")
        temp.pages[0].sections[0].component_groups[componentNameFreeze].components[0]["disabled"] = true
        temp.pages[0].sections[0].component_groups[componentEmailFreeze].components[0]["disabled"] = true
        temp.pages[0].sections[0].component_groups[componentNumberFreeze].components[1]["disabled"] = true
      }else if(journeyState.journeyIdFromStrapi === "pension4LifeJourney"){
        setSectionState(prev => {
          return {
            ...prev,
            sectionFirstPass: true,
            sectionData: {
              ...prev.sectionData,
              "namePension4life": fullname,
              "emailPension4life": data?.emailId,
              "contactNoPension4life": data?.phoneNumber,
              "CountryCodesPension4life": data?.countryCode,
              // "GOPAannualIncome": data?.annualIncome,
              "DOBPension4life": data?.birthDate
            }
          }
        })
        let componentNameFreeze = temp?.pages[0]?.sections[0]?.component_groups?.findIndex(element => element.componentId === "namePension4life")
        let componentEmailFreeze = temp?.pages[0]?.sections[0]?.component_groups?.findIndex(element => element.componentId === "emailPension4life")
        let componentNumberFreeze = temp?.pages[0]?.sections[0]?.component_groups?.findIndex(element => element.componentId === "contactNoPension4life")
        temp.pages[0].sections[0].component_groups[componentNameFreeze].components[0]["disabled"] = true
        temp.pages[0].sections[0].component_groups[componentEmailFreeze].components[0]["disabled"] = true
        temp.pages[0].sections[0].component_groups[componentNumberFreeze].components[1]["disabled"] = true
      }else if(journeyState.journeyIdFromStrapi === "FlexiEdgeJourney"){
        setSectionState(prev => {
          return {
            ...prev,
            sectionFirstPass: true,
            sectionData: {
            ...prev.sectionData,
            "CPPersonalDetailName": fullname,
            "email": data?.emailId,
            "contactNo": data?.phoneNumber,
            "mobileNumber": data?.countryCode,
            "annualIncome": data?.annualIncome,
            "dateOfBirth": data?.birthDate,
            "gender": lookup?.fnaGender?.[0][data.title]
            }
          }
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${pageId}.${sectionId}.gender`]: lookup?.fnaGender?.[0][data.title],
            [`${pageId}.${sectionId}.CPPersonalDetailName`]: fullname,
            [`${pageId}.${sectionId}.email`]: data?.emailId,
            [`${pageId}.${sectionId}.contactNo`]: data?.phoneNumber,
            [`${pageId}.${sectionId}.mobileNumber`]: data?.countryCode,
            [`${pageId}.${sectionId}.annualIncome`]: data?.annualIncome,
            [`${pageId}.${sectionId}.dateOfBirth`]: data?.birthDate
          }
        })
        let componentNameFreeze = temp?.pages[0]?.sections[0]?.component_groups?.findIndex(element => element.componentId === "CPPersonalDetailName")
        let componentEmailFreeze = temp?.pages[0]?.sections[0]?.component_groups?.findIndex(element => element.componentId === "email")
        let componentNumberFreeze = temp?.pages[0]?.sections[0]?.component_groups?.findIndex(element => element.componentId === "contactNo")
        let componentIsLifeTiBeAssuredFreeze = temp?.pages[0]?.sections[0]?.component_groups?.findIndex(element => element.componentId === "islifetobeAssuredandProposer")
        temp.pages[0].sections[0].component_groups[componentNameFreeze].components[0]["disabled"] = true
        temp.pages[0].sections[0].component_groups[componentEmailFreeze].components[0]["disabled"] = true
        temp.pages[0].sections[0].component_groups[componentNumberFreeze].components[1]["disabled"] = true
        temp.pages[0].sections[0].component_groups[componentIsLifeTiBeAssuredFreeze].components[0]["disabled"] = true
      }
      else if(journeyState.journeyIdFromStrapi === "titaniumPlusJourney" || journeyState.journeyIdFromStrapi === "alphaWealthPlanJourney"){
        setSectionState(prev => {
          return {
            ...prev,
            sectionFirstPass: true,
            sectionData: {
            ...prev.sectionData,
            "CPPersonalDetailName": fullname,
            "email": data?.emailId,
            "contactNo": data?.phoneNumber,
            "mobileNumber": data?.countryCode,
            "annualIncome": data?.annualIncome,
            "dateOfBirth": data?.birthDate,
            "gender": lookup?.fnaGender?.[0][data.title]
            }
          }
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${pageId}.${sectionId}.gender`]: lookup?.fnaGender?.[0][data.title],
            [`${pageId}.${sectionId}.CPPersonalDetailName`]: fullname,
            [`${pageId}.${sectionId}.email`]: data?.emailId,
            [`${pageId}.${sectionId}.contactNo`]: data?.phoneNumber,
            [`${pageId}.${sectionId}.mobileNumber`]: data?.countryCode,
            [`${pageId}.${sectionId}.annualIncome`]: data?.annualIncome,
            [`${pageId}.${sectionId}.dateOfBirth`]: data?.birthDate
          }
        })
        let componentNameFreeze = temp?.pages[0]?.sections[0]?.component_groups?.findIndex(element => element.componentId === "CPPersonalDetailName")
        let componentEmailFreeze = temp?.pages[0]?.sections[0]?.component_groups?.findIndex(element => element.componentId === "email")
        let componentNumberFreeze = temp?.pages[0]?.sections[0]?.component_groups?.findIndex(element => element.componentId === "contactNo")
        let componentIsLifeTiBeAssuredFreeze = temp?.pages[0]?.sections[0]?.component_groups?.findIndex(element => element.componentId === "CFislifetobeAssuredandProposer")
        temp.pages[0].sections[0].component_groups[componentNameFreeze].components[0]["disabled"] = true
        temp.pages[0].sections[0].component_groups[componentEmailFreeze].components[0]["disabled"] = true
        temp.pages[0].sections[0].component_groups[componentNumberFreeze].components[1]["disabled"] = true
        temp.pages[0].sections[0].component_groups[componentIsLifeTiBeAssuredFreeze].components[0]["disabled"] = true
      }
    } else {
      if(journeyState.journeyIdFromStrapi === "guaranteedSavingsOption" || journeyState.journeyIdFromStrapi === "guaranteedIncomeAdvantage" 
      || journeyState.journeyIdFromStrapi === "insureSmart" || journeyState.journeyIdFromStrapi === "guaranteedFutureJourney" 
      || journeyState.journeyIdFromStrapi === "GuarateedOnePayJourney" || journeyState.journeyIdFromStrapi === "jeevanNivesh" 
      || journeyState.journeyIdFromStrapi === "guaranteedFortuneJourney" || journeyState.journeyIdFromStrapi === "moneyBackAdvantage"
      || journeyState.journeyIdFromStrapi === "invest4GJourney" || journeyState.journeyIdFromStrapi === "healthFirstJourney"
      || journeyState.journeyIdFromStrapi === "guaranteedIncome4LifeJourney" || journeyState.journeyIdFromStrapi === "secureBhavishyaJourney"
      || journeyState.journeyIdFromStrapi === "smartJuniorPlan"){
        setSectionState(prev => {
          return {
            ...prev,
            sectionFirstPass: true,
            sectionData: {
              ...prev.sectionData,
              "GOPAslifetobeAssuredandProposer": "N",
              "GOPAProposername": fullname,
              "GOPAproposerEmail": data?.emailId,
              "GOPAnumber": data?.phoneNumber,
              "GOPAproposerCode": data?.countryCode,
              "GOPAproposerAnnualIncome": data?.annualIncome,
              "GOPAproposerDateOfBirth": data?.birthDate,
              "GOPAproposerGender": lookup?.fnaGender?.[0][data.title]
            }
          }
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${pageId}.${sectionId}.GOPAslifetobeAssuredandProposer`]: "N",
            [`${pageId}.${sectionId}.CPProposalDetailName`]: fullname,
            [`${pageId}.${sectionId}.proposerEmail`]: data?.emailId,
            [`${pageId}.${sectionId}.contactNoproposer`]: data?.phoneNumber,
            [`${pageId}.${sectionId}.proposerNumber`]: data?.countryCode,
            [`${pageId}.${sectionId}.proposerannualIncome`]: data?.annualIncome,
            [`${pageId}.${sectionId}.propserdateOfBirth`]: data?.birthDate,
          }
        })
        let componentToBeChange = temp?.pages[0]?.sections[0]?.component_groups?.findIndex(element => element.componentId === "GOPAproposerDetails")
        let componentNameFreeze = temp?.pages[0]?.sections[0]?.component_groups[componentToBeChange]?.components.findIndex(element => element.formControlKey === "GOPAProposername")
        let componentEmailFreeze = temp?.pages[0]?.sections[0]?.component_groups[componentToBeChange]?.components.findIndex(element => element.formControlKey === "GOPAproposerEmail")
        let componentNumberFreeze = temp?.pages[0]?.sections[0]?.component_groups[componentToBeChange]?.components.findIndex(element => element.formControlKey === "GOPAnumber")
        temp.pages[0].sections[0].component_groups[componentToBeChange].components[componentNameFreeze]["disabled"] = true
        temp.pages[0].sections[0].component_groups[componentToBeChange].components[componentEmailFreeze]["disabled"] = true
        temp.pages[0].sections[0].component_groups[componentToBeChange].components[componentNumberFreeze]["disabled"] = true
      } else if(journeyState.journeyIdFromStrapi === "pension4LifeJourney"){
        setSectionState(prev => {
          return {
            ...prev,
            sectionFirstPass: true,
            sectionData: {
              ...prev.sectionData,
              "lifeToBeAssuredPension4LIfe": "N",
              "proposerName": fullname,
              "proposerEmail": data?.emailId,
              "proposerNumber": data?.phoneNumber,
              "proposerCountryCode": data?.countryCode,
              // "GOPAannualIncome": data?.annualIncome,
              "DOBproposer": data?.birthDate
            }
          }
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${pageId}.${sectionId}.lifeToBeAssuredPension4LIfe`]: "N",
            [`${pageId}.${sectionId}.proposerName`]: fullname,
            [`${pageId}.${sectionId}.proposerEmail`]: data?.emailId,
            [`${pageId}.${sectionId}.proposerNumber`]: data?.phoneNumber,
            [`${pageId}.${sectionId}.proposerCountryCode`]: data?.countryCode,
            [`${pageId}.${sectionId}.DOBproposer`]: data?.birthDate,
          }
        })
        let componentToBeChange = temp.pages[0]?.sections[0]?.component_groups?.findIndex(element => element.componentId === "proposerDetailsPesnion4life")
        let componentNameFreeze = temp.pages[0]?.sections[0]?.component_groups[componentToBeChange]?.components.findIndex(element => element.formControlKey === "proposerName")
        let componentEmailFreeze = temp.pages[0]?.sections[0]?.component_groups[componentToBeChange]?.components.findIndex(element => element.formControlKey === "proposerEmail")
        let componentNumberFreeze = temp.pages[0]?.sections[0]?.component_groups[componentToBeChange]?.components.findIndex(element => element.formControlKey === "proposerNumber")
        temp.pages[0].sections[0].component_groups[componentToBeChange].components[componentNameFreeze]["disabled"] = true
        temp.pages[0].sections[0].component_groups[componentToBeChange].components[componentEmailFreeze]["disabled"] = true
        temp.pages[0].sections[0].component_groups[componentToBeChange].components[componentNumberFreeze]["disabled"] = true
      } else if(journeyState.journeyIdFromStrapi === "FlexiEdgeJourney"){
        setSectionState(prev => {
          return {
            ...prev,
            sectionFirstPass: true,
            sectionData: {
            ...prev.sectionData,
            "islifetobeAssuredandProposer": "N",
            "CPProposalDetailName": fullname,
            "proposerEmail": data?.emailId,
            "contactNoproposer": data?.phoneNumber,
            "proposerNumber": data?.countryCode,
            "proposerannualIncome": data?.annualIncome,
            "propserdateOfBirth": data?.birthDate,
            "proposergender": lookup?.fnaGender?.[0][data.title]
            }
          }
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${pageId}.${sectionId}.islifetobeAssuredandProposer`]: "N",
            [`${pageId}.${sectionId}.CPProposalDetailName`]: fullname,
            [`${pageId}.${sectionId}.proposerEmail`]: data?.emailId,
            [`${pageId}.${sectionId}.contactNoproposer`]: data?.phoneNumber,
            [`${pageId}.${sectionId}.proposerNumber`]: data?.countryCode,
            [`${pageId}.${sectionId}.proposerannualIncome`]: data?.annualIncome,
            [`${pageId}.${sectionId}.propserdateOfBirth`]: data?.birthDate,
          }
        })
        let componentToBeChange = temp?.pages[0]?.sections[0]?.component_groups?.findIndex(element => element.componentId === "CPPremiumProposerDetails")
        let componentNameFreeze = temp?.pages[0]?.sections[0]?.component_groups[componentToBeChange]?.components.findIndex(element => element.formControlKey === "CPProposalDetailName")
        let componentEmailFreeze = temp?.pages[0]?.sections[0]?.component_groups[componentToBeChange]?.components.findIndex(element => element.formControlKey === "proposerEmail")
        let componentNumberFreeze = temp?.pages[0]?.sections[0]?.component_groups[componentToBeChange]?.components.findIndex(element => element.formControlKey === "contactNoproposer")
        temp.pages[0].sections[0].component_groups[componentToBeChange].components[componentNameFreeze]["disabled"] = true
        temp.pages[0].sections[0].component_groups[componentToBeChange].components[componentEmailFreeze]["disabled"] = true
        temp.pages[0].sections[0].component_groups[componentToBeChange].components[componentNumberFreeze]["disabled"] = true
      } else if(journeyState.journeyIdFromStrapi === "titaniumPlusJourney" || journeyState.journeyIdFromStrapi === "alphaWealthPlanJourney"){
        setSectionState(prev => {
          return {
            ...prev,
            sectionFirstPass: true,
            sectionData: {
            ...prev.sectionData,
            "CFislifetobeAssuredandProposer": "N",
            "CPProposalDetailName": fullname,
            "proposerEmail": data?.emailId,
            "contactNoproposer": data?.phoneNumber,
            "proposerNumber": data?.countryCode,
            "proposerannualIncome": data?.annualIncome,
            "propserdateOfBirth": data?.birthDate
            }
          }
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${pageId}.${sectionId}.CFislifetobeAssuredandProposer`]: "N",
            [`${pageId}.${sectionId}.CPProposalDetailName`]: fullname,
            [`${pageId}.${sectionId}.proposerEmail`]: data?.emailId,
            [`${pageId}.${sectionId}.contactNoproposer`]: data?.phoneNumber,
            [`${pageId}.${sectionId}.proposerNumber`]: data?.countryCode,
            [`${pageId}.${sectionId}.proposerannualIncome`]: data?.annualIncome,
            [`${pageId}.${sectionId}.propserdateOfBirth`]: data?.birthDate,
          }
        })
        let componentToBeChange = temp?.pages[0]?.sections[0]?.component_groups?.findIndex(element => element.componentId === "CFProposerDetails")
        let componentNameFreeze = temp?.pages[0]?.sections[0]?.component_groups[componentToBeChange]?.components.findIndex(element => element.formControlKey === "CPProposalDetailName")
        let componentEmailFreeze = temp?.pages[0]?.sections[0]?.component_groups[componentToBeChange]?.components.findIndex(element => element.formControlKey === "proposerEmail")
        let componentNumberFreeze = temp?.pages[0]?.sections[0]?.component_groups[componentToBeChange]?.components.findIndex(element => element.formControlKey === "contactNoproposer")
        temp.pages[0].sections[0].component_groups[componentToBeChange].components[componentNameFreeze]["disabled"] = true
        temp.pages[0].sections[0].component_groups[componentToBeChange].components[componentEmailFreeze]["disabled"] = true
        temp.pages[0].sections[0].component_groups[componentToBeChange].components[componentNumberFreeze]["disabled"] = true
      }
    }
    // setSectionState(prev => {
    //   return {
    //     ...prev,
    //     sectionData: {
    //       ...prev.sectionData,
    //       "CPPersonalDetailName": fullname,
    //       "email": data?.emailId,
    //       "contactNo": data?.phoneNumber,
    //       "mobileNumber": data?.countryCode,
    //       "annualIncome": data?.annualIncome,
    //       "dateOfBirth": data?.birthDate
    //     }
    //   }
    // })

    console.log("HIIIII");
  },[props.canaraPosData])

  useEffect(() => {
    if (!nvestFilterResult && journeyState.channel) {
      getIpAddress()
        .then(res => {
          let payload = {
            ip: res.IPv4
          }
          if (refreshToken) {
            let payload = {
              ProductId: journeyState.productId,
              Bank: getValueFromLookup("reverseChannelToNumber", journeyState.channel),
              journeyIdFromStrapi: journeyState.journeyIdFromStrapi
            }
            getAllInputQuotations(payload)
              .then(res => {
                if (res.status) {
                  let temp = res.data
                  let formInputsWithUnifiedKey = res.data.formInputs.filter(element => element.unified_keywordName)
                  temp.formInputs = formInputsWithUnifiedKey
                  console.log("inside all input quotations")
                  setNvestFilterResult(temp)
                  if (res.data.optionIds) {
                    setJourneyState(prev => {
                      return ({
                        ...prev,
                        optionValues: res.data.optionIds,
                        allUniquePtValues: res.data.allUniquePtValues,
                        allUniquePptValues: res.data.allUniquePptValues
                      })
                    })
                  }
                }
              })
              .catch(err => {
                console.log(err)
              })
          } else {
            getJWTTokenForIp(payload)
              .then(res => {
                let payload = {
                  ProductId: journeyState.productId,
                  Bank: getValueFromLookup("reverseChannelToNumber", journeyState.channel),
                  journeyIdFromStrapi: journeyState.journeyIdFromStrapi
                }
                getAllInputQuotations(payload)
                  .then(res => {
                    if (res.status) {
                      let temp = res.data
                      let formInputsWithUnifiedKey = res.data.formInputs.filter(element => element.unified_keywordName)
                      temp.formInputs = formInputsWithUnifiedKey
                      console.log("inside all input quotations")
                      setNvestFilterResult(temp)
                      if (res.data.optionIds) {
                        setJourneyState(prev => {
                          return ({
                            ...prev,
                            optionValues: res.data.optionIds,
                            allUniquePtValues: res.data.allUniquePtValues,
                            allUniquePptValues: res.data.allUniquePptValues
                          })
                        })
                      }
                    }
                  })
                  .catch(err => {
                    console.log(err)
                  })
              })
          }
        })
    }
  }, [journeyState.channel])

  useEffect(() => {
    let allowCaseToResume = props?.resumeJourneyData?.allowCaseToResume || false
  
    if (products_to_be_closed.includes(journeyState?.journeyIdFromStrapi) && !allowCaseToResume){
      navigate("/productWithdrawn",{
        replace : true,
      })
    }
  }, [])
  

  useEffect(() => {
    let temp = journeyState.journeySteps
    let tempPageIndex
    let tempSectionIndex
    let tempComponentGroupIndex
    let tempComponentIndex
    if (journeyState.journeyIdFromStrapi === "iSelectJourney") {
      tempPageIndex = temp.pages.findIndex(element => element.pageId === "calculatePremiumPage")
      tempSectionIndex = temp.pages[tempPageIndex].sections.findIndex(element => element.sectionId === "CPCustomizePlanSection")
      tempComponentGroupIndex = temp.pages[tempPageIndex].sections[tempSectionIndex].component_groups.findIndex(element => element.componentId === "CPCustomizePlan")
      tempComponentIndex = temp.pages[tempPageIndex].sections[tempSectionIndex].component_groups[tempComponentGroupIndex].components.findIndex(element => element.formControlKey === "CPCustomizePlanPaymentFrequency")
      if (journeyState.channel && journeyState.channel === "A") {
        temp.pages[tempPageIndex].sections[tempSectionIndex].component_groups[tempComponentGroupIndex].components[tempComponentIndex]["lookupKey"] = "premiumFrequency_withoutSinglePremium"
      } else {
        temp.pages[tempPageIndex].sections[tempSectionIndex].component_groups[tempComponentGroupIndex].components[tempComponentIndex]["lookupKey"] = "premiumFrequency"
      }
    } else if (journeyState.journeyIdFromStrapi === "ISelect360Journey") {
      tempPageIndex = temp.pages.findIndex(element => element.pageId === "PageISelect360CalculatePremium")
      tempSectionIndex = temp.pages[tempPageIndex].sections.findIndex(element => element.sectionId === "iSelect360CPCustomizePlanSection")
      tempComponentGroupIndex = temp.pages[tempPageIndex].sections[tempSectionIndex].component_groups.findIndex(element => element.componentId === "iSelect360CPCustomizePlan")
      tempComponentIndex = temp.pages[tempPageIndex].sections[tempSectionIndex].component_groups[tempComponentGroupIndex].components.findIndex(element => element.formControlKey === "iSelect360CPCustomizePlanPaymentFrequency")
      if (journeyState.channel && journeyState.channel === "A") {
        temp.pages[tempPageIndex].sections[tempSectionIndex].component_groups[tempComponentGroupIndex].components[tempComponentIndex]["lookupKey"] = "premiumFrequency_withoutSinglePremium"
      } else {
        temp.pages[tempPageIndex].sections[tempSectionIndex].component_groups[tempComponentGroupIndex].components[tempComponentIndex]["lookupKey"] = "premiumFrequency"
      }
    }

  }, [journeyState.channel])

  function skipTPAPage(option){
    console.log(`removing ${option} tpa page...`)
    if (option === "LA"){
      setTpaState(prev => {
        return {
          ...prev,
          skipPage: true,
        }
      })
    }else if (option === "SA"){
      setTpaStateSA(prev => {
        return {
          ...prev,
          skipPage: true,
        }
      })
    }
  }

  function handleTPA(res,option){
    const matchType = res?.data?.response?.matchType
    let tpa = res?.data?.response?.response
    if ((!tpa) || (tpa && Array.isArray(tpa) && tpa.length === 0)){
      skipTPAPage(option)
      return;
    }
    if (matchType === "PARTIAL" || tpa.length > 1){ // multiple tpas and partial match is out of scope for isnp system
      skipTPAPage(option)
      return;
    }else if ((matchType === "EXACT" || matchType === "NEW") && tpa.length === 1) {
      tpa = tpa[0]

      if (!["Health India","Health Assure","Gowelnext"].includes(tpa.tpaName)){
        skipTPAPage(option)
        return;
      }

      const medicalPFRS = tpa.medicalPFRS || []
      if (medicalPFRS.length > 0) {
        const tpaName = tpa.tpaName
        const medicalType = medicalPFRS[0]?.pfrGroup
        const medicalTests = medicalPFRS?.map(pfr => pfr?.pfrDesc || "")
        if (option === "LA"){
          setTpaState(prev => {
            return {
              ...prev,
              medicalTests: [...medicalTests],
              tpaName: tpaName,
              medicalType: medicalType,
              matchType: matchType,
              skipPage: false,
            }
          })
        }else if(option === "SA"){
          setTpaStateSA(prev => {
            return {
              ...prev,
              medicalTests: [...medicalTests],
              tpaName: tpaName,
              medicalType: medicalType,
              matchType: matchType,
              skipPage: false,
            }
          })
        }
      }else{
        skipTPAPage(option)
      }
    }else{
      skipTPAPage(option)
    }
  }

  useEffect(() => {
    if (props.pageId === "PageFlexiEdgeFillProposalForm" && sectionState?.sectionId === "SectionFlexiEdgeBankDetailsOfProposer" && !['A'].includes(journeyState.channel)){
      const payloadLA = {
        journeyId : journeyState.journeyId,
        option : "LA"
      }
      
      checkTPA(payloadLA)
      .then(res => {
        handleTPA(res,"LA")
      })
      .catch(err => {
        skipTPAPage("LA")
        console.log("err",err)
      })
      callJlref.current = "initiate"
      console.info("nocall to initiate")
    }

  },[sectionState?.sectionId])

  useEffect(() => {
    if (callJl){
      console.info("calling...")
      if (tpaStateSA.isSA !== false){
          const payloadSA = {
            journeyId : journeyState.journeyId,
            option : "SA"
          }
          checkTPA(payloadSA)
          .then(res => {
            handleTPA(res,"SA")
          })
          .catch(err => {
            skipTPAPage("SA")
            console.log("err",err)
          })
      }
      callJlref.current = "nocall"
      setCallJl(false)
    }
  }, [callJl])
  


  const callAllInputForIndividualSections = () => {
    if (!nvestFilterResult) {
      let payload = {
        ProductId: journeyState.productId,
        Bank: getValueFromLookup("reverseChannelToNumber", journeyState.channel),
        journeyIdFromStrapi: journeyState.journeyIdFromStrapi
      }
      getAllInputQuotations(payload)
        .then(res => {
          if (res.status) {
            let temp = res.data
            let formInputsWithUnifiedKey = res.data.formInputs.filter(element => element.unified_keywordName)
            temp.formInputs = formInputsWithUnifiedKey
            console.log("inside all input quotations")
            setNvestFilterResult(temp)
            if (res.data.optionIds) {
              setJourneyState(prev => {
                return ({
                  ...prev,
                  optionValues: res.data.optionIds,
                  allUniquePtValues: res.data.allUniquePtValues,
                  allUniquePptValues: res.data.allUniquePptValues
                })
              })
            }
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
  const callAllInputForCustomPayload = (payload) => {
    getAllInputQuotations(payload)
      .then(res => {
        if (res.status) {
          let temp = res.data
          let formInputsWithUnifiedKey = res.data.formInputs.filter(element => element.unified_keywordName)
          temp.formInputs = formInputsWithUnifiedKey
          if (res.data.optionIds) {
            setJourneyState(prev => {
              return ({
                ...prev,
                optionValues: res.data.optionIds,
                allUniquePtValues: res.data.allUniquePtValues,
                allUniquePptValues: res.data.allUniquePptValues
              })
            })
          }
        }
      })
      .catch(err => {
        console.log(err)
      })
  }

  useEffect(() => {
    let payload;
    if (sectionState?.sectionData?.childsFuture === "Y" && sectionState.sectionData.childsAge) {
      payload = {
        ProductId: journeyState.productId,
        "REQUESTSOURCE": 4,
        "Child_Age": sectionState.sectionData?.childsAge,
      }
      callAllInputForCustomPayload(payload)
    } else if (sectionState?.sectionData?.childsFuture === "N") {
      payload = {
        ProductId: journeyState.productId,
        "REQUESTSOURCE": 4
      }
      callAllInputForCustomPayload(payload)
    }
  }, [sectionState?.sectionData?.childsFuture, sectionState?.sectionData?.childsAge])

  useEffect(() => {
    if (["guaranteedSavingsOption", "invest4GJourney", "guaranteedIncome4LifeJourney"].includes(journeyState.journeyIdFromStrapi) && sections[currentSectionIndex]?.sectionId === "SectionCommonResidenceAndOccupation" && sectionState?.sectionData?.GOPAexactNatureOfOccupation) {
      let payload = {
        "ProductId": journeyState.productId,
        "Occupation": sectionState?.sectionData?.GOPAexactNatureOfOccupation
      }
      getAllInputQuotations(payload)
      .then(res => {
        console.log(res)
        if (res.status) {
          if (res.data.planOptionList) {
            setJourneyState(prev => {
              return ({
                ...prev,
                planOptionList: res.data.planOptionList,
              })
            })
          }
        }
      })
      .catch(err => {
        console.log(err)
      })
    }
  }, [sectionState?.sectionData?.GOPAexactNatureOfOccupation])

  useEffect(() => {
    if (props.pageId === "PageGuaranteedOnePayCalculatePremium" && sections[currentSectionIndex]?.sectionId === "SectionGOPAPersonelDetails" && journeyState.journeyIdFromStrapi === "GuarateedOnePayJourney") {
      let temp = journeyState?.journeySteps;
      const changeJourneySteps = (pageId, sectionId, componentGroup, componentFormControlKey, key, value) => {
        try {
          let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
          let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
          let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentGroup)
          let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === componentFormControlKey)
          console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "======>ImpTemp0")
          temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange][key] = value
        } catch (err) {
          console.log(err, "=====>ErrorInPage.js===Line-152")
        }
      }
      if (sectionState?.sectionData?.GOPAslifetobeAssuredandProposer === "N") {
        changeJourneySteps("PageGuaranteedOnePayCalculatePremium", "SectionGOPAChooseYourPlan", "GopaCoverageOption", "GopaCoverageOption", "disabled", true)
      } else if (sectionState?.sectionData?.GOPAslifetobeAssuredandProposer === "Y") {
        changeJourneySteps("PageGuaranteedOnePayCalculatePremium", "SectionGOPAChooseYourPlan", "GopaCoverageOption", "GopaCoverageOption", "disabled", false)
      }
    }
  }, [sectionState?.sectionData])



  //useEffect to auto Fill data for sections of fill proposal form.
  useEffect(() => {
    const canaraPosPlanArray = [
      "PageInsureSmartCalculateFundValue",
      "PageGuaranteedOnePayCalculatePremium",
      "PageGuaranteedFutureCalculatePremium",
      "PageTitaniumPlusCalculateFundValue",
      "PageGuaranteedIncome4LifeCalculatePremium",
      "PageGuaranteedIncomeAdvantageCalculatePremium",
      "PageGuaranteedSavingsCalculatePremium",
      "PageGuaranteedFortuneCalculatePremium",
      "PageHealthFirstCalculateFundValue",
      "PageInvest4GCalculateFundValue",
      "PageJeevenNiveshCalculatePremium",
      "PageMoneyBackCalculatePremium",
      "PageSecureBhavishyaCalculatePremium",
      "PageSmartJuniorCalculatePremium",
      "PageTitaniumPlusCalculateFundValue",
      "GAINcalculatePremiumPage",
      "AlphaWealthPlanCalculateFundValuePage"
    ]
    if (props.pageId === "calculatePremiumPage" && sections[currentSectionIndex]?.sectionId === "CPPersonalDetailsSection") {
      if (journeyState.journeyId && firstPageAutoFillApiCall) {
        autoFillData("calculatePremiumPage", "CPPersonalDetailsSection")
      }
    } else if (props.pageId === "calculatePremiumPage" && sections[currentSectionIndex]?.sectionId === "CPResidentAndOccupationDetailSection") {
      autoFillData("calculatePremiumPage", "CPResidentAndOccupationDetailSection")
    } else if (props.pageId === "PageISelect360CalculatePremium" && sections[currentSectionIndex]?.sectionId === "iSelect360CPResidentAndOccupationDetailSection") {
      autoFillData("PageISelect360CalculatePremium", "iSelect360CPResidentAndOccupationDetailSection")
    } else if (props.pageId === "calculatePremiumPage" && sections[currentSectionIndex]?.sectionId === "CPCustomizePlanSection") {
      autoFillData("calculatePremiumPage", "CPCustomizePlanSection")
      callAllInputForIndividualSections()
    } else if (props.pageId === "calculatePremiumPage" && sections[currentSectionIndex]?.sectionId === "CPOptionInBuiltCoversSection") {
      autoFillData("calculatePremiumPage", "CPOptionInBuiltCoversSection")
      callAllInputForIndividualSections()
    } else if (props.pageId === "calculatePremiumPage" && sections[currentSectionIndex]?.sectionId === "CPSpouseCoverDetails") {
      autoFillData("calculatePremiumPage", "CPSpouseCoverDetails")
      callAllInputForIndividualSections()
    } else if (props.pageId === "PageInsureSmartCalculateFundValue" && sections[currentSectionIndex]?.sectionId === "SectionInsureSmartPortfolioManagementOPtions") {
      autoFillData("PageInsureSmartCalculateFundValue", "SectionInsureSmartPortfolioManagementOPtions")
    }

    else if (props.pageId === "PageISelect360CalculatePremium" && sections[currentSectionIndex]?.sectionId === "CPPersonalDetailsSection") {
      if (journeyState.journeyId) {
        autoFillData("PageISelect360CalculatePremium", "CPPersonalDetailsSection")
      }
    } 
    // else if (props.pageId === "PageISelect360CalculatePremium" && sections[currentSectionIndex]?.sectionId === "iSelect360CPResidentAndOccupationDetailSection") {
      // autoFillData("PageISelect360CalculatePremium", "iSelect360CPResidentAndOccupationDetailSection")
    // }
    else if (props.pageId === "PageISelect360CalculatePremium" && sections[currentSectionIndex]?.sectionId === "iSelect360CPCustomizePlanSection") {
      autoFillData("PageISelect360CalculatePremium", "iSelect360CPCustomizePlanSection")
      callAllInputForIndividualSections()
    } else if (props.pageId === "PageISelect360CalculatePremium" && sections[currentSectionIndex]?.sectionId === "iSelect360CPOptionalInBuilt") {
      autoFillData("PageISelect360CalculatePremium", "iSelect360CPOptionalInBuilt")
      callAllInputForIndividualSections()
    } else if (props.pageId === "PageISelect360CalculatePremium" && sections[currentSectionIndex]?.sectionId === "iSelect360CPSpouseCoverDetails") {
      autoFillData("PageISelect360CalculatePremium", "iSelect360CPSpouseCoverDetails")
      callAllInputForIndividualSections()
    }
    // For ISelectStar
    else if (props.pageId === "fillProposalForm" && sections[currentSectionIndex]?.sectionId === "personalDetailsSection") {
      autoFillDataAndFreeze("fillProposalForm", "personalDetailsSection")
    }
    else if (props.pageId === "fillProposalForm" && sections[currentSectionIndex]?.sectionId === "residenceDetailsSection") {
      autoFillDataAndFreeze("fillProposalForm", "residenceDetailsSection")

    } else if (props.pageId === "fillProposalForm" && sections[currentSectionIndex]?.sectionId === "professionalDetailSection") {
      autoFillDataAndFreeze("fillProposalForm", "professionalDetailSection")
    }
    else if (props.pageId === "fillProposalForm" && sections[currentSectionIndex]?.sectionId === "healthAndLifeStyleDetailSection") {
      autoFillDataAndFreeze("fillProposalForm", "healthAndLifeStyleDetailSection")
    }
    // For ISelect360
    else if (props.pageId === "pageISelect360FillProposalForm" && sections[currentSectionIndex]?.sectionId === "personalDetailsSection") {
      autoFillDataAndFreeze("pageISelect360FillProposalForm", "personalDetailsSection")
    }
    else if (props.pageId === "pageISelect360FillProposalForm" && sections[currentSectionIndex]?.sectionId === "residenceDetailsSection") {
      autoFillDataAndFreeze("pageISelect360FillProposalForm", "residenceDetailsSection")

    } else if (props.pageId === "pageISelect360FillProposalForm" && sections[currentSectionIndex]?.sectionId === "sectionISelect360ProfessionalDetail") {
      autoFillDataAndFreeze("pageISelect360FillProposalForm", "sectionISelect360ProfessionalDetail")
    }
    else if (props.pageId === "pageISelect360FillProposalForm" && sections[currentSectionIndex]?.sectionId === "healthAndLifeStyleDetailSection") {
      autoFillDataAndFreeze("pageISelect360FillProposalForm", "healthAndLifeStyleDetailSection")
    }
    else if (props.pageId === "pageISelect360FillProposalForm" && sections[currentSectionIndex]?.sectionId === "spouseQuestionnaire") {
      autoFillDataAndFreeze("pageISelect360FillProposalForm", "spouseQuestionnaire")
    }

    else if (props.pageId === "pageISelect360FillProposalForm" && sections[currentSectionIndex]?.sectionId === "spouseMedicalQuestionnaire") {
      autoFillDataAndFreeze("pageISelect360FillProposalForm", "spouseMedicalQuestionnaire")
    }

    // GuaranteedSavingJourney 
    else if (props.pageId === "PagePOSFillProposalForm" && sections[currentSectionIndex]?.sectionId === "SectionPOSFPSPersonalDetails") {
      autoFillDataAndFreeze("PagePOSFillProposalForm", "SectionPOSFPSPersonalDetails")
    }
    else if (props.pageId === "PagePOSFillProposalForm" && sections[currentSectionIndex]?.sectionId === "SectionPOSCommunicationAddress") {
      autoFillDataAndFreeze("PagePOSFillProposalForm", "SectionPOSCommunicationAddress")

    } else if (props.pageId === "PagePOSFillProposalForm" && sections[currentSectionIndex]?.sectionId === "SectionPOSOccupationDetails") {
      autoFillDataAndFreeze("PagePOSFillProposalForm", "SectionPOSOccupationDetails")
    }
    else if (props.pageId === "PagePOSFillProposalForm" && sections[currentSectionIndex]?.sectionId === "SectionPOSProposerDetails") {
      if (conditionState["PageGuaranteedSavingCalculatePremium.SectionGuaranteedSavingPersonaldetails.personalDetailLifeInsuredQuestion"] === "N") {
        autoFillDataAndFreeze("PagePOSFillProposalForm", "SectionPOSProposerDetails")
      }
    }

    //common fill proposal form
    else if (props.pageId === "PageFlexiEdgeFillProposalForm" && sections[currentSectionIndex]?.sectionId === "SectionFlexiEdgeFillProposalPersonalDetail") {
      if (journeyState?.journeyType === "CanaraPos" || props?.resumeJourneyData?.journeyData?.journeyType === "CanaraPos"){
        autoFillData("PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalPersonalDetail")
      }else{
        autoFillDataAndFreeze("PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalPersonalDetail")
      }
    } else if (props.pageId === "PageFlexiEdgeFillProposalForm" && sections[currentSectionIndex]?.sectionId === "SectionFlexiEdgeFillProposalProposerDetails") {
      if (journeyState?.journeyType === "CanaraPos" || props?.resumeJourneyData?.journeyData?.journeyType === "CanaraPos"){
        autoFillData("PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalProposerDetails")
      }else{
        autoFillDataAndFreeze("PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalProposerDetails")
      }
    } else if (props.pageId === "PageFlexiEdgeFillProposalForm" && sections[currentSectionIndex]?.sectionId === "SectionFlexiEdgeFillproposalOccupationDetails") {
      if (journeyState?.journeyType === "CanaraPos" || props?.resumeJourneyData?.journeyData?.journeyType === "CanaraPos"){
        autoFillData("PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillproposalOccupationDetails")
      }else{
        autoFillDataAndFreeze("PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillproposalOccupationDetails")
      }
    } else if (props.pageId === "PageFlexiEdgeFillProposalForm" && sections[currentSectionIndex]?.sectionId === "SectionFlexiEdgeFillProposalCommunicationAddress") {
      if (journeyState?.journeyType === "CanaraPos" || props?.resumeJourneyData?.journeyData?.journeyType === "CanaraPos"){
        autoFillData("PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalCommunicationAddress") 
      }else{
        autoFillDataAndFreeze("PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalCommunicationAddress")
      }
    }
    // else if (props.pageId === "PageFlexiEdgeFillProposalForm" && sections[currentSectionIndex]?.sectionId === "SectionFlexiEdgeFillProposalCommunicationAddress") {
    //   if (journeyState?.journeyType === "CanaraPos" || props?.resumeJourneyData?.journeyData?.journeyType === "CanaraPos"){
    //     autoFillData("PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalCommunicationAddress")
    //   }else{
    //     autoFillDataAndFreeze("PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalCommunicationAddress")
    //   }
    // }
    else if (props.pageId === "PageFlexiEdgeFillProposalForm" && sections[currentSectionIndex]?.sectionId === "SectionFlexiEdgeBankDetailsOfProposer") {
      autoFillDataAndFreeze("PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeBankDetailsOfProposer")
    }
    else if (props.pageId === "PageFlexiEdgeFillProposalForm" && sections[currentSectionIndex]?.sectionId === "sectionGOPAJointLifeQuestionnaire") {
      autoFillDataAndFreeze("PageFlexiEdgeFillProposalForm", "sectionGOPAJointLifeQuestionnaire")
    }
    else if (props.pageId === "PageSecureBhavishyaCalculatePremium" && sections[currentSectionIndex]?.sectionId === "SectionSecureBhavishyafundoption") {
      autoFillData("PageSecureBhavishyaCalculatePremium", "SectionSecureBhavishyafundoption")
    }
    else if (props.pageId === "PageFlexiEdgeFillProposalForm" && sections[currentSectionIndex]?.sectionId === "SectionFlexiEdgeFillProposalNomineeDetails") {
      autoFillData("PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalNomineeDetails")
    }
    else if (props.pageId === "PageFlexiEdgeCalculatePremium" && sections[currentSectionIndex]?.sectionId === "SectionFlexiEdgeResidenceandOccupationDetails") {
      autoFillData("PageFlexiEdgeCalculatePremium", "SectionFlexiEdgeResidenceandOccupationDetails")
    }
    else if (props.pageId === "PageFlexiEdgeCalculatePremium" && sections[currentSectionIndex]?.sectionId === "proposerCommonResidenceAndOccupation") {
      autoFillData("PageFlexiEdgeCalculatePremium", "proposerCommonResidenceAndOccupation")
    }else if (props.pageId === "PageInsureSmartCalculateFundValue" && sections[currentSectionIndex]?.sectionId === "SectionCommonResidenceAndOccupation"){
      autoFillData("PageInsureSmartCalculateFundValue", "SectionCommonResidenceAndOccupation")
    }
    else if (props.pageId === "PageGuaranteedOnePayCalculatePremium" && sections[currentSectionIndex]?.sectionId === "SectionCommonResidenceAndOccupation"){
      autoFillData("PageGuaranteedOnePayCalculatePremium", "SectionCommonResidenceAndOccupation")
    }
    else if (props.pageId === "GAINcalculatePremiumPage" && sections[currentSectionIndex]?.sectionId === "SectionCommonResidenceAndOccupation"){
      autoFillData("GAINcalculatePremiumPage", "SectionCommonResidenceAndOccupation")
    }
    // else if (props.pageId === "PageFlexiEdgeFillProposalForm" && sections[currentSectionIndex]?.sectionId === "SectionFlexiEdgeBankDetailsOfProposer") {
    //   autoFillData("PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeBankDetailsOfProposer")
    // }

    // CanaraPos SectionCommonResidenceAndOccupation autofill
    else if (canaraPosPlanArray.includes(props.pageId) && sections[currentSectionIndex]?.sectionId === "SectionCommonResidenceAndOccupation" && journeyState?.journeyType?.toLowerCase() === "canarapos") {
      autoFillData(props.pageId, "SectionCommonResidenceAndOccupation")
    }
    else if (canaraPosPlanArray.includes(props.pageId) && sections[currentSectionIndex]?.sectionId === "proposerCommonResidenceAndOccupation" && journeyState?.journeyType?.toLowerCase() === "canarapos") {
      autoFillData(props.pageId, "proposerCommonResidenceAndOccupation")
    } else if (props.pageId === "AlphaWealthPlanCalculateFundValuePage" && sections[currentSectionIndex]?.sectionId === "SectionCommonResidenceAndOccupation") {
      autoFillData("AlphaWealthPlanCalculateFundValuePage", "SectionCommonResidenceAndOccupation") 
    } else if (props.pageId === "PageFlexiEdgeFillProposalForm" && sections[currentSectionIndex]?.sectionId === "SectionFlexiEdgeFillProposalPersonalDetail") {
      autoFillData("PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalPersonalDetail") 
    }
  }, [props.currentPageIndex, currentSectionIndex, journeyState.journeyId])

  useEffect(() => {
    let conditionStatePlanOptionKey
    if (journeyState.journeyIdFromStrapi === "iSelectJourney") {
      conditionStatePlanOptionKey = "calculatePremiumPage.CPCustomizePlanSection.CPCustomizePlanQuestionOne"
    } else if (journeyState.journeyIdFromStrapi === "ISelect360Journey") {
      conditionStatePlanOptionKey = "PageISelect360CalculatePremium.iSelect360CPCustomizePlanSection.iSelect360CPCustomizePlanQuestionOne"
    }
    // else if(journeyState.journeyIdFromStrapi === "FlexiEdgeJourney"){

    // }
    // else if(journeyState.journeyIdFromStrapi === "GuaranteedSavingJourney"){
    //   conditionStatePlanOptionKey = "PageGuaranteedSavingCalculatePremium.SectionGuaranteedSavingInvestmentDetails.planOption"
    // }
    else {
      return
    }
    if (conditionState[conditionStatePlanOptionKey]) {
      if (journeyState.optionValues[conditionState[conditionStatePlanOptionKey]]) {
        let ptValues = journeyState.optionValues[conditionState[conditionStatePlanOptionKey]].ptValues
        if (Object.keys(ptValues).length) {
          console.log("ptValues length exists")
          let lookupForPolicyTermUpto35 = JSON.parse(JSON.stringify(ptValues))
          delete lookupForPolicyTermUpto35["5"]
          delete lookupForPolicyTermUpto35["6"]
          delete lookupForPolicyTermUpto35["7"]
          delete lookupForPolicyTermUpto35["8"]
          delete lookupForPolicyTermUpto35["9"]
          // console.log(lookupForPolicyTermUpto35, "lookupForPolicyTermUpto35")
          // console.log(ptValues, "lookupForPolicyTerm")
          setJourneyState(prev => {
            return ({
              ...prev,
              policyTermLookup: ptValues,
              policyTermLookupUpto35: lookupForPolicyTermUpto35
            })
          })
        }
      }
    } else if (journeyState.planOption) {
      if (journeyState.optionValues[journeyState.planOption]) {
        let ptValues = journeyState.optionValues[journeyState.planOption].ptValues
        if (Object.keys(ptValues).length) {
          console.log("ptValues length exists")
          let lookupForPolicyTermUpto35 = JSON.parse(JSON.stringify(ptValues))
          delete lookupForPolicyTermUpto35["5"]
          delete lookupForPolicyTermUpto35["6"]
          delete lookupForPolicyTermUpto35["7"]
          delete lookupForPolicyTermUpto35["8"]
          delete lookupForPolicyTermUpto35["9"]

          setJourneyState(prev => {
            return ({
              ...prev,
              policyTermLookup: ptValues,
              policyTermLookupUpto35: lookupForPolicyTermUpto35
            })
          })
        }
      }
    }
  }, [journeyState.optionValues])


    useEffect (()=>{
      let temp = journeyState.journeySteps
      let pageId = ""
      let sectionId = ""
      let contactNumberComponentId = ""
      let contactNumberFormControlKey = ""
      let countryCodeFormControlKey = ""
      let proposerContactNumberComponentId = ""
      let proposerContactNumberFormControlKey = ""
      let proposerCountryCodeFormControlKey = ""

      if (journeyState.journeyIdFromStrapi === "alphaWealthPlanJourney"){
        pageId = "AlphaWealthPlanCalculateFundValuePage"
        sectionId = "AlphaWealthPlanCFpersonelDetailsSection"
        contactNumberComponentId = "contactNo"
        contactNumberFormControlKey = "contactNo"
        proposerContactNumberComponentId = "CFProposerDetails"
        proposerContactNumberFormControlKey = "contactNoproposer"
        countryCodeFormControlKey = "mobileNumber"
        proposerCountryCodeFormControlKey = "proposerNumber"
      }else if (journeyState.journeyIdFromStrapi === "titaniumPlusJourney"){
        pageId = "PageTitaniumPlusCalculateFundValue"
        sectionId = "CFSectionTitaniumPersonelDetails"
        contactNumberComponentId = "contactNo"
        contactNumberFormControlKey = "contactNo"
        proposerContactNumberComponentId = "CFProposerDetails"
        proposerContactNumberFormControlKey = "contactNoproposer"
        countryCodeFormControlKey = "mobileNumber"
        proposerCountryCodeFormControlKey = "proposerNumber"
      }else if (journeyState.journeyIdFromStrapi === "GAINjourney"){
        pageId = "GAINcalculatePremiumPage"
        sectionId = "GAINpersonalDetailsSection"
        contactNumberComponentId = "contactNo"
        contactNumberFormControlKey = "contactNo"
        proposerContactNumberComponentId = "GOPAproposerDetails"
        proposerContactNumberFormControlKey = "GOPAnumber"
        countryCodeFormControlKey = "mobileNumber"
        proposerCountryCodeFormControlKey = "GOPAproposerCode"
      }else if (journeyState.journeyIdFromStrapi === "guaranteedFutureJourney"){
        pageId = "PageGuaranteedFutureCalculatePremium"
        sectionId = "SectionGuaranteedFuturePersonelDetails"
        contactNumberComponentId = "contactNo"
        contactNumberFormControlKey = "contactNo"
        proposerContactNumberComponentId = "GOPAproposerDetails"
        proposerContactNumberFormControlKey = "GOPAnumber"
        countryCodeFormControlKey = "mobileNumber"
        proposerCountryCodeFormControlKey = "GOPAproposerCode"
      }else if (journeyState.journeyIdFromStrapi === "guaranteedFortuneJourney"){
        pageId = "PageGuaranteedFortuneCalculatePremium"
        sectionId = "SectionGuaranteedFortunePersonelDetails"
        contactNumberComponentId = "contactNo"
        contactNumberFormControlKey = "contactNo"
        proposerContactNumberComponentId = "GOPAproposerDetails"
        proposerContactNumberFormControlKey = "GOPAnumber"
        countryCodeFormControlKey = "mobileNumber"
        proposerCountryCodeFormControlKey = "GOPAproposerCode"
      }else if (journeyState.journeyIdFromStrapi === "IGFPPlusJourney"){
        pageId = "PageIGFPPlusCalculatePremium"
        sectionId = "SectionIGFPPlusPersonelDetails"
        contactNumberComponentId = "contactNo"
        contactNumberFormControlKey = "contactNo"
        proposerContactNumberComponentId = "GOPAproposerDetails"
        proposerContactNumberFormControlKey = "GOPAnumber"
        countryCodeFormControlKey = "mobileNumber"
        proposerCountryCodeFormControlKey = "GOPAproposerCode"
      }else if (journeyState.journeyIdFromStrapi === "Promise4FutureJourney"){
        pageId = "PagePromise4FutureCalculatePremium"
        sectionId = "SectionPromise4FutureCalculatePremiumPersonalDetails"
        contactNumberComponentId = "contactNo"
        contactNumberFormControlKey = "contactNo"
        proposerContactNumberComponentId = "CPPremiumProposerDetails"
        proposerContactNumberFormControlKey = "contactNoproposer"
        countryCodeFormControlKey = "mobileNumber"
        proposerCountryCodeFormControlKey = "proposerNumber"
      }
 
      if(sectionState?.sectionData?.[countryCodeFormControlKey] != '+91'){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === contactNumberComponentId)
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === contactNumberFormControlKey)
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 9
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 15
      }
      else if(sectionState?.sectionData?.[countryCodeFormControlKey]== '+91'){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === contactNumberComponentId)
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === contactNumberFormControlKey)
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 10
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 10
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = "/(?!9999999999|8888888888|7777777777|6666666666)(^[6-9][0-9]{9}$)/"
      
      }
      
      if(sectionState?.sectionData?.[proposerCountryCodeFormControlKey] !="+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === proposerContactNumberComponentId)
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === proposerContactNumberFormControlKey)
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 9
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 15
      }
      else if(sectionState?.sectionData?.[proposerCountryCodeFormControlKey] =="+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === proposerContactNumberComponentId)
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === proposerContactNumberFormControlKey)
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 10
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = "/(?!9999999999|8888888888|7777777777|6666666666)(^[6-9][0-9]{9}$)/"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 10
      }
  
      if(sectionState?.sectionData?.MobAlternateCountryCode != "+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeFillProposalForm")
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeFillProposalPersonalDetail")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "LAalternateMobileNo")
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "AlternateMobNumber")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 9
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 15
      }
      else if(sectionState?.sectionData?.MobAlternateCountryCode == "+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeFillProposalForm")
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeFillProposalPersonalDetail")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "LAalternateMobileNo")
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "AlternateMobNumber")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 10
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = "/(?!9999999999|8888888888|7777777777|6666666666)(^[6-9][0-9]{9}$)/"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 10
      }
  
      if(sectionState?.sectionData?.contactCountryCode != "+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeFillProposalForm")
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeFillProposalPersonalDetail")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "LAcontactNo")
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "contactNumber")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 9
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 15
  
        tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeFillProposalProposerDetails")
        tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "proposerContactNumber")
        tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "contactNumber")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 9
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = "E168"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 15
      }
      else if(sectionState?.sectionData?.contactCountryCode == "+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeFillProposalForm")
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeFillProposalPersonalDetail")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "LAcontactNo")
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "contactNumber")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 10
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = "/(?!9999999999|8888888888|7777777777|6666666666)(^[6-9][0-9]{9}$)/"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = "E168"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 10
  
        tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeFillProposalProposerDetails")
        tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "proposerContactNumber")
        tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "contactNumber")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 10
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = "/(?!9999999999|8888888888|7777777777|6666666666)(^[6-9][0-9]{9}$)/"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = "E168"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 10
      }
  
      if(sectionState?.sectionData?.contactCountryCode != "+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeFillProposalForm")
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeFillProposalProposerDetails")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "proposerAlternateNumber")
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey ==="AlternateMobNumber")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 9
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 15
      }
      else if(sectionState?.sectionData?.contactCountryCode == "+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeFillProposalForm")
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeFillProposalProposerDetails")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "proposerAlternateNumber")
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey ==="AlternateMobNumber")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 10
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = "/(?!9999999999|8888888888|7777777777|6666666666)(^[6-9][0-9]{9}$)/"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = "E168"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 10
      }
      
      if(sectionState?.sectionData?.proposerAlternateMobCountryCode != "+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeFillProposalForm")
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeFillProposalProposerDetails")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "proposerAlternateNumber")
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "AlternateMobNumber")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 9
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 15
      }
      else if(sectionState?.sectionData?.proposerAlternateMobCountryCode == "+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeFillProposalForm")
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeFillProposalProposerDetails")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "proposerAlternateNumber")
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "AlternateMobNumber")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 10
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = "/(?!9999999999|8888888888|7777777777|6666666666)(^[6-9][0-9]{9}$)/"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 10
      }

      if(sectionState?.sectionData?.countryCodeNominee != "+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeFillProposalForm")
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "FlexiEdgeFillProposalAppointeeSection")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "nomineeAgeCondition")
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "contactNominee")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 9
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = null
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 15
      }else if(sectionState?.sectionData?.countryCodeNominee == "+91"){
        let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeFillProposalForm")
        let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "FlexiEdgeFillProposalAppointeeSection")
        let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "nomineeAgeCondition")
        let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "contactNominee")
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 10
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = "/(?!9999999999|8888888888|7777777777|6666666666)(^[6-9][0-9]{9}$)/"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = "E168"
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 10
      }
      
  
      setJourneyState(prev => {
        return ({
          ...prev,
          journeySteps: temp
        })
      })
 
  },[sectionState?.sectionData?.["mobileNumber"],sectionState?.sectionData?.["proposerNumber"], sectionState?.sectionData?.["MobAlternateCountryCode"],  sectionState?.sectionData?.["LAalternateMobileNo"] ,sectionState?.sectionData?.["contactCountryCode"], sectionState?.sectionData?.["countryCodeNominee"], sectionState?.sectionData?.["proposerAlternateMobCountryCode"]])

  // function getAge(birthDate) {
  //   var now = new Date();
  //   function isLeap(year) {
  //     return year % 4 == 0 && (year % 100 != 0 || year % 400 == 0);
  //   }
  //   // days since the birthdate    
  //   var days = Math.floor((now.getTime() - birthDate.getTime())/1000/60/60/24);
  //   var age = 0;
  //   // iterate the years
  //   for (var y = birthDate.getFullYear(); y <= now.getFullYear(); y++){
  //     var daysInYear = isLeap(y) ? 366 : 365;
  //     if (days >= daysInYear){
  //       days -= daysInYear;
  //       age++;
  //       // increment the age only if there are available enough days for the year.
  //     }
  //   }
  //   return age;
  // }

  // This UseEffect Critical Illness PP & PPP FOR LA
  useEffect(() => {
    //Built in cover options 
    if (journeyState.journeyIdFromStrapi == "ISelect360Journey" && (sectionState.sectionId == "iSelect360CPOptionalInBuilt")) {
      let temp = journeyState.journeySteps
      let componentIdKey
      let policyTermKey
      let premiumPaymentTermKey
      if (sectionState.sectionData["iSelect360CPOptionInBuiltCI"] == "IBATC1") {
        // FOR critical illness PP
        componentIdKey = "iS360DetailsCI1"
        policyTermKey = "iS360CPCustomizePlanPolicyTermCI1"
        premiumPaymentTermKey = "iS360CPCustomizePlanPremiumPaymentTermCI1"

      } else {
        // FOR critical illness PPP
        componentIdKey = "iS360DetailsCI2"
        policyTermKey = "iS360CPCustomizePlanPolicyTermCI2"
        premiumPaymentTermKey = "iS360CPCustomizePlanPremiumPaymentTermCI2"
      }
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageISelect360CalculatePremium")
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "iSelect360CPOptionalInBuilt")
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentIdKey)
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === policyTermKey)
      let tempComponentIndexToChangePPT = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === premiumPaymentTermKey)

      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true

      let last_policyTerm = conditionState["PageISelect360CalculatePremium.iSelect360CPCustomizePlanSection.iSelect360CPCustomizePlanPolicyTerm"]
      let last_ppt = conditionState["PageISelect360CalculatePremium.iSelect360CPCustomizePlanSection.iSelect360CPCustomizePlanPremiumPaymentTerm"]
      let la_age = getAge(conditionState["PageISelect360CalculatePremium.CPPersonalDetailsSection.dob"])
      let plan_code = conditionState["PageISelect360CalculatePremium.iSelect360CPCustomizePlanSection.iSelect360CPCustomizePlanQuestionOne"]

      if (plan_code == "IBTML" || plan_code == "IBTML1") {
        let ageparam = 70 - la_age
        let newpolicyTerm = ageparam >= last_policyTerm ? last_policyTerm : ageparam
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePPT]["disabled"] = false
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [policyTermKey]: newpolicyTerm,
            },
          }
        })
      } else {
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [policyTermKey]: last_policyTerm,
              [premiumPaymentTermKey]: last_ppt,
            },
          }
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePPT]["disabled"] = true
      }
      setJourneyState(prev => {
        return ({
          ...prev,
          journeySteps: temp
        })
      })
    }

  }, [sectionState.sectionData && sectionState.sectionData["iSelect360CPOptionInBuiltCI"]])

  // This UseEffect Critical Illness PP & PPP FOR SPOUSE
  useEffect(() => {
    //Built in cover options 
    if (journeyState.journeyIdFromStrapi == "ISelect360Journey" && (sectionState.sectionId == "iSelect360CPSpouseCoverDetails")) {
      let temp = journeyState.journeySteps
      let componentIdKey
      let policyTermKey
      let premiumPaymentTermKey
      if (sectionState.sectionData["iSelect360CPSpouseOptionInBuiltCI"] == "IBCSB1") {
        // FOR critical illness PP
        componentIdKey = "iS360SpouseDetailsCI1"
        policyTermKey = "iS360CPSpouseCustomizePlanPolicyTermCI1"
        premiumPaymentTermKey = "iS360CPSpouseCustomizePlanPremiumPaymentTermCI1"

      } else {
        // FOR critical illness PPP
        componentIdKey = "iS360SpouseDetailsCI2"
        policyTermKey = "iS360CPSpouseCustomizePlanPolicyTermCI2"
        premiumPaymentTermKey = "iS360CPSpouseCustomizePlanPremiumPaymentTermCI2"
      }
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageISelect360CalculatePremium")
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "iSelect360CPSpouseCoverDetails")
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentIdKey)
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === policyTermKey)
      let tempComponentIndexToChangePPT = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === premiumPaymentTermKey)

      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange]["disabled"] = true

      let last_policyTerm = conditionState["PageISelect360CalculatePremium.iSelect360CPCustomizePlanSection.iSelect360CPCustomizePlanPolicyTerm"]
      let last_ppt = conditionState["PageISelect360CalculatePremium.iSelect360CPCustomizePlanSection.iSelect360CPCustomizePlanPremiumPaymentTerm"]
      let la_age = getAge(conditionState["PageISelect360CalculatePremium.CPPersonalDetailsSection.dob"])
      let plan_code = conditionState["PageISelect360CalculatePremium.iSelect360CPCustomizePlanSection.iSelect360CPCustomizePlanQuestionOne"]

      if (plan_code == "IBTML" || plan_code == "IBTML1") {
        let ageparam = 70 - la_age
        let newpolicyTerm = ageparam >= last_policyTerm ? last_policyTerm : ageparam
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePPT]["disabled"] = false
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [policyTermKey]: newpolicyTerm,
            },
          }
        })
      } else {
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [policyTermKey]: last_policyTerm,
              [premiumPaymentTermKey]: last_ppt,
            },
          }
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePPT]["disabled"] = true
      }
      setJourneyState(prev => {
        return ({
          ...prev,
          journeySteps: temp
        })
      })
    }

  }, [sectionState.sectionData && sectionState.sectionData["iSelect360CPSpouseOptionInBuiltCI"]])

  // SPOUSE Built in CCB cover options 
  useEffect(() => {
    console.log("SPOUSE Built in CCB cover options")
    // SPOUSE Built in CCB cover options 
    if (journeyState.journeyIdFromStrapi == "ISelect360Journey" && (sectionState.sectionId == "iSelect360CPSpouseCoverDetails")) {
      let temp = journeyState.journeySteps

      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageISelect360CalculatePremium")
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "iSelect360CPSpouseCoverDetails")
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "iSelect360CPSpouseOptionInBuiltCoversCCB")
      let tempComponentIndexToChangeDOB = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "iS360spousedobCCB")
      let tempComponentIndexToChangeGENDER = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "iS360spouseGenderCCB")
      let tempComponentIndexToChangePT = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "iS360CPSpouseCustomizePlanPolicyTermCCB")
      let tempComponentIndexToChangePPT = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "iS360CPSpouseCustomizePlanPremiumPaymentTermCCB")

      let isLaCCB = conditionState["PageISelect360CalculatePremium.iSelect360CPOptionalInBuilt.iSelect360CPOptionInBuiltCCB"]
      let isSPCCB = sectionState.sectionData["iSelect360CPSpouseOptionInBuiltCCB"]

      if (isLaCCB && (isLaCCB == "IBCSB")) {
        let la_dob_ccb = conditionState["PageISelect360CalculatePremium.iSelect360CPOptionalInBuilt.iS360dobCCB"]
        let la_gender_ccb = conditionState["PageISelect360CalculatePremium.iSelect360CPOptionalInBuilt.iS360GenderCCB"]
        let la_pt_ccb = conditionState["PageISelect360CalculatePremium.iSelect360CPOptionalInBuilt.iS360CPCustomizePlanPolicyTermCCB"]
        let la_ppt_ccb = conditionState["PageISelect360CalculatePremium.iSelect360CPOptionalInBuilt.iS360CPCustomizePlanPremiumPaymentTermCCB"]
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeDOB]["disabled"] = true
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeGENDER]["disabled"] = true
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePT]["disabled"] = true
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePPT]["disabled"] = true
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["iS360spousedobCCB"]: la_dob_ccb,
              ["iS360spouseGenderCCB"]: la_gender_ccb,
              ["iS360CPSpouseCustomizePlanPolicyTermCCB"]: la_pt_ccb,
              ["iS360CPSpouseCustomizePlanPremiumPaymentTermCCB"]: la_ppt_ccb,
            },
          }
        })
      } else if (isSPCCB) {
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeDOB]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeGENDER]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePT]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePPT]["disabled"] = false
      }
      else {
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["iS360spousedobCCB"]: "",
              ["iS360spouseGenderCCB"]: "",
              ["iS360CPSpouseCustomizePlanPolicyTermCCB"]: "",
              ["iS360CPSpouseCustomizePlanPremiumPaymentTermCCB"]: "",
            },
          }
        })
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeDOB]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangeGENDER]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePT]["disabled"] = false
        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePPT]["disabled"] = false
      }
      setJourneyState(prev => {
        return ({
          ...prev,
          journeySteps: temp
        })
      })
    }

  }, [sectionState.sectionData && sectionState.sectionData["iSelect360CPSpouseOptionInBuiltCCB"]])

  /*Helper Functions Start*/

  useEffect (()=>{
    let temp = journeyState.journeySteps
    if(sectionState?.sectionData?.mobileNumber != '+91'){
     
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageGuaranteedFutureCalculatePremium")
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionGuaranteedFuturePersonelDetails")
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "contactNo")
      let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "contactNo")
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 9
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = null
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 15
    
    
    }
    else if(sectionState?.sectionData?.mobileNumber == '+91'){
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageGuaranteedFutureCalculatePremium")
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionGuaranteedFuturePersonelDetails")
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "contactNo")
      let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "contactNo")
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 10
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 10
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = "/(?!9999999999|8888888888|7777777777|6666666666)(^[6-9][0-9]{9}$)/"
    
    }
    
    if(sectionState?.sectionData?.GOPAproposerCode !="+91"){
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageGuaranteedFutureCalculatePremium")
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionGuaranteedFuturePersonelDetails")
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "GOPAproposerDetails")
      let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "GOPAnumber")
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 9
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = null
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 15
    }
    else if(sectionState?.sectionData?.GOPAproposerCode =="+91"){
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageGuaranteedFutureCalculatePremium")
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionGuaranteedFuturePersonelDetails")
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "GOPAproposerDetails")
      let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "GOPAnumber")
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 10
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = "/(?!9999999999|8888888888|7777777777|6666666666)(^[6-9][0-9]{9}$)/"
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 10
    }

    if(sectionState?.sectionData?.MobAlternateCountryCode != "+91"){
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeFillProposalForm")
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeFillProposalPersonalDetail")
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "LAalternateMobileNo")
      let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "AlternateMobNumber")
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 9
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = null
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 15
    }
    else   if(sectionState?.sectionData?.MobAlternateCountryCode == "+91"){
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeFillProposalForm")
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeFillProposalPersonalDetail")
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "LAalternateMobileNo")
      let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "AlternateMobNumber")
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 10
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = "/(?!9999999999|8888888888|7777777777|6666666666)(^[6-9][0-9]{9}$)/"
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 10 
    }

    if(sectionState?.sectionData?.contactCountryCode != "+91"){
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeFillProposalForm")
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeFillProposalPersonalDetail")
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "LAcontactNo")
      let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "contactNumber")
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 9
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = null
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = null
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 15

      tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeFillProposalProposerDetails")
      tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "proposerContactNumber")
      tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "contactNumber")
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 9
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = null
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = null
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 15
    }
    else   if(sectionState?.sectionData?.contactCountryCode == "+91"){
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeFillProposalForm")
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeFillProposalPersonalDetail")
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "LAcontactNo")
      let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "contactNumber")
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 10
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = "/(?!9999999999|8888888888|7777777777|6666666666)(^[6-9][0-9]{9}$)/"
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = "E168"
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 10 

      tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeFillProposalProposerDetails")
      tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "proposerContactNumber")
      tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "contactNumber")
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 10
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = "/(?!9999999999|8888888888|7777777777|6666666666)(^[6-9][0-9]{9}$)/"
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = "E168"
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 10 
    }

    if(sectionState?.sectionData?.contactCountryCode != "+91"){
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeFillProposalForm")
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeFillProposalProposerDetails")
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "proposerAlternateNumber")
      let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey ==="AlternateMobNumber")
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 9
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = null
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = null
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 15
    }
    else   if(sectionState?.sectionData?.contactCountryCode == "+91"){
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeFillProposalForm")
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "SectionFlexiEdgeFillProposalProposerDetails")
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "proposerAlternateNumber")
      let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey ==="AlternateMobNumber")
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 10
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = "/(?!9999999999|8888888888|7777777777|6666666666)(^[6-9][0-9]{9}$)/"
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = "E168"
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 10 
    }

    if(sectionState?.sectionData?.countryCodeNominee != "+91"){
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeFillProposalForm")
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "FlexiEdgeFillProposalAppointeeSection")
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "nomineeAgeCondition")
      let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "contactNominee")
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 9
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = null
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = null
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 15
    }else   if(sectionState?.sectionData?.countryCodeNominee == "+91"){
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === "PageFlexiEdgeFillProposalForm")
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === "FlexiEdgeFillProposalAppointeeSection")
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === "nomineeAgeCondition")
      let tempComponentIndexToChangePhoneNumber = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "contactNominee")
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["min_len"] = 10
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regex"] = "/(?!9999999999|8888888888|7777777777|6666666666)(^[6-9][0-9]{9}$)/"
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["regexError"] = "E168"
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChangePhoneNumber]["max_len"] = 10 
    }
    

    setJourneyState(prev => {
      return ({
        ...prev,
        journeySteps: temp
      })
    })

  },[sectionState.sectionData])


  const handleSATPAPage = (wishToSecure) => {
    if (!wishToSecure || wishToSecure !== "02"){
      if (tpaStateSA.isSA === null){
        let temp = journeyState.journeySteps;
        const tempPageIndexToChange = temp.pages.findIndex(page => page.pageId === "PageFlexiEdgeFillProposalForm")
        if (tempPageIndexToChange !== -1){
          const tempSectionIndexToChange = temp.pages[tempPageIndexToChange]?.sections?.findIndex(section => section.sectionId === "sectionBookSlotSA")
          if (tempSectionIndexToChange !== -1){
            setTpaStateSA(prev => {
              return {
                ...prev,
                isSA : false,
              }
            })
            console.info("Removing sa page....")
            temp.pages[tempPageIndexToChange].sections?.splice(tempSectionIndexToChange,1)
            setJourneyState(prev => { // no need to set state explicitly, direct change in state, deep copy aproach not working but following the isnp way
              return {
                ...prev,
                journeySteps : temp
              }
            })
          }
        }
      }
    }
  }

  //Code to fill data on API call
  const autoFillData = async (pageId, sectionId) => {
    let payload = {
      _id: journeyState.journeyId,
    }
    fetchApplicationDetails(payload)
      .then(async res => {
        let fetchedPageIndex = res.applicationData.findIndex(element => element.pageId === pageId)
        if (fetchedPageIndex !== -1) {
          let fetchedSectionIndex = res.applicationData[fetchedPageIndex].pageData.findIndex(element => element.sectionId === sectionId)
          if (fetchedSectionIndex !== -1) {
            let valueObject = {}
            let conditionObject = {}
            let requiredSectionData = res.applicationData[fetchedPageIndex].pageData[fetchedSectionIndex].sectionData
            Object.keys(requiredSectionData).forEach(element => {
              if (requiredSectionData[element]) {
                valueObject[element] = requiredSectionData[element]
                conditionObject[`${pageId}.${sectionId}.${element}`] = requiredSectionData[element]
              }
            })
            console.log(valueObject, "value object")
            console.log(conditionObject, "condition object")
            setConditionState(prev => {
              return {
                ...prev,
                ...conditionObject
              }
            })

            if (sectionId === "SectionFlexiEdgeFillProposalNomineeDetails") {
              let addressLine1Value
              let addressLine2Value
              let addressLine3Value
              let countryValue
              let pincodeValue
              let stateValue
              let cityValue
              let otherCityValue
                addressLine1Value = conditionState["PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalCommunicationAddress.addressLineOne"]
                addressLine2Value = conditionState["PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalCommunicationAddress.addressLineTwo"]
                addressLine3Value = conditionState["PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalCommunicationAddress.addressLineThree"]
                countryValue = conditionState["PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalPersonalDetail.currentCountryofResidence"]
                pincodeValue = conditionState["PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalCommunicationAddress.pincode"]
                stateValue = conditionState["PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalCommunicationAddress.state"]
                cityValue = conditionState["PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalCommunicationAddress.city"]
                otherCityValue = conditionState["PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalCommunicationAddress.commCity"]

              let getStateValueAndDisable = (formControlKeyToSet, valueToSet, elseCaseValue, indexToFreeze) => {
                let tempState
                if (sectionState.sectionData[formControlKeyToSet]) {
                  let temp1 = sectionState.sectionData[formControlKeyToSet]
                  if (valueToSet) {
                    temp1[0] = valueToSet
                  } else {
                    temp1[0] = elseCaseValue
                  }
                  tempState = temp1
                } else {
                  let temp1 = []
                  if (valueToSet) {
                    temp1[0] = valueToSet
                  } else {
                    temp1[0] = elseCaseValue
                  }
                  tempState = temp1
                }
                return tempState
              }
        
              valueObject["address1nominee"] = getStateValueAndDisable("address1nominee", addressLine1Value, "", 9)
              valueObject["address2nominee"] = getStateValueAndDisable("address2nominee", addressLine2Value, "", 10)
              valueObject["address3nominee"] = getStateValueAndDisable("address3nominee", addressLine3Value, "", 11)
              valueObject["nomineeCountry"] = getStateValueAndDisable("nomineeCountry", countryValue, "IN", 12)
              valueObject["nomineePincode"] = getStateValueAndDisable("nomineePincode", pincodeValue, "", 13)
              valueObject["stateNominee"] = getStateValueAndDisable("stateNominee", stateValue, "", 14)
              valueObject["cityNominee"] = getStateValueAndDisable("cityNominee", cityValue, "", 15)
              valueObject["cityTextNominee"] = getStateValueAndDisable("cityTextNominee", otherCityValue, "", 16)
              let tempNomineeTitle = []
              // tempNomineeTitle[0] = "MR"
              let tempNomineeCountryCode = []
              tempNomineeCountryCode[0] = requiredSectionData?.nomineeCountryCode?.[0] || "+91"
              let tempNomineeGender = []
              tempNomineeGender[0] = "M"
              valueObject["nomineeTitle"] = tempNomineeTitle
              valueObject["nomineeCountryCode"] = tempNomineeCountryCode
              valueObject["nomineeGender"] = tempNomineeGender
            }
            if (sectionId === "iSelect360CPOptionalInBuilt" || sectionId === "iSelect360CPSpouseCoverDetails") {
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionData: {
                    ...valueObject
                  }
                }
              })
            } else {
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionId: sectionId,
                  sectionData: {
                    ...prev.sectionData,
                    ...valueObject
                  }
                }
              })
            }

            if (pageId === "PageFlexiEdgeFillProposalForm"){
              handleSATPAPage(res?.journeyData?.productDetails?.spouseLaDetails?.wishToSecure)
            }

            let lookupKeyForTitle = "title"
            let lookupKeyforProposerTitle = "title"
            if (valueObject["gender"] === "M") {
              valueObject["fullNameTitle"] = "MR"
              valueObject["title"] = "MR"
              conditionObject[`${pageId}.${sectionId}.fullNameTitle`] = "MR"
            } else if (valueObject["gender"] === "F") {
              valueObject["fullNameTitle"] = valueObject["fullNameTitle"] ? valueObject["fullNameTitle"] : ""
              valueObject["title"] = valueObject["fullNameTitle"] ? valueObject["fullNameTitle"] : ""
              lookupKeyForTitle = "title-female"
            } else if (valueObject["proposergender"] === "M") {
              valueObject["title"] = "MR"
              conditionObject[`${pageId}.${sectionId}.title`] = "MR"
            } else if (valueObject["proposergender"] === "F") {
              valueObject["title"] = valueObject["title"] ? valueObject["title"] : ""
              lookupKeyforProposerTitle = "title-female"
            }

            if (sectionId === "CPResidentAndOccupationDetailSection" || sectionId === "iSelect360CPResidentAndOccupationDetailSection") {
              if (journeyState.residenceDetailEmailTrigger === false) {
                let sendEmailPayload = {
                  journeyId: journeyState.journeyId,
                  module: "QUOTESMSEMAIL",
                  residenceDetailEmailTrigger: true
                }
                // sendEmailBI(sendEmailPayload).then(res => {
                //   console.log(res, "emailRes")
                //   if (res?.status) {
                //     successToastr(res.message)
                //   } else {
                //     errorToastr(res.message)
                //   }
                // })
                setJourneyState(prev => {
                  return ({
                    ...prev,
                    residenceDetailEmailTrigger: true
                  })
                })
              }

            }
            // if(pageId === "calculatePremiumPage" && sectionId === "CPCustomizePlanSection"){
            //   let payload = {
            //     ProductId: journeyState.productId,
            //     PT: valueObject["CPCustomizePlanPolicyTerm"]
            //   }
            //   getAllInputQuotations(payload)
            //   .then(res => {
            //     if(res.status){
            //       let temp = res.data
            //       let formInputsWithUnifiedKey = res.data.formInputs.filter(element => element.unified_keywordName)
            //       temp.formInputs = formInputsWithUnifiedKey
            //       console.log( "inside all input quotations")
            //       setNvestFilterResult(temp)
            //     }
            //   })
            //   .catch(err => {
            //     console.log(err)
            //   })
            // }
            setSectionState((prev) => {
              return ({
                  ...prev,
                  sectionData: {
                      ...prev.sectionData,
                      ["fullNameTitle"]: valueObject?.["fullNameTitle"]
                  }
              })
            })
            if (journeyState?.journeyType === "CanaraPos" || props?.resumeJourneyData?.journeyData?.journeyType === "CanaraPos"){
              if (pageId === "PageFlexiEdgeFillProposalForm" && sectionId === "SectionFlexiEdgeFillProposalPersonalDetail"){
                const pages = journeyState.journeySteps?.pages || []
                const tempPageIndexToChange = pages.findIndex(page => page.pageId === "PageFlexiEdgeFillProposalForm")
                const tempSectionIndexToChange = pages[tempPageIndexToChange]?.sections?.findIndex(section => section.sectionId === "SectionFlexiEdgeFillProposalPersonalDetail")
                const tempNameComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "fullname")
                const tempNameComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempNameComponentGroupIndexToChange]?.components
                tempNameComponents?.forEach(nameComponent => {
                  if (valueObject?.[nameComponent?.formControlKey]){
                    nameComponent.disabled = true;
                  }
                })
                const tempEmailComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "PDemail")
                const tempEmailComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempEmailComponentGroupIndexToChange]?.components
                tempEmailComponents?.forEach(emailComponent => {
                  if (valueObject?.[emailComponent?.formControlKey]){
                    emailComponent.disabled = true;
                  }
                })
                const tempContactNoComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "LAcontactNo")
                const tempContactComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempContactNoComponentGroupIndexToChange]?.components
                tempContactComponents?.forEach(contactComponent => {
                  if (valueObject?.[contactComponent?.formControlKey]){
                    contactComponent.disabled = true;
                  }
                })
                const tempDOBComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "PDdob")
                const tempDOBComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempDOBComponentGroupIndexToChange]?.components
                tempDOBComponents?.forEach(dobComponent => {
                  if (valueObject?.[dobComponent?.formControlKey]){
                    dobComponent.disabled = true;
                  }
                })
                const tempIncomeComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "PDannualIncome")
                const tempIncomeComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempIncomeComponentGroupIndexToChange]?.components
                tempIncomeComponents?.forEach(incomeComponent => {
                  if (valueObject?.[incomeComponent?.formControlKey]){
                    incomeComponent.disabled = true;
                  }
                })
              }
              if (pageId === "PageFlexiEdgeFillProposalForm" && sectionId === "SectionFlexiEdgeFillProposalCommunicationAddress"){
                const pages = journeyState.journeySteps?.pages || []
                const tempPageIndexToChange = pages.findIndex(page => page.pageId === "PageFlexiEdgeFillProposalForm")
                const tempSectionIndexToChange = pages[tempPageIndexToChange]?.sections?.findIndex(section => section.sectionId === "SectionFlexiEdgeFillProposalCommunicationAddress")
                const tempPincodeComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "pincode")
                const tempPincodeComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempPincodeComponentGroupIndexToChange]?.components
                if (valueObject?.["pincode"]){
                  tempPincodeComponents?.forEach(pincodeComponent => {
                    pincodeComponent.disabled = true;
                  })
                }
            
                const tempStateComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "state")
                const tempStateComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempStateComponentGroupIndexToChange]?.components
                if (valueObject?.["state"]){
                  tempStateComponents?.forEach(stateComponent => {
                    stateComponent.disabled = true;
                  })
                }
                
                const tempCityComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "city")
                const tempCityComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempCityComponentGroupIndexToChange]?.components
                if (valueObject?.["city"]){
                  tempCityComponents?.forEach(cityComponent => {
                    cityComponent.disabled = true;
                  })
                }

                const tempSameComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "isYourCurrentResidentialSame")
                const tempSameComp = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempSameComponentGroupIndexToChange]?.components
                if (valueObject?.["isYourCurrentResentialSame"]){
                  tempSameComp?.forEach(cityComponent => {
                    cityComponent.disabled = false;
                  })
                }
              }
              if (pageId === "PageFlexiEdgeFillProposalForm" && sectionId === "SectionFlexiEdgeFillProposalProposerDetails"){
                const pages = journeyState.journeySteps?.pages || []
                const tempPageIndexToChange = pages.findIndex(page => page.pageId === "PageFlexiEdgeFillProposalForm")
                const tempSectionIndexToChange = pages[tempPageIndexToChange]?.sections?.findIndex(section => section.sectionId === "SectionFlexiEdgeFillProposalProposerDetails")
                const tempNameComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "fullname")
                const tempNameComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempNameComponentGroupIndexToChange]?.components
                tempNameComponents?.forEach(nameComponent => {
                  if (valueObject?.[nameComponent?.formControlKey]){
                    nameComponent.disabled = true;
                  }
                })
          
                const tempDOBComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "proposerbirthdate")
                const tempDOBComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempDOBComponentGroupIndexToChange]?.components
                tempDOBComponents?.forEach(dobComponent => {
                  if (valueObject?.[dobComponent?.formControlKey]){
                    dobComponent.disabled = true;
                  }
                })

                const tempIncomeComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "annualIncome")
                const tempIncomeComponents = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempIncomeComponentGroupIndexToChange]?.components
                tempIncomeComponents?.forEach(incomeComponent => {
                  if (valueObject?.[incomeComponent?.formControlKey]){
                    incomeComponent.disabled = true;
                  }
                })

                const tempPincodeComponentGroupIndexToChange = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups?.findIndex(cgrp => cgrp.componentId === "communicationaddress")
                const tempCountryComponent = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempPincodeComponentGroupIndexToChange]?.components?.find(cmp => cmp.formControlKey === "proposerCommunicationCountry")
                const tempPincodeComponent = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempPincodeComponentGroupIndexToChange]?.components?.find(cmp => cmp.formControlKey === "pincode")
                const tempStateComponent = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempPincodeComponentGroupIndexToChange]?.components?.find(cmp => cmp.formControlKey === "state")
                const tempCityComponent = pages[tempPageIndexToChange]?.sections[tempSectionIndexToChange]?.component_groups[tempPincodeComponentGroupIndexToChange]?.components?.find(cmp => cmp.formControlKey === "cityCommProp")
                if (tempCountryComponent){
                  tempCountryComponent.disabled = true
                }
                if (valueObject?.[tempPincodeComponent?.formControlKey]){
                  tempPincodeComponent.disabled = true
                }
                if (valueObject?.[tempStateComponent?.formControlKey]){
                  tempStateComponent.disabled = true
                }
                if (valueObject?.[tempCityComponent?.formControlKey]){
                  tempCityComponent.disabled = true
                }
              }
            }
            if(sectionState.sectionData){
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionFirstPass: true,
                }
              })
            }
            valueObject = {}
            conditionObject = {}
          }
        }
      })
  }

  //Code to fill data on API call and freeze necessary fields
  const autoFillDataAndFreeze = (pageId, sectionId) => {
    let payload = {
      _id: journeyState.journeyId,
    }
     let temp = journeyState.journeySteps
     const changeJourneySteps = (
       pageId,
       sectionId,
       componentGroup,
       componentFormControlKey,
       key,
       value
     ) => {
       try {
         let tempPageIndexToChange = temp.pages.findIndex(
           element => element.pageId === pageId
         )
         let tempSectionIndexToChange = temp.pages[
           tempPageIndexToChange
         ].sections.findIndex(element => element.sectionId === sectionId)
         let tempComponentGroupIndexToChange = temp.pages[
           tempPageIndexToChange
         ].sections[tempSectionIndexToChange].component_groups.findIndex(
           element => element.componentId === componentGroup
         )
         let tempComponentIndexToChange = temp.pages[
           tempPageIndexToChange
         ].sections[tempSectionIndexToChange].component_groups[
           tempComponentGroupIndexToChange
         ].components.findIndex(
           element => element.formControlKey === componentFormControlKey
         )
         console.log(
           tempPageIndexToChange,
           tempSectionIndexToChange,
           tempComponentGroupIndexToChange,
           tempComponentIndexToChange,
           "======>ImpTemp0"
         )
         temp.pages[tempPageIndexToChange].sections[
           tempSectionIndexToChange
         ].component_groups[tempComponentGroupIndexToChange].components[
           tempComponentIndexToChange
         ][key] = value
       } catch (err) {
         console.log(err, "=====>ErrorInPage.js===Line-152")
       }
     }
    fetchApplicationDetails(payload)
      .then(res => {
        let fetchedPageIndex = res.applicationData.findIndex(element => element.pageId === pageId)
        if (fetchedPageIndex) {
          let fetchedSectionIndex = res.applicationData[fetchedPageIndex].pageData.findIndex(element => element.sectionId === sectionId)
          if (fetchedSectionIndex !== -1) {
            let valueObject = {}
            let conditionObject = {}
            let requiredSectionData = res.applicationData[fetchedPageIndex].pageData[fetchedSectionIndex].sectionData

            /* Autofillinf Data*/
            Object.keys(requiredSectionData).forEach(element => {
              if (requiredSectionData[element]) {
                valueObject[element] = requiredSectionData[element]
                conditionObject[`${pageId}.${sectionId}.${element}`] = requiredSectionData[element]
              }
            })
            console.log(valueObject, conditionObject, "dcdvdv")

            /*Hardcoding for particular fields*/
            let lookupKeyForTitle = "title"
            let lookupKeyforProposerTitle = "title"
            if (valueObject["gender"] === "M") {
              valueObject["fullNameTitle"] = "MR"
              valueObject["title"] = "MR"
              conditionObject[`${pageId}.${sectionId}.fullNameTitle`] = "MR"
            } else if (valueObject["gender"] === "F") {
              valueObject["fullNameTitle"] = valueObject["fullNameTitle"] ? valueObject["fullNameTitle"] : ""
              valueObject["title"] = valueObject["fullNameTitle"] ? valueObject["fullNameTitle"] : ""
              lookupKeyForTitle = "title-female"
            } else if (valueObject["proposergender"] === "M") {
              valueObject["title"] = "MR"
              conditionObject[`${pageId}.${sectionId}.title`] = "MR"
            } else if (valueObject["proposergender"] === "F") {
              valueObject["title"] = valueObject["title"] ? valueObject["title"] : ""
              lookupKeyforProposerTitle = "title-female"
            }

            let lookupForAccountType = "accountTypeForProposer"
            if (res?.journeyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.country === "IN") {
              //valueObject["accountType"] = valueObject["accountType"] ? valueObject["accountType"] : ""
              lookupForAccountType = "accountTypeForProposerWithoutNRE"
            }

            let lookupKeyForIdProof = "PROOF_OF_IDENTITY_OR_AGE"
            let lookupKeyForAddProof = "ADDRESS_PROOF"
            let lookupKeyForAddProofPermanent = "ADDRESS_PROOF"
            let lookupKeyForAddProofPermanentProposer = "ADDRESS_PROOF"
            let lookupKeyForProposerIdProof = "ID_PROOF"
            let lookupKeyForProposerAddProof = "ADDRESS_PROOF"
            let lookupForResidentCountry = "residentStatus"
            if (sectionId === "personalDetailsSection") {
              if (res?.journeyData?.lifeAssuredDetails?.communicationDetails?.currentAddress?.country !== "IN") {
                valueObject["prrofIdAge"] = "01"
                conditionObject[`${pageId}.${sectionId}.prrofIdAge`] = "01"
              } else {
                if (!(res?.journeyData?.lifeAssuredDetails?.proceedWith === "ekyc" || res?.journeyData?.lifeAssuredDetails?.proceedWith === "ckyc")) {
                  valueObject["prrofIdAge"] = "03"
                  conditionObject[`${pageId}.${sectionId}.prrofIdAge`] = "03"
                  lookupKeyForIdProof = "ID_PROOF_PAN"
                }
              }
              if (res?.journeyData?.productDetails?.spouseLaDetails?.wishToSecure === "02") {
                valueObject["maritalStatus"] = "M"
                conditionObject[`${pageId}.${sectionId}.maritalStatus`] = "M"
              }

            }
            if ((sectionId === "SectionFlexiEdgeFillProposalPersonalDetail" || sectionId === "SectionFlexiEdgeFillProposalProposerDetails") && (ProductJourneyId.includes(journeyState.journeyIdFromStrapi))) {
              if (res?.journeyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.countryCodeMap && (res?.journeyData?.lifeAssuredDetails?.communicationDetails?.contactDetails?.countryCodeMap !== "+91")) {
                valueObject["ageIdentityProof"] = "01"
                valueObject["addressProof"] = "01"
                valueObject["residentialStatus"] = "Y"
                let valueForMobileNumber
                if (journeyState.journeyIdFromStrapi === "guaranteedSavingsOption") {
                  valueForMobileNumber = conditionState["PageGuaranteedSavingsCalculatePremium.SectionGuaranteedSavingsPersonelDetails.mobileNumber"]
                } else if (journeyState.journeyIdFromStrapi === "FlexiEdgeJourney") {
                  valueForMobileNumber = conditionState["PageFlexiEdgeCalculatePremium.SectionFlexiEdgeCalculatePremiumPersonalDetails.mobileNumber"]
                } else if (journeyState.journeyIdFromStrapi === "titaniumPlusJourney") {
                  valueForMobileNumber = conditionState["PageTitaniumPlusCalculateFundValue.CFSectionTitaniumPersonelDetails.mobileNumber"]
                } else if (journeyState.journeyIdFromStrapi === "alphaWealthPlanJourney") {
                  valueForMobileNumber = conditionState["AlphaWealthPlanCalculateFundValuePage.AlphaWealthPlanCFpersonelDetailsSection.mobileNumber"]
                } else if (journeyState.journeyIdFromStrapi === "guaranteedIncomeAdvantage") {
                  valueForMobileNumber = conditionState["PageGuaranteedIncomeAdvantageCalculatePremium.SectionGuaranteedIncomeAdvantagePersonelDetails.mobileNumber"]
                } else if (journeyState.journeyIdFromStrapi === "GuarateedOnePayJourney") {
                  valueForMobileNumber = conditionState["PageGuaranteedOnePayCalculatePremium.SectionGOPAPersonelDetails.mobileNumber"]
                } else if (journeyState.journeyIdFromStrapi === "insureSmart") {
                  valueForMobileNumber = conditionState["PageInsureSmartCalculateFundValue.SectionInsureSmartPersonelDetails.mobileNumber"] // Insure Smart
                } else if (journeyState.journeyIdFromStrapi === "jeevanNivesh") {
                  valueForMobileNumber = conditionState["PageJeevenNiveshCalculatePremium.SectionJeevanNiveshCalculatePremiumPersonalDetails.mobileNumber"]
                } else if (journeyState.journeyIdFromStrapi === "moneyBackAdvantage") {
                  valueForMobileNumber = conditionState["PageMoneyBackCalculatePremium.SectionMoneyBackPersonalDetails.mobileNumber"] // money Back
                } else if (journeyState.journeyIdFromStrapi === "invest4GJourney") {
                  valueForMobileNumber = conditionState["PageInvest4GCalculateFundValue.SectionInvest4GPersonelDetails.mobileNumber"] // invest 4g
                } else if (journeyState.journeyIdFromStrapi === "smartJuniorPlan") {
                  valueForMobileNumber = conditionState["PageSmartJuniorCalculatePremium.SectionSmartJuniorPersonelDetails.mobileNumber"] // smart junior
                } else if (journeyState.journeyIdFromStrapi === "secureBhavishyaJourney") {
                  valueForMobileNumber = conditionState["PageSecureBhavishyaCalculatePremium.SectionSecureBhavishyaPersonelDetails.mobileNumber"] // secure bhavishya
                } else if (journeyState.journeyIdFromStrapi === "guaranteedFortuneJourney") {
                  valueForMobileNumber = conditionState["PageGuaranteedFortuneCalculatePremium.SectionGuaranteedFortunePersonelDetails.mobileNumber"] // secure bhavishya
                } else if (journeyState.journeyIdFromStrapi === "guaranteedFutureJourney") {
                  valueForMobileNumber = conditionState["PageGuaranteedFutureCalculatePremium.SectionGuaranteedFuturePersonelDetails.mobileNumber"] // guaranteed Future
                } else if (journeyState.journeyIdFromStrapi === "guaranteedIncome4LifeJourney") {
                  valueForMobileNumber = conditionState["PageGuaranteedIncome4LifeCalculatePremium.SectionGuaranteedIncome4LifePersonelDetails.mobileNumber"] // secure bhavishya
                } else if (journeyState.journeyIdFromStrapi === "GAINjourney") {
                  valueForMobileNumber = conditionState["GAINcalculatePremiumPage.GAINpersonalDetailsSection.mobileNumber"] // secure bhavishya
                }
                valueObject["countryofbirth"] = getValueFromLookup("countryCodeToCountry", valueForMobileNumber)
                conditionObject[`${pageId}.${sectionId}.ageIdentityProof`] = "01"
                conditionObject[`${pageId}.${sectionId}.addressProof`] = "01"
                conditionObject[`${pageId}.${sectionId}.residentialStatus`] = "Y"
                conditionObject[`${pageId}.${sectionId}.countryofbirth`] = getValueFromLookup("countryCodeToCountry", valueForMobileNumber)
                lookupForResidentCountry = "residentStatus"
                valueObject["state"] = "NR"
                changeJourneySteps("PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalPersonalDetail", "currentState", "state", "lookupKey", "state")
                changeJourneySteps("PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalPersonalDetail", "citizenship", "citizenship", "disabled", false)
                changeJourneySteps("PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalPersonalDetail", "nationality", "nationality", "disabled", false)
                changeJourneySteps("PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalPersonalDetail", "taxResidenceCountry", "taxResidenceCountry", "disabled", false)
              }else {
                if (res.journeyData?.agentDetails?.rmLedJourneyInd === "01") {
                  valueObject["residentialStatus"] = "N"
                  conditionObject[`${pageId}.${sectionId}.residentialStatus`] = "N"
                  valueObject["citizenship"] = "IN"
                  conditionObject[`${pageId}.${sectionId}.citizenship`] = "IN"
                  valueObject["nationality"] = "IN"
                  conditionObject[`${pageId}.${sectionId}.nationality`] = "IN"
                  valueObject["taxResidenceCountry"] = "IN"
                  conditionObject[`${pageId}.${sectionId}.taxResidenceCountry`] = "IN"
                }
                if (!(res?.journeyData?.lifeAssuredDetails?.kycVerified === true || res?.journeyData?.lifeAssuredDetails?.ckycVerified === true)) {
                  // valueObject["ageIdentityProof"] = "03"
                  // conditionObject[`${pageId}.${sectionId}.ageIdentityProof`] = "03"
                  // lookupKeyForIdProof = "ID_PROOF_PAN"
                } else {
                  lookupKeyForAddProof = "ADDRESS_PROOF_VERIFIED"
                  lookupKeyForIdProof = "ID_PROOF"
                }
                if (!(res?.journeyData?.proposerDetails?.kycVerified === true || res?.journeyData?.proposerDetails?.ckycVerified === true)) {
                  // valueObject["ageIdentityProof"] = "03"
                  // conditionObject[`${pageId}.${sectionId}.ageIdentityProof`] = "03"
                  // lookupKeyForIdProof = "ID_PROOF_PAN"
                } else {
                  if(res?.journeyData?.proposerDetails?.addressProceedWith !== "permanentAddress")
                      lookupKeyForProposerAddProof = "ADDRESS_PROOF_VERIFIED"
                }
              }

              // for proposer, if the country code is not of india, then preselect, ageprood and id proof as passport and residential status field as nri 
              if (res?.journeyData?.proposerDetails?.communicationDetails?.contactDetails?.countryCode && (res?.journeyData?.proposerDetails?.communicationDetails?.contactDetails?.countryCode !== "+91")) {
                const countryFromCountryCode = getValueFromLookup("countryCodeToCountry", res?.journeyData?.proposerDetails?.communicationDetails?.contactDetails?.countryCode) || "IN"
                valueObject["idProof"] = "01"
                valueObject["currentAddressProof"] = "01"
                valueObject["isproposer"] = "Y"
                valueObject["proposerCountryOfBirth"] = countryFromCountryCode
                valueObject["taxResidenceCountryProposer"] = countryFromCountryCode
                valueObject["proposerCurrentCountryResidence"] = countryFromCountryCode
                conditionObject[`${pageId}.${sectionId}.idProof`] = "01"
                conditionObject[`${pageId}.${sectionId}.currentAddressProof`] = "01"
                conditionObject[`${pageId}.${sectionId}.isproposer`] = "Y"
                conditionObject[`${pageId}.${sectionId}.proposerCountryOfBirth`] = getValueFromLookup("countryCodeToCountry", res?.journeyData?.proposerDetails?.communicationDetails?.contactDetails?.countryCode)
                lookupForResidentCountry = "residentStatus"
              }else{
                const countryFromCountryCode = "IN"
                valueObject["proposerCountryOfBirth"] = countryFromCountryCode
                valueObject["taxResidenceCountryProposer"] = countryFromCountryCode
                valueObject["proposerCurrentCountryResidence"] = countryFromCountryCode
                conditionObject[`${pageId}.${sectionId}.proposerCountryOfBirth`] = countryFromCountryCode
              } 

            }

            if (sectionId === "SectionFlexiEdgeFillProposalCommunicationAddress") {
              if (res?.journeyData?.lifeAssuredDetails?.proceedWith === "ekyc" || res?.journeyData?.lifeAssuredDetails?.proceedWith === "ckyc") {
                if ((res?.journeyData?.lifeAssuredDetails?.proceedWith === "ekyc" || res?.journeyData?.lifeAssuredDetails?.proceedWith === "ckyc") && res?.journeyData?.lifeAssuredDetails?.addressProceedWith === "permanentAddress") {
                  lookupKeyForAddProof = "ADDRESS_PROOF"
                  lookupKeyForAddProofPermanent = "ADDRESS_PROOF_VERIFIED"
                } else {
                  lookupKeyForAddProof = "ADDRESS_PROOF_VERIFIED"
                }
              }
            }
            if (sectionId === "SectionFlexiEdgeFillProposalProposerDetails") {
              if (res?.journeyData?.proposerDetails?.proceedWith === "ekyc" || res?.journeyData?.proposerDetails?.proceedWith === "ckyc") {
                if ((res?.journeyData?.proposerDetails?.proceedWith === "ekyc"  || res?.journeyData?.proposerDetails?.proceedWith === "ckyc") && res?.journeyData?.proposerDetails?.addressProceedWith === "permanentAddress") {
                  lookupKeyForAddProofPermanentProposer = "ADDRESS_PROOF_VERIFIED"
                }
              }
            }

            /*Hardcoding for particular fields Ends*/
            if(conditionState["AlphaWealthPlanCalculateFundValuePage.AlphaWealthPlanCFpersonelDetailsSection.mobileNumber"]==="+91" ||
              conditionState["GAINcalculatePremiumPage.GAINpersonalDetailsSection.mobileNumber"]==="+91" ||
              conditionState["PageGuaranteedFortuneCalculatePremium.SectionGuaranteedFortunePersonelDetails.mobileNumber"]==="+91" ||
              conditionState["PageGuaranteedFutureCalculatePremium.SectionGuaranteedFuturePersonelDetails.mobileNumber"]==="+91" ||
              conditionState["PageIGFPPlusCalculatePremium.SectionIGFPPlusPersonelDetails.mobileNumber"]==="+91" ||
              conditionState["PageTitaniumPlusCalculateFundValue.CFSectionTitaniumPersonelDetails.mobileNumber"]==="+91"
            ){
              valueObject["residentialStatus"] = "N"
               changeJourneySteps("PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalPersonalDetail", "residentialStatus", "residentialStatus", "disabled", false);
            }else{
              valueObject["residentialStatus"] = "Y"
               changeJourneySteps("PageFlexiEdgeFillProposalForm", "SectionFlexiEdgeFillProposalPersonalDetail", "residentialStatus", "residentialStatus", "disabled", false);
            }
            if (pageId === "PageFlexiEdgeFillProposalForm"){
              handleSATPAPage(res?.journeyData?.productDetails?.spouseLaDetails?.wishToSecure)
            }

            setSectionState(prev => {
              return {
                ...prev,
                sectionId: sectionId,
                sectionData: {
                  ...prev.sectionData,
                  ...valueObject
                }
              }
            })
            setConditionState(prev => {
              return {
                ...prev,
                ...conditionObject
              }
            })
            /* AutoFillingData */

            /*Freezing Data */

            if (firstPassForFreezingDataSections[sectionId]) {
              let temp = journeyState.journeySteps
              let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
              let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
              let componentGroups = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups
              console.log("23232323232332", componentGroups)
              componentGroups.forEach((componentGroup, componentGroupIndex) => {
                componentGroup.components.forEach((component, componentIndex) => {
                  // freezeJson?.[journeyState.journeyIdFromStrapi]?.[pageId]?.[sectionId]?.forEach(element => {
                  Object.keys(valueObject)?.forEach(element => {
                    if (element === component.formControlKey && element !== "residentialStatus") { //exclude residentialStatus
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = true
                    }
                    if (element === component.formControlKey && element === "profesionalOccupationEmployerOrganization") {
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                    }
                    if (element === component.formControlKey && (element === "fathersFirstName" || element === "fathersMiddleName" || element === "fathersLastName" || element === "mothersFirstName" || element === "mothersMiddleName" || element === "mothersLastName")) {
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                    }
                    if (element === component.formControlKey && (element === "proposerfathersFirstName" || element === "proposerfathersMiddleName" || element === "proposerfathersLastName" || element === "proposermothersFirstName" || element === "proposermothersMiddleName" || element === "proposermothersLastName")) {
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                    }
                    if (element === component.formControlKey && element === "fullNameTitle") {
                      console.log("23232323232332", element, tempPageIndexToChange, tempPageIndexToChange, tempPageIndexToChange, componentIndex)
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["lookupKey"] = lookupKeyForTitle
                      if (valueObject["gender"] !== "M") {
                        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                      }
                    }
                    if (element === component.formControlKey && element === "accountType") {
                      console.log("23232323232332", element, tempPageIndexToChange, tempPageIndexToChange, tempPageIndexToChange, componentIndex)
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["lookupKey"] = lookupForAccountType
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                    }
                    if (element === component.formControlKey && element === "aadharNumber") {
                      console.log("23232323232332", element, tempPageIndexToChange, tempPageIndexToChange, tempPageIndexToChange, componentIndex)
                      if(valueObject["aadharNumber"]){
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["regex"] = "/^[a-zA-Z0-9]+$/"
                      }
                    }
                    if( element === component.formControlKey && element === "permanentAddressProof"){
                      console.log("23232323232332", element,tempPageIndexToChange,tempPageIndexToChange, tempPageIndexToChange,componentIndex)
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["lookupKey"] = lookupKeyForAddProofPermanent
                    }
                    if( element === component.formControlKey && element === "permanentAddressProof" && sectionId === "SectionFlexiEdgeFillProposalProposerDetails"){
                      console.log("23232323232332", element,tempPageIndexToChange,tempPageIndexToChange, tempPageIndexToChange,componentIndex)
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["lookupKey"] = lookupKeyForAddProofPermanentProposer
                    }
                    if (element === component.formControlKey && element === "title") {
                      console.log("23232323232332", element, tempPageIndexToChange, tempPageIndexToChange, tempPageIndexToChange, componentIndex)
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["lookupKey"] = lookupKeyforProposerTitle
                      if (valueObject["proposergender"] !== "M") {
                        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                      }
                    }
                    if (element === component.formControlKey && element === "residentialStatus" && res.journeyData?.agentDetails?.rmLedJourneyInd !== "01") {
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["lookupKey"] = lookupForResidentCountry
                      console.log("23232323232332", element, tempPageIndexToChange, tempPageIndexToChange, tempPageIndexToChange, componentIndex)
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                    }
                    if (element === component.formControlKey && element === "isproposer") {
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["lookupKey"] = lookupForResidentCountry
                      console.log("23232323232332", element, tempPageIndexToChange, tempPageIndexToChange, tempPageIndexToChange, componentIndex)
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                    }
                    if (element === component.formControlKey && element === "countryofbirth") {

                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                    }
                    if (element === component.formControlKey && element === "proposerCountryOfBirth") {

                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                    }
                    if (element === component.formControlKey && element === "isYourCurrentResentialSame") {

                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                      
                    }
                    if (element === component.formControlKey && element === "taxResidenceCountryProposer") {

                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                    }
                    if (element === component.formControlKey && (element === "prrofIdAge" || element === "ageIdentityProof")) {
                      console.log("23232323232332", element, tempPageIndexToChange, tempPageIndexToChange, tempPageIndexToChange, componentIndex)
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["lookupKey"] = lookupKeyForIdProof
                      if (valueObject[element] === "03") {
                        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                      }
                    }
                    if (element === component.formControlKey && (element === "idProof")) {
                      console.log("23232323232332", element, tempPageIndexToChange, tempPageIndexToChange, tempPageIndexToChange, componentIndex)
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["lookupKey"] = lookupKeyForProposerIdProof
                      if (valueObject[element] === "03") {
                        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                      }
                    }
                    if (element === component.formControlKey && (element === "PRAddressProof" || element === "addressProof")) {
                      console.log("23232323232332", element, tempPageIndexToChange, tempPageIndexToChange, tempPageIndexToChange, componentIndex)
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["lookupKey"] = lookupKeyForAddProof
                      if (valueObject[element] === "01") {
                        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                      }
                    }
                    if (element === component.formControlKey && (element === "currentAddressProof")) {
                      console.log("23232323232332", element, tempPageIndexToChange, tempPageIndexToChange, tempPageIndexToChange, componentIndex)
                      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["lookupKey"] = lookupKeyForProposerAddProof
                      if (valueObject[element] === "01") {
                        temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[componentGroupIndex].components[componentIndex]["disabled"] = false
                      }
                    }

                  })
                })
              })
              if(sectionId === "SectionFlexiEdgeFillProposalCommunicationAddress"){
                if(valueObject["isYourCurrentResentialSame"] === "N" || valueObject["city"] === "OTHERS" || valueObject["cityPermanent"] === "OTHERS"){
                  setSectionState(prev => {
                    return {
                      ...prev,
                      sectionId: sectionId,
                      sectionData: {
                        ...prev.sectionData,
                        ...valueObject
                      }
                    }
                  })
                }
              }
              if(sectionId === "SectionFlexiEdgeFillProposalProposerDetails"){
                if(valueObject["IsCurrentAddresssameasPermannentAddress"] === "N" || valueObject["cityCommProp"] === "OTHERS" || valueObject["proposerCity"] === "OTHERS"){
                  setSectionState(prev => {
                    return {
                      ...prev,
                      sectionId: sectionId,
                      sectionData: {
                        ...prev.sectionData,
                        ...valueObject
                      }
                    }
                  })
                }
              }
              if(sectionId === "SectionFlexiEdgeFillProposalProposerDetails"){
                  setSectionState(prev => {
                    return {
                      ...prev,
                      sectionId: sectionId,
                      sectionData: {
                        ...prev.sectionData,
                        ...valueObject
                      }
                    }
                  })
                }
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionId: sectionId,
                  sectionData: {
                    ...prev.sectionData,
                    ...valueObject
                  }
                }
              })

              if (sectionId === "residenceDetailsSection") {
                let fillProposalPageId
                if (journeyState.journeyIdFromStrapi === "iSelectJourney") {
                  fillProposalPageId = "fillProposalForm"
                } else if (journeyState.journeyIdFromStrapi === "ISelect360Journey") {
                  fillProposalPageId = "pageISelect360FillProposalForm"
                } else {
                  return
                }
                let tempPageIndexFillProposalForm = temp.pages.findIndex(element => element.pageId === fillProposalPageId)
                let tempSectionIndexFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections.findIndex(element => element.sectionId === "residenceDetailsSection")
                let tempComponentGroupFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "pinCode")
                let tempComponentFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components.findIndex(element => element.formControlKey === "pincode")
                console.log(tempPageIndexFillProposalForm, tempSectionIndexFillProposalForm, tempComponentGroupFillProposalForm, tempComponentFillProposalForm, "dfefd1278")

                if (valueObject["reisdentialCurrentCountry"] !== "IN") {
                  temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["min_len"] = 3
                  temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["max_length"] = 9
                  temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["regex"] = "/^[a-zA-Z0-9 \-\/]+$/"
                  temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupFillProposalForm].components[tempComponentFillProposalForm]["__typename"] = "ComponentCmpTagTextString"
                }
              }
              if (sectionId === "spouseQuestionnaire") {
                let tempPageIndexFillProposalForm = temp.pages.findIndex(element => element.pageId === "pageISelect360FillProposalForm")
                let tempSectionIndexFillProposalForm = temp.pages[tempPageIndexFillProposalForm].sections.findIndex(element => element.sectionId === "spouseQuestionnaire")
                let tempComponentGroupNameOfEmployer = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "orgainsationName-order-13")
                let tempComponentGroupNatureOfIndustry = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "NatureOrganisation-order-14")
                let tempComponentGroupPanNumber = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups.findIndex(element => element.componentId === "pan-order-16")
                let tempComponentNameOfEmployer = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupNameOfEmployer].components.findIndex(element => element.formControlKey === "orgainsationName")
                let tempComponentNatureOfIndustry = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupNatureOfIndustry].components.findIndex(element => element.formControlKey === "NatureOrganisation")
                let tempComponentPanNumber = temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupPanNumber].components.findIndex(element => element.formControlKey === "pan")

                let spouseOccupationType = conditionState["PageISelect360CalculatePremium.iSelect360CPSpouseCoverDetails.CPSpouseOccupationQuestion"]
                if (spouseOccupationType && (spouseOccupationType === "NW")) {
                  temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupNameOfEmployer].components[tempComponentNameOfEmployer]["required"] = false
                  temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupNatureOfIndustry].components[tempComponentNatureOfIndustry]["required"] = false
                  temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupPanNumber].components[tempComponentPanNumber]["required"] = false
                  console.log("spouseOccupationType---NW");
                  setErrorState(prev => {
                    return {
                      ...prev,
                      ["orgainsationName"]: "",
                      ["NatureOrganisation"]: "",
                      ["pan"]: "",
                    }
                  })
                } else {
                  temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupNameOfEmployer].components[tempComponentNameOfEmployer]["required"] = true
                  temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupNatureOfIndustry].components[tempComponentNatureOfIndustry]["required"] = true
                  temp.pages[tempPageIndexFillProposalForm].sections[tempSectionIndexFillProposalForm].component_groups[tempComponentGroupPanNumber].components[tempComponentPanNumber]["required"] = true
                  console.log("spouseOccupationType---W");
                }

              }
              setJourneyState(prev => {
                return ({
                  ...prev,
                  journeySteps: temp
                })
              })
            }
            setFirstPassForFreezingDataSections(prev => {
              return ({
                ...prev,
                [sectionId]: false
              })
            })

            if(sectionState.sectionData){
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionFirstPass: true,
                }
              })
            }
            if(valueObject["aadharNumber"]){
              setErrorState(prev => {
                return {
                  ...prev,
                  ["aadharNumber"]: ""
                }
              })
            }

            valueObject = {}
          }
        }
      })
      .catch(err => {
        console.log(err)
      })
  }

  //Code to Check Nominee Percetage totals 100%
  const checkNomineePercentage = () => {
    // For Iselect Plans
    if (sectionState.sectionData["nomineePercent"]) {
      let values = sectionState.sectionData["nomineePercent"]
      if (values) {
        let total
        if (values.length === 1) {
          total = parseInt(values[0])
        } else {
          if (values.length > 1) {
            total = values?.reduce((a, b) => {
              return parseInt(a) + parseInt(b)
            })
          }
        }
        let temp
        let temp1
        if (errorState["nomineePercent"]) {
          temp1 = errorState["nomineePercent"]
        } else {
          temp1 = []
        }
        if (total !== 100) {
          const numberOfNominees = sectionState.sectionData["nomineePercent"].length
          for (let i = 0; i < numberOfNominees; i++) {
            temp1[i] = "Total of Nominee Percentages must be 100"
          }
          temp = temp1
          setErrorState(prev => {
            return {
              ...prev,
              ["nomineePercent"]: temp,
            }
          })
        } else {
          const numberOfNominees = sectionState.sectionData["nomineePercent"].length
          for (let i = 0; i < numberOfNominees; i++) {
            temp1[i] = ""
          }
          temp = temp1
          setErrorState(prev => {
            return {
              ...prev,
              ["nomineePercent"]: temp,
            }
          })
        }
      }

    }
    // For CPF plan
    else if (sectionState.sectionData["nomineePercentCPF"]) {
      let values = sectionState.sectionData["nomineePercentCPF"]
      if (values) {
        let total
        if (values.length === 1) {
          total = parseInt(values[0])
        } else {
          if (values.length > 1) {
            total = values?.reduce((a, b) => {
              return parseInt(a) + parseInt(b)
            })
          }
        }
        let temp
        let temp1
        if (errorState["nomineePercentCPF"]) {
          temp1 = errorState["nomineePercentCPF"]
        } else {
          temp1 = []
        }
        if (total !== 100) {
          const numberOfNominees = sectionState.sectionData["nomineePercentCPF"].length
          for (let i = 0; i < numberOfNominees; i++) {
            temp1[i] = "Total of Nominee Percentages must be 100"
          }
          temp = temp1
          setErrorState(prev => {
            return {
              ...prev,
              ["nomineePercentCPF"]: temp,
            }
          })
        } else {
          const numberOfNominees = sectionState.sectionData["nomineePercentCPF"].length
          for (let i = 0; i < numberOfNominees; i++) {
            temp1[i] = ""
          }
          temp = temp1
          setErrorState(prev => {
            return {
              ...prev,
              ["nomineePercentCPF"]: temp,
            }
          })
        }
      }

    }
  }

  //Code to call BI for product pages
  const saveApplicationAndCallBi = (formControlKey, value, previousSelectedValue) => {
    console.log(formControlKey, "dsfdfd")
    if (!showMainButtonFlexiEdgePlan) {
      return
    }
    let isValidSection = Object.keys(errorState).every(element => {
      if (element === "errorFromBI") {
        return true
      }
      if (Array.isArray(errorState[element])) {
        return errorState[element].every(subElement => {
          return subElement === ""
        })
      } else {
        if (element === formControlKey && value) {
          return true
        } else {
          return errorState[element] === ""
        }

      }
    })
    if (!isValidSection) {
      return
    }
    if (callBiKeyJson["keysTOCallOn"][sections[currentSectionIndex].sectionId] &&
      callBiKeyJson["keysTOCallOn"][sections[currentSectionIndex].sectionId].includes(formControlKey)) {
      let sectionStateToPass = sectionState
      sectionStateToPass.sectionData[formControlKey] = value
      if (!sectionStateToPass.sectionId) {
        sectionStateToPass.sectionId = sections[currentSectionIndex].sectionId
      }
      let pageData = pageState.pageData.filter(
        element => element.sectionId !== sectionState.sectionId
      )
      let journeyData = journeyState.journeyData.filter(
        element =>
          element.pageId !== props.pages[props.currentPageIndex].pageId
      )
      setPageState(prev => {
        return {
          ...prev,
          pageData: [...pageData, sectionStateToPass], // adding new section
        }
      })

      let LoadPaylod = [
        ...journeyData,
        {
          pageId: props.pages[props.currentPageIndex].pageId,
          pageData: [...pageData, sectionStateToPass],
        },
      ]
      console.log(LoadPaylod, "loadPayload")
      if (formControlKey === "CPCustomizePlanPremiumPaymentTerm") {
        setJourneyState(prev => {
          return ({
            ...prev,
            paymentFrequency: sectionState.sectionData["CPCustomizePlanPaymentFrequency"]
          })
        })
      }
      else if (formControlKey === "iSelect360CPCustomizePlanPremiumPaymentTerm") {
        setJourneyState(prev => {
          return ({
            ...prev,
            paymentFrequency: sectionState.sectionData["iSelect360CPCustomizePlanPaymentFrequency"]
          })
        })
      }
      if (formControlKey === "CPCustomizePlanPaymentFrequency" || formControlKey === "iSelect360CPCustomizePlanPaymentFrequency") {
        setJourneyState(prev => {
          return ({
            ...prev,
            paymentFrequency: value
          })
        })
      }
      if (formControlKey === "gstWaiverInd") {
        setJourneyState(prev => {
          return ({
            ...prev,
            gstWaiverInd: value ?? "N"
          })
        })
      }

      //console.log(firstLoadPaylod)
      let sendPayload = {
        applicationData: LoadPaylod,
        journeyData: {
          _id: journeyState.journeyId,
          // lastPage: getLastPageAndLastSection(props.currentPageIndex, currentSectionIndex, sections.length).lastPage,
          // lastSection: getLastPageAndLastSection(props.currentPageIndex, currentSectionIndex, sections.length).lastSection,
          lastPageCode: props.pageId,
          lastSectionCode: sections[currentSectionIndex].sectionId,
          journeyCode: findCurrentJourneyCode(props.pageId, sections[currentSectionIndex].sectionId),
          applicationNo: journeyState.applicationNo,
          illustrationNumber: journeyState.illustrationNumber,
          proposalEntryId: journeyState.proposalEntryId,
          planOption: journeyState.planOption,
          journeyIdFromStrapi: journeyState.journeyIdFromStrapi,
          premium: journeyState.premium,
          channel: journeyState.channel,
          paymentFrequency: journeyState.paymentFrequency
        },
      }
      let toCallBi
      if (sections[currentSectionIndex].sectionId === "CPSpouseCoverDetails"
        || sections[currentSectionIndex].sectionId === "CPOptionInBuiltCoversSection"
        || sections[currentSectionIndex].sectionId === "iSelect360CPOptionalInBuilt"
        || sections[currentSectionIndex].sectionId === "iSelect360CPSpouseCoverDetails"
        || sections[currentSectionIndex].sectionId === "sectionFlexiEdgeCustomizeYourPlan"
        || sections[currentSectionIndex].sectionId === "GAINchooseYourPlan"
        || sections[currentSectionIndex].sectionId === "CFSectionInvestmentDetails"
        || sections[currentSectionIndex].sectionId === "AlphaWealthPlanInvestmentDetailsSection") {
        console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa", sections[currentSectionIndex].sectionId);
        let keysToCheck = callBiKeyJson["keysToCheck"][sections[currentSectionIndex].sectionId][formControlKey]
        console.log(keysToCheck, "keysToCheck")
        if (Array.isArray(keysToCheck)) {
          toCallBi = keysToCheck?.every(key => {
            if (!sectionStateToPass.sectionData[key]) {
              return false
            } else {
              return sectionStateToPass.sectionData[key] !== ""
            }
          })
        } else {
          console.log("previousSelectedValue", previousSelectedValue)
          if (previousSelectedValue || value) {
            if (value) {
              toCallBi = keysToCheck?.[value]?.every(key => {
                if (!sectionStateToPass.sectionData[key]) {
                  return false
                } else {
                  return sectionStateToPass.sectionData[key] !== ""
                }
              })
            } else {
              toCallBi = keysToCheck?.[previousSelectedValue]?.every(key => {
                if (!sectionStateToPass.sectionData[key]) {
                  return false
                } else {
                  return sectionStateToPass.sectionData[key] !== ""
                }
              })
            }

          } else {
            toCallBi = true
          }
        }
      } else {
        toCallBi = true
      }
      console.log(toCallBi, "toCallBi")
      if (toCallBi) {
        saveApplication(sendPayload).then(res => {
          // console.log(res)
          let payload = {
            journeyId: journeyState.journeyId
          }
          generateBI(payload).then(res => {
            console.log(res, "eefe")
            if (res.data.BIJson) {
              if(sections[currentSectionIndex].sectionId === "GAINchooseYourPlan"){
                setSectionState(prev => {
                  return {
                    ...prev,
                    sectionData: {
                      ...prev.sectionData,
                      ["GAINsumAssured"]: Math.round(Number(sectionState.sectionData["GAINmultipleFactor"]) * JSON.parse(res.data.BIJson)[0]?.ANN_PREM_YEARLY)
                    },
                  }
                })
                setErrorState(prev => {
                  return {
                    ...prev,
                    ["errorFromBI"]: "",
                  }
                })
              } else {
                console.log("inside if")
                setSectionState(prev => {
                  return {
                    ...prev,
                    sectionData: {
                      ...sectionState.sectionData,
                      sumAssured: JSON.parse(res.data.BIJson)[0].SA ? JSON.parse(res.data.BIJson)[0].SA.toFixed(2) : ''
                    }
                  }
                })
                setJourneyState(prev => {
                  return ({
                    ...prev,
                    premium: ((journeyState.journeyIdFromStrapi === "FlexiEdgeJourney" ? Math.round(JSON.parse(res.data.BIJson)?.[0].MODAL_PREM) : (res?.data?.finalKeys?.PREMIUM)) || 0),
                  })
                })
                setErrorState(prev => {
                  return {
                    ...prev,
                    ["errorFromBI"]: "",
                  }
                })
              }
            } else {
              if (res.data.InputValidationStatus && res.data.InputValidationStatus[0]?.ErrorMessage) {
                let str = res.data.InputValidationStatus[0]?.ErrorMessage.map(el => el.value).join(',')
                setErrorState(prev => {
                  return {
                    ...prev,
                    ["errorFromBI"]: str,
                  }
                })
              } else {
                setErrorState(prev => {
                  return {
                    ...prev,
                    ["errorFromBI"]: res.data.Message,
                  }
                })
              }
            }
          })
        })
          .catch(err => {
            console.log("error in save application of save application and call BI function")
          })
      }
    }
  }

  const fullNameConverter = (firstName, middleName, lastName) => {
    let fullName
    if(firstName && middleName && lastName){
      return fullName = firstName + " " + middleName + " " + lastName
    }else if(firstName && lastName){
      return fullName = firstName + " " + lastName
    }else if(firstName &&  middleName){
      return fullName = firstName + " " + middleName
    }else if(firstName){
      return fullName = firstName
    }else{
      return ""
    }
  }

  /*Helper FUnction Ends*/

  //Code to handlePrevious Button Click
  const handlePreviousClick = () => {
    //this function runs on previous button click
    setShowError(false)
    setErrorState({})
    setCallBi(true)

    try {
      const payload = {
        journeyId: journeyState.journeyId, 
        buttonClicked:  "Previous", 
      };
      updateUserTrackerDetails(payload)
        .then((response) => {
          if (response?.status) {
            console.log("UserTracker updated successfully:", response.message);
          } else {
            console.error("Error in updating UserTracker:", response?.message);
          }
        })
        .catch((error) => {
          console.error("Error in updateUserTrackerDetails API call:", error);
        })
    } catch (error) {
      console.error("Error in handlePrevious:", error);
    }

    let journeyFormatData = applicationDataInJourneyFormat()
    DataLayerIntegration(journeyFormatData, "previous", sections?.[currentSectionIndex]?.sectionId,"", journeyState)

    let keysToRemoveFromConditionState = {}
    if (sectionState.sectionId === "CPOptionInBuiltCoversSection" || sectionState.sectionId === "iSelect360CPOptionalInBuilt"
     || sectionState.sectionId === "SectionFlexiEdgeFillProposalPersonalDetail" || sectionState.sectionId === "SectionFlexiEdgeFillProposalCommunicationAddress"
     || sectionState.sectionId === "SectionFlexiEdgeFillproposalOccupationDetails" || sectionState.sectionId === "SectionFlexiEdgeFillProposalNomineeDetails"
     || sectionState.sectionId === "FlexiEdgeFillProposalAppointeeSection" || sectionState.sectionId === "SectionFlexiEdgeFillProposalProposerDetails") {
      Object.keys(sectionState.sectionData).forEach(key => {
        keysToRemoveFromConditionState[`${pageState.pageId}.${sectionState.sectionId}.${key}`] = ""
      })
    }
    console.log(keysToRemoveFromConditionState, 'erefrrgrg')

    //handeling section movement
    if (currentSectionIndex <= 0) {
      // condition to move to previous page

      if (props.currentPageIndex - 1 >= 0) {
        let foundPage = journeyState.journeyData.find(
          element => element.pageId === pageState.pageId
        )
        //console.log(foundPage, "foundPage")
        if (foundPage) {
          let newJourneyData = journeyState.journeyData.filter(
            element => element.pageId !== foundPage.pageId
          )
          setJourneyState(prev => {
            return {
              ...prev,
              journeyData: newJourneyData,
            }
          })
          foundPage = []
        }

        //to add current page to journey context
        setJourneyState(prev => {
          return {
            ...prev,
            journeyData: [...prev.journeyData, pageState],
          }
        })
        props.setCurrentPageIndex(prev => prev - 1) // to change page
        setCurrentSectionIndex(
          props.pages[props.currentPageIndex - 1].sections.length - 1
        ) // to render last section of previous page

        //picking previous page data from journey context
        journeyState.journeyData.map((element, index) => {
          if (
            element.pageId === props.pages[props.currentPageIndex - 1].pageId
          ) {
            setPageState(prev => {
              return {
                ...prev,
                pageId: element.pageId,
                pageData: element.pageData,
              }
            })
          } // picking last section of previous page
          element.pageData.map((section, index) => {
            if (
              section.sectionId ===
              props.pages[props.currentPageIndex - 1].sections[
                props.pages[props.currentPageIndex - 1].sections.length - 1
              ].sectionId
            ) {
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionId: section.sectionId,
                  sectionData: section.sectionData,
                }
              })
            }
          })
        })
      }
    } else {
      // condition of same page
      setCurrentSectionIndex(prev => prev - 1) // this moves to previous section on same page
      setSectionState({
        sectionId: null,
        sectionFirstPass: null,
        sectionData: {},
      })

      //handeling context change
      if (pageState.pageId === props.pageId) {
        pageState.pageData.map((element, index) => {
          if (
            element.sectionId === sections[currentSectionIndex - 1]?.sectionId // setting section context from page context
          ) {
            setSectionState(prev => {
              return {
                ...prev,
                sectionId: element.sectionId,
                sectionData: element.sectionData,
              }
            })
          }
        })
      }
      console.log(sectionState, "sectionState previous")
      console.log(pageState, "pageState previous")
      console.log(journeyState, "journeyState previous")
    }
    setConditionState(prev => {
      return {
        ...prev,
        ...keysToRemoveFromConditionState
      }
    })
    keysToRemoveFromConditionState = {}

    setJourneyState(prev => {
      return {
        ...prev,
        lastPage: props.currentPageIndex,
        lastSection: currentSectionIndex,
        lastPageCode: props.pageId,
        lastSectionCode: sections[currentSectionIndex]?.sectionId,
        journeyCode: findCurrentJourneyCode(props.pageId, sections[currentSectionIndex]?.sectionId)
      }
    })
    //console.log(journeyState, "agete jkdcehbce")
  }
  //Code to Handle Submit Button Click
  const handleSubmit = async () => {
    console.log(conditionState, "condition state")
    console.log(journeyState, "journey state")
    console.log(sectionState);
    // errorToastr('validation error')
    console.log(errorState, "inpage")

    // SectionGOPAPersonelDetails
    const sectionIdToChange = [
      "SectionFlexiEdgeCalculatePremiumPersonalDetails",
      "CFSectionTitaniumPersonelDetails",
      "SectionGuaranteedSavingsPersonelDetails",
      "SectionGOPAPersonelDetails",
      "SectionGuaranteedIncomeAdvantagePersonelDetails",
      "SectionInsureSmartPersonelDetails",
      "SectionMoneyBackPersonalDetails",
      "SectionJeevanNiveshCalculatePremiumPersonalDetails",
      "SectionInvest4GPersonelDetails",
      "SectionSmartJuniorPersonelDetails",
      "SectionSecureBhavishyaPersonelDetails",
      "SectionGuaranteedFuturePersonelDetails"
    ]

    if (props.pageId === "PageGuaranteedFutureCalculatePremium" && sections[currentSectionIndex].sectionId === "SectionGuaranteedFuturePersonelDetails" && props.showFirstSectionFields === true) {
      console.info(sectionState)
      const isLaPrSame  = sectionState?.sectionData['GOPAslifetobeAssuredandProposer']
      const educationalQualification = sectionState?.sectionData['GOPAeducationQualification']
      if (isLaPrSame === "Y" && (educationalQualification === "5" || educationalQualification === "6")){
        errorToastr("Minimum educational qualification should be 10th standard")
        return;
      }
    }
   
    if (props.pageId === "PageGuaranteedFutureCalculatePremium" && sections[currentSectionIndex].sectionId === "SectionGuaranteedFuturePersonelDetails") {
      const educationalQualification = sectionState?.sectionData['GOPAeducationQualification']
      console.info(sectionState)
      const isLaPrSame  = sectionState?.sectionData['GOPAslifetobeAssuredandProposer']
      if (isLaPrSame === "Y" && (educationalQualification === "5" || educationalQualification === "6")){
        errorToastr("Minimum educational qualification should be 10th standard")
        return;
      }
      if (isLaPrSame === "N"){
        const proposerEducationalQualification = sectionState?.sectionData['GOPAproposerEducationalQualification']
        if (proposerEducationalQualification === "5" || proposerEducationalQualification === "6"){
          errorToastr("Minimum educational qualification should be 10th standard")
          return;
        }
      }
    }

    if (sectionIdToChange.includes(sections[currentSectionIndex].sectionId) && props.showFirstSectionFields === true) {
      let dobComponent
      let age
      if (sections[currentSectionIndex].sectionId === "SectionFlexiEdgeCalculatePremiumPersonalDetails" || sections[currentSectionIndex].sectionId === "CFSectionTitaniumPersonelDetails") {
        dobComponent = "dateOfBirth"
        age = getAge(sectionState.sectionData.dateOfBirth)
      } else {
        dobComponent = "GOPAdob"
        age = getAge(sectionState.sectionData.GOPAdob)
      }
      if ((sectionState.sectionData.GOPAslifetobeAssuredandProposer === 'Y' || sectionState.sectionData.islifetobeAssuredandProposer === 'Y') && age < 18) {
        setErrorState(prev => {
          return {
            ...prev,
            [dobComponent]: "Please select proposer because LA is minor"
          }
        })
        errorToastr('Please select proposer because LA is minor')
        return
      } else {
        if (!sectionState.sectionData?.[dobComponent]) {
          setErrorState(prev => {
            return {
              ...prev,
              [dobComponent]: "Please enter Date of Birth"
            }
          })
        } else {
          setErrorState(prev => {
            return {
              ...prev,
              [dobComponent]: ""
            }
          })
        }
      }
    }
    if (["nomineeDetailsSection", "SectionFlexiEdgeFillProposalNomineeDetails"].includes(sections[currentSectionIndex].sectionId)) {
      checkNomineePercentage()
    }
    let isValidSection = Object.keys(errorState).every(element => {
      if (Array.isArray(errorState[element])) {
        return errorState[element].every(subElement => {
          return subElement === ""
        })
      } else {
        return errorState[element] === ""
      }
    })
    if (sections[currentSectionIndex].sectionId === "SectionFlexiEdgeCustomizeYourPlan" && !sectionState.sectionData['sumAssured']) {
      console.log("getting error in BI");
      return
    }
    // For BI error Show
    if (props.currentPageIndex === 0) {
      if (!isValidSection) {
        if (errorState["errorFromBI"]) {
          errorToastr(errorState["errorFromBI"])
          setShowError(true)
          console.log("For BI error Show")
          return
        }
      }
    }
    if (sections[currentSectionIndex].sectionId === "SectionFlexiEdgeFillProposalMedicalInformation") {
      if (!isValidSection) {
        Object.keys(errorState).forEach(e => {
          if (errorState[e]) {
            errorState[e].map(element => {
              if (element) {
                errorToastr(element)
                setShowError(true)
                return
              }
            })
          }
        })
      }
    }
    if (journeyState.journeyIdFromStrapi === "GuaranteedSavingJourney" && props.pages[props.currentPageIndex].pageId === "PageGuaranteedSavingCalculatePremium" && sections[currentSectionIndex].sectionId === "SectionGuaranteedSavingInvestmentDetails") {
      if (!sectionState.sectionData["sumAssured"] || !sectionState.sectionData["GspAddition"] || !sectionState.sectionData["totalAmount"]) {
        errorToastr("Please calculate the benefit illustration before proceeding")
        return
      }
    }

    if (isValidSection) {

      let journeyFormatData =  applicationDataInJourneyFormat()
      if (props.pages[props.currentPageIndex].pageId === "PageGuaranteedFutureCalculatePremium" && sections[currentSectionIndex].sectionId === "SectionCommonResidenceAndOccupation"){
        sessionStorage.setItem("isResidentDetailsSubmitted", true)
      }
      if (props.pages[props.currentPageIndex].pageId === "PageGuaranteedFutureCalculatePremium" && sections[currentSectionIndex].sectionId === "SectionGuaranteedFutureSumAssured"){
        sessionStorage.setItem("isCustomiseDetailsSubmitted", true)
      }
      if (props.pages[props.currentPageIndex].pageId === "PageGuaranteedFutureCalculatePremium" && sections[currentSectionIndex].sectionId === "SectionGuaranteedFuturePremiumQuotation"){
        sessionStorage.setItem("isPortfolioDetailsSubmitted", true)
      }
      if (props.pages[props.currentPageIndex].pageId === "PageFlexiEdgeFillProposalForm" && sections[currentSectionIndex].sectionId === "SectionFlexiEdgeFillProposalInsuranceHistory"){
        sessionStorage.setItem("isInsuranceDetailsSubmitted",true)
      }
      if (props.pages[props.currentPageIndex].pageId === "PageFlexiEdgeFillProposalForm" && sections[currentSectionIndex].sectionId === "SectionFlexiEdgeFillProposalNomineeDetails"){
        sessionStorage.setItem("isNomineeDetailsSubmitted",true)
      }
      if(journeyState.journeyId){
        DataLayerIntegration(journeyFormatData, "proceed", sections?.[currentSectionIndex]?.sectionId, "", journeyState)
      }

      if (props.currentPageIndex === 0 && currentSectionIndex === 0 && (props.showFirstSectionFields === false)) {
        props.setShowFirstSectionFields(true)
        setShowError(false)
        if (sectionState?.sectionData?.privacyPolicy) {

          let temp = journeyState.journeySteps
          const tempComponentGroupIndexToChange = temp.pages[props.currentPageIndex].sections[currentSectionIndex].component_groups.findIndex(element => element.componentId === "privacypolicy-MD-12-order-21")
          const tempComponentIndex = temp.pages[props.currentPageIndex].sections[currentSectionIndex].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "privacyPolicy")
          temp.pages[props.currentPageIndex].sections[currentSectionIndex].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndex]["display"] = false;
          setJourneyState(prev => {
            return ({
              ...prev,
              journeySteps: temp
            })
          })
        }
        async function applicationNumberGeneration() {
          let anurConfigChannels=[];
            try{
              const res=await getConfigByType({ type: "anur-config" })
              if (res?.data[0]?.config?.products?.hasOwnProperty(journeyState?.journeyIdFromStrapi)) {
                anurConfigChannels = res?.data[0]?.config?.products?.[journeyState?.journeyIdFromStrapi]?.channels || [];
                anurConfigChannels = anurConfigChannels.map(c => c.toUpperCase());
              }

            }
             catch(error){
              console.error(error)
              errorToastr(error?.response?.data?.message || error.message)
            }
          let payloadForApplicationNumber = {
            planCode: journeyState.planOption,
            channelType: "HSBC",
            userId: "ONLINE",
            source: "I",
          }
          console.log(props)
          let rmLedJourneyIndVal = journeyState.channel !== "A" ? "02" : journeyState.agentDetails.rmLedJourneyInd
          let rmLedFNAIndVal = journeyState.channel === "A" 
                              ? 
                                (journeyState.rmLedJourney === "Y" ) 
                                ? "N" 
                                : "Y"  
                              : "N"
          if(journeyState?.fnaData?.FNASOURCE == "rm"){
            rmLedJourneyIndVal='01'
          }
          let payloadForSaveJounrey = {
            basicDetails: {
              applicationNumber: "",
              journeyEncrypt: true,
              emailID: sectionState.sectionData.email,
              mobileNo: sectionState.sectionData.contactNumber,
              countryCode: sectionState.sectionData.contactCountryCode,
              channel: journeyState.channel,
              planCode: journeyState.planOption,
              planName: journeyState.planOption,
              journey: "1",
              illustrationNumber: "",
              proposalEntryId: "",
              fnaDetails: {
                FNAID: journeyState?.fnaData?.FNAID,
                PROPOSERFULLNAME: journeyState?.fnaData?.PROPOSERFULLNAME,
                BIRTHDATE: journeyState?.fnaData?.BIRTHDATE,
                PHONENUMBER: journeyState?.fnaData?.PHONENUMBER,
                EMAILID: journeyState?.fnaData?.EMAILID,
                ANNUALINCOME: journeyState?.fnaData?.ANNUALINCOME,
                ANNUALEXPENSES: journeyState?.fnaData?.ANNUALEXPENSES,
                ANNUALDISPOSABLRINCOME: journeyState?.fnaData?.ANNUALDISPOSABLRINCOME,
                EXISTINGLIFECOVER: journeyState?.fnaData?.EXISTINGLIFECOVER,
                LIFECOVERREQUIRED: journeyState?.fnaData?.LIFECOVERREQUIRED,
                GOALTOACHIEVE: journeyState?.fnaData?.GOALTOACHIEVE,
                TIMEHORIZON: journeyState?.fnaData?.TIMEHORIZON,
                CAPITALPROTECTION: journeyState?.fnaData?.CAPITALPROTECTION,
                PREFERREDPLAN: journeyState?.fnaData?.PREFERREDPLAN,
                PROPOSALENTRYID: journeyState?.fnaData?.PROPOSALENTRYID,
                CREATEDATE: journeyState?.fnaData?.CREATEDATE,
                FNAFLAG: journeyState?.fnaData?.FNAFLAG

              },
              videoVcApplicable:anurConfigChannels.includes(journeyState?.channel?.toUpperCase())?"Y":"N"
            },
            agentDetails: {
              eSPCode: journeyState.eSPCode,
              subChannel: journeyState.subChannel,
              ...journeyState.agentDetails,
              rmLedJourneyInd: rmLedJourneyIndVal,
              rmLedFNAInd: rmLedFNAIndVal
            },

            lastSection: 0,
            lastPage: 0,
            lastPageCode: "calculatePremiumPage",
            lastSectionCode: "CPPersonalDetailsSection",
            journeyCode: "J1_001",
            uniqueId: journeyState?.uid,
          }
          let firstLoadPaylod = [
            {
              pageId: props.pages[props.currentPageIndex].pageId,
              pageData: [sectionState],
            },
          ]
          let collectionToBeMapped
          if(props?.canaraPosData){
            collectionToBeMapped = {
              fnaId: props?.canaraPosData?.canaraPosData[0]?.fnaData?._id,
              canaraPosId: props?.canaraPosData?.canaraPosData[1]?.canaraPosData?._id
            }
          }
          let saveApplicationPayload = {
            sendResponseData: true,
            applicationData: firstLoadPaylod,
            journeyData: {
              _id: "",
              lastPage: 0,
              lastSection: 0,
              lastPageCode: props.pageId,
              lastSectionCode: sections[currentSectionIndex].sectionId,
              journeyCode: "J1_001",
              applicationNo: "",
              illustrationNumber: "",
              planOption: journeyState.planOption,
              journeyIdFromStrapi: journeyState.journeyIdFromStrapi,
              proposalEntryId: "",
              channel: journeyState.channel,
              premium: journeyState.premium ? journeyState.premium : 0,
              journeyType: journeyState?.journeyType,
              hsbcJourneyID: journeyState?.hsbcJourneyID,
              collectionToBeMapped: collectionToBeMapped
            },
          }
          let finalPayloadForApplicationNumberGeneration = {
            payloadForApplicationNumber: payloadForApplicationNumber,
            payloadForSaveJounrey: payloadForSaveJounrey,
            saveApplicationPayload: saveApplicationPayload
          }
          try {
            console.log(journeyState);
            if (journeyState?.applicationNo) {
              let sendPayload = {
                applicationData: firstLoadPaylod,
                journeyData: {
                  _id: journeyState.journeyId,
                  lastPage: getLastPageAndLastSection(props.currentPageIndex, currentSectionIndex, sections.length).lastPage,
                  lastSection: getLastPageAndLastSection(props.currentPageIndex, currentSectionIndex, sections.length).lastSection,
                  lastPageCode: props.pageId,
                  lastSectionCode: sections[currentSectionIndex].sectionId,
                  journeyCode: findCurrentJourneyCode(props.pageId, sections[currentSectionIndex].sectionId),
                  applicationNo: journeyState.applicationNo,
                  illustrationNumber: journeyState.illustrationNumber,
                  planOption: journeyState.planOption,
                  journeyIdFromStrapi: journeyState.journeyIdFromStrapi,
                  proposalEntryId: journeyState.proposalEntryId,
                  premium: journeyState.premium,
                  channel: journeyState.channel,
                },
              }
              console.log(sendPayload);
              let saveApplicationResponse = await saveApplication(sendPayload)
              console.log(saveApplicationResponse);
            } else {
              let applicationNumberResponse = await saveApplicationDetailsOverall(finalPayloadForApplicationNumberGeneration)
              sessionStorage.setItem("appNo",applicationNumberResponse.alljounreyData.basicDetails.applicationNumber)
              DataLayerIntegration(journeyFormatData, "", sections?.[currentSectionIndex]?.sectionId, "leadSubmit", journeyState)
              DataLayerIntegration(journeyFormatData, "", sections?.[currentSectionIndex]?.sectionId, "secondPageLanded", journeyState)
              console.log(applicationNumberResponse.alljounreyData.basicDetails.applicationNumber, "applicationNumberResponse")
              setJourneyState(prev => {
                return {
                  ...prev,
                  proposalEntryId: applicationNumberResponse.alljounreyData.basicDetails.proposalEntryId,
                  applicationNo: applicationNumberResponse.alljounreyData.basicDetails.applicationNumber,
                  illustrationNumber: applicationNumberResponse.alljounreyData.basicDetails.illustrationNumber,
                  journeyId: applicationNumberResponse.alljounreyData._id,
                }
              })
            }
          } catch (err) {
            console.log(err)
          }
        }
        applicationNumberGeneration()
        return
      }
      setFirstPassForPremiumPaymentBicall(true)
      setFirstPageAutoFillApiCall(true)
      setErrorState({})
      setShowError(false)
      // this function runs on submit button click
      //handeling section movement
      if (currentSectionIndex >= sections.length - 1) {
        console.log("inside if")
        // condition to move to next page

        /*to remove duplicate page state */
        let foundSection = pageState.pageData.find(
          //to prevent duplicate section
          element => element.sectionId === sectionState.sectionId
        )
        //console.log(foundSection, "foundSection")

        if (foundSection) {
          // removing the old section to add new section
          let newPageData = pageState.pageData.filter(
            element => element.sectionId !== foundSection.sectionId
          )
          setPageState(prev => {
            return {
              ...prev,
              pageData: [...newPageData, sectionState], //newPageData has all sections except founded section
            }
          })
          foundSection = {}
        } else {
          setPageState(prev => {
            return {
              ...prev,
              pageData: [...prev.pageData, sectionState], // adding new section
            }
          })
        }

        let foundPage = journeyState.journeyData.find(
          element => element.pageId === pageState.pageId
        )
        console.log(foundPage, "foundPage")
        if (foundPage) {
          let newJourneyData = journeyState.journeyData.filter(
            element => element.pageId !== foundPage.pageId
          )
          let pageData = pageState.pageData.filter(
            element => element.sectionId !== sectionState.sectionId
          )
          setJourneyState(prev => {
            return {
              ...prev,
              journeyData: [
                ...newJourneyData,
                {
                  pageId: props.pages[props.currentPageIndex].pageId,
                  pageData: [...pageData, sectionState],
                },
              ],
            }
          })
          foundPage = {}
        } else {
          let pageData = pageState.pageData.filter(
            element => element.sectionId !== sectionState.sectionId
          )

          setJourneyState(prev => {
            return {
              ...prev,
              journeyData: [
                ...prev.journeyData,
                {
                  pageId: props.pages[props.currentPageIndex].pageId,
                  pageData: [...pageData, sectionState],
                },
              ],
            }
          })
        }

        setPageState(prev => {
          return {
            ...prev,
            pageId: null,
            pageData: [],
          }
        })
        setSectionState(prev => {
          return {
            ...prev,
            sectionId: null,
            sectionFirstPass: null,
            sectionData: {},
          }
        })
        /*to remove duplicate page state */

        journeyState.journeyData.map((element, index) => {
          // to get pageState if exists
          if (
            element.pageId === props.pages[props.currentPageIndex + 1].pageId
          ) {
            setPageState(prev => {
              return {
                ...prev,
                pageId: element.pageId,
                pageData: element.pageData,
              }
            })
            element.pageData.map((section, index) => {
              if (
                section.sectionId ===
                props.pages[props.currentPageIndex + 1].sections[0].sectionId
              ) {
                setSectionState(prev => {
                  return {
                    ...prev,
                    sectionId: section.sectionId,
                    sectionData: section.sectionData,
                  }
                })
              }
            })
          }
        })

        if (props.currentPageIndex < props.pages.length - 1) {
          // edge case condition for last page
          props.setCurrentPageIndex(prev => prev + 1)
          setCurrentSectionIndex(0)
          //console.log(journeyState, "journey state")
        }
      } else {
        // condition of same page

        //Handeling context change
        if (sectionState.sectionId !== null) {
          //console.log("is section ID null")
          if (pageState.pageId === props.pageId) {
            let foundSection = pageState.pageData.find(
              //to prevent duplicate section
              element => element.sectionId === sectionState.sectionId
            )
            //console.log(foundSection, "foundSection")

            if (foundSection) {
              // removing the old section to add new section
              const newPageData = pageState.pageData.filter(
                element => element.sectionId !== foundSection.sectionId
              )
              setPageState(prev => {
                return {
                  ...prev,
                  pageData: newPageData, //newPageData has all sections except founded section
                }
              })
              foundSection = {}
            }

            setPageState(prev => {
              return {
                ...prev,
                pageData: [...prev.pageData, sectionState], // adding new section
              }
            })
          } else {
            setPageState(prev => {
              // case of new page
              return {
                ...prev,
                pageId: props.pageId,
                pageData: [...prev.pageData, sectionState],
              }
            })
          }
        }

        setSectionState(prev => {
          // making section data empty to load new sectionData
          return {
            ...prev,
            sectionId: null,
            sectionFirstPass: null,
            sectionData: {},
          }
        })

        pageState.pageData.map((element, index) => {
          if (
            element.sectionId === sections[currentSectionIndex + 1].sectionId
          ) {
            //loading section state if already present
            setSectionState(prev => {
              return {
                ...prev,
                sectionId: element.sectionId,
                sectionData: element.sectionData,
              }
            })
          }
        })

        console.log(sectionState, "section state")
        console.log(pageState, "pageState")
        console.log(journeyState, "journey state else")
        console.log("setCurrentSectionIndex6");
        setCurrentSectionIndex(prev => prev + 1)
        props.sections[currentSectionIndex].class = "active"
      }

      // save application details
      setJourneyState(prev => {
        return {
          ...prev,
          lastPage: props.currentPageIndex,
          lastSection: currentSectionIndex,
          lastPageCode: props.pageId,
          lastSectionCode: sections[currentSectionIndex].sectionId,
          journeyCode: findCurrentJourneyCode(props.pageId, sections[currentSectionIndex].sectionId)
        }
      })
      //console.log(journeyState, "agete jkdcehbce")


      let pageData = pageState.pageData.filter(
        element => element.sectionId !== sectionState.sectionId
      )
      let journeyData = journeyState.journeyData.filter(
        element =>
          element.pageId !== props.pages[props.currentPageIndex].pageId
      )

      let LoadPaylod = [
        ...journeyData,
        {
          pageId: props.pages[props.currentPageIndex].pageId,
          pageData: [...pageData, sectionState],
        },
      ]

      //console.log(firstLoadPaylod)
      let sendPayload = {
        applicationData: LoadPaylod,
        journeyData: {
          _id: journeyState.journeyId,
          lastPage: getLastPageAndLastSection(props.currentPageIndex, currentSectionIndex, sections.length).lastPage,
          lastSection: getLastPageAndLastSection(props.currentPageIndex, currentSectionIndex, sections.length).lastSection,
          lastPageCode: props.pageId,
          lastSectionCode: sections[currentSectionIndex].sectionId,
          journeyCode: findCurrentJourneyCode(props.pageId, sections[currentSectionIndex].sectionId),
          applicationNo: journeyState.applicationNo,
          illustrationNumber: journeyState.illustrationNumber,
          planOption: journeyState.planOption,
          journeyIdFromStrapi: journeyState.journeyIdFromStrapi,
          proposalEntryId: journeyState.proposalEntryId,
          premium: journeyState.premium,
          channel: journeyState.channel,
          sendCaseToCustomerFirstResume: journeyState?.sendCaseToCustomerFirstResume
        },
        posDashboardListingData:{
          sendCaseToCustomerFirstResume: journeyState?.sendCaseToCustomerFirstResume
        }
      }
      saveApplication(sendPayload).then(async res => {
        setCallBi(true);
        // if (sections[currentSectionIndex].sectionId === "residenceDetailsSection" || sections[currentSectionIndex].sectionId === "SectionFlexiEdgeFillProposalCommunicationAddress") {
        //   const data = await checkDocuments({ _id: journeyState.journeyId });
        // }
        setSaveApplicationCounter(prev => prev + 1)
        if (callJlref.current === "initiate"){
          setCallJl(true)
        }
        //console.log(res)
      }).catch(error => {
        console.log("asdsadasd", errorState)
        if (currentSectionIndex === sections.length - 1) {
          if (props.currentPageIndex >= 0) {
            // let foundPage = journeyState.journeyData.find(
            //   element => element.pageId === props.pages[props.currentPageIndex - 1].pageId
            // )
            // if (foundPage) {
            setPageState({
              pageId: pageState.pageId,
              pageData: pageState.pageData
            })
            // let foundSection = foundPage.pageData.find(
            //   element => element.sectionId === props.pages[props.currentPageIndex -1].sections[sections.length -1].sectionId
            // )
            // if (foundSection) {
            setSectionState({
              sectionId: sectionState.sectionId,
              sectionData: sectionState.sectionData
            })
            // }
          }
          props.setCurrentPageIndex(prev => prev - 1)
          setCurrentSectionIndex(props.pages[props.currentPageIndex]?.sections.length - 1)
          setErrorState({})
        } else {
          // let foundSection = pageState.pageData.find(element => {
          //   console.log(element, "sdfdf", sectionState)
          //   return element.sectionId === sectionState.sectionId
          // })
          // if(foundSection){
          setSectionState({
            sectionId: sectionState.sectionId,
            sectionData: sectionState.sectionData
          })
          // }
          setCurrentSectionIndex(prev => prev - 1)
          setErrorState({})

        }
      })
      // .then(res => {
      //   if(currentSectionIndex >= sections.length - 1){
      //     if(props.currentPageIndex < props.pages.length - 1) {
      //       // edge case condition for last page
      //       props.setCurrentPageIndex(prev => prev + 1)
      //       setCurrentSectionIndex(0)
      //       //console.log(journeyState, "journey state")
      //     }
      //   }else{
      //     setCurrentSectionIndex(prev => prev + 1);
      //   }
      // })
    } else {
      if (((sections[currentSectionIndex].sectionId === "CPPersonalDetailsSection" && errorState["educationalQualification"] && errorState["educationalQualification"] === "This option is not available for this plan")
        || (sections[currentSectionIndex].sectionId === "CPResidentAndOccupationDetailSection" && errorState["CPResidentAndOccupationType"] && errorState["CPResidentAndOccupationType"] === "This option is not available for this plan")
        || (sections[currentSectionIndex].sectionId === "iSelect360CPResidentAndOccupationDetailSection" && errorState["CPResidentAndOccupationType"] && errorState["CPResidentAndOccupationType"] === "This option is not available for this plan")
        || (sections[currentSectionIndex].sectionId === "CPPersonalDetailsSection" && errorState["AnnualIncome"] && errorState["AnnualIncome"] === "This option is not available for this plan")) && (journeyState.journeyIdFromStrapi === "ISelect360Journey" || journeyState.journeyIdFromStrapi === "iSelectJourney")
        || (sections[currentSectionIndex].sectionId === "iSelect360CPResidentAndOccupationDetailSection" && errorState["pincode"] && errorState["pincode"] === "This Pincode is not serviceable")
        || (sections[currentSectionIndex].sectionId === "SectionFlexiEdgeResidenceandOccupationDetails" && errorState["pincode"] && errorState["pincode"] === "This Pincode is not serviceable")
        || (sections[currentSectionIndex].sectionId === "SectionCommonResidenceAndOccupation" && errorState["GOPApincode"] && errorState["GOPApincode"] === "This Pincode is not serviceable")
        || (sections[currentSectionIndex].sectionId === "proposerCommonResidenceAndOccupation" && errorState["proposerPincode"] && errorState["proposerPincode"] === "This Pincode is not serviceable")
      ) {
        errorToastr(`Thank You for choosing Canara HSBC Life Insurance Company Limited -${lookup?.['errorToaster']?.[journeyState.journeyIdFromStrapi]}. Basis your input this Plan is not available.`)
      }
      setShowError(true)
    }

    try { // for recaptcha v3 implementation
      if (journeyState.applicationNo){
        const token = await executeRecaptcha("submit_form");
        verifyCaptcha({
          token : token,
          applicationNumber : journeyState.applicationNo,
          sectionId : sectionState.sectionId,
          pageId : props.pages[props.currentPageIndex].pageId
        })
        .then(res => {
          console.info(res)
        })
        .catch(err => {
          console.info(err)
        })
      }
    }catch(err){
      console.info(err)
    }

  }

  //Individual Product Journey Buttons Functionalities

  const handleCalculateGurantedSumGSP = async () => {
    console.info("hskj")
    let journeyFormatData = applicationDataInJourneyFormat()
    DataLayerIntegration(journeyFormatData, "proceed", sections?.[currentSectionIndex]?.sectionId,"", journeyState)
    let isValidSection = Object.keys(errorState).every(element => {
      if (Array.isArray(errorState[element])) {
        return errorState[element].every(subElement => {
          return subElement === ""
        })
      } else {
        return errorState[element] === ""
      }
    })
    let premiumForJourney
    let frequencyForJourney
    if (journeyState.journeyIdFromStrapi === "guaranteedIncomeAdvantage") {
      premiumForJourney = "GIAPPremiumAmount"
      frequencyForJourney = "GIAPPaymentFrequency"
    } else if (journeyState.journeyIdFromStrapi === "guaranteedSavingsOption") {
      premiumForJourney = "GSPInstallmentPremium"
      frequencyForJourney = "GSPpaymentFrequency"
    } else if (journeyState.journeyIdFromStrapi === "GuarateedOnePayJourney") {
      premiumForJourney = "GOPAcpInstallmentPremium"
      frequencyForJourney = "GOPACPPaymentFrequency"
    }
    else if (journeyState.journeyIdFromStrapi === "insureSmart") {
      premiumForJourney = "InsurePremiumAmount"
      frequencyForJourney = "InsurePaymentFrequency"
    } else if (journeyState.journeyIdFromStrapi === "moneyBackAdvantage") {
      premiumForJourney = ""
      frequencyForJourney = "MoneyBackPaymentFrequency"
    }
    if (journeyState.journeyIdFromStrapi === "jeevanNivesh") {
      // premiumForJourney = "JeevanNiveshInstallmentPremium"
      frequencyForJourney = "JeevanNiveshPaymentFrequency"
    }
    if (journeyState.journeyIdFromStrapi === "smartJuniorPlan") {
      // premiumForJourney = "JeevanNiveshInstallmentPremium"
      frequencyForJourney = "paymentFrequencySmartJunior"
    }
    if (journeyState.journeyIdFromStrapi === "secureBhavishyaJourney") {
      premiumForJourney = "secureBhavishyaAmountInvest"
      frequencyForJourney = "secureBhavishyaPaymentFrequency"
    }
    if (journeyState.journeyIdFromStrapi === "guaranteedFortuneJourney") {
      premiumForJourney = "GFPInstallmentPremium"
      frequencyForJourney = "GFPPaymentFrequency"
    }
    if (journeyState.journeyIdFromStrapi === "guaranteedFutureJourney") {
      premiumForJourney = "guaranteedFutureInstallmentPremium"
      frequencyForJourney = "guaranteedFuturePF"
    }
    if (journeyState.journeyIdFromStrapi === "invest4GJourney") {
      premiumForJourney = "invest4gAmountInvest"
      frequencyForJourney = "invest4gPremiumFrequency"
    }
    if (journeyState.journeyIdFromStrapi === "guaranteedIncome4LifeJourney") {
      premiumForJourney = "GI4LPremiumAmount"
      frequencyForJourney = "GI4LPaymentFrequency"
    }
    if (journeyState.journeyIdFromStrapi === "GAINjourney") {
      premiumForJourney = "GAINpremiumAmount"
      frequencyForJourney = "GAINpremiumFrequency"
    }
    setJourneyState(prev => {
      return {
        ...prev,
        premium: sectionState.sectionData[premiumForJourney] || "",
        paymentFrequency: sectionState.sectionData[frequencyForJourney]
      }
    })
    if (isValidSection) {
      if (pageState.pageId === props.pages[props.currentPageIndex].pageId) {
        let foundSection = pageState.pageData.find(
          element => element.sectionId === sectionState.sectionId
        )

        if (foundSection) {
          let newPageData = pageState.pageData.filter(
            element => element.sectionId !== foundSection.sectionId
          )
          setPageState(prev => {
            return {
              ...prev,
              pageData: newPageData, //newPageData has all sections except founded section
            }
          })
          foundSection = {}
        }

        setPageState(prev => {
          return {
            ...prev,
            pageData: [...prev.pageData, sectionState], // adding new section
          }
        })
      } else {
        setPageState(prev => {
          return {
            ...prev,
            pageId: props.pages[props.currentPageIndex].pageId,
            pageData: [...prev.pageData, sectionState],
          }
        })
      }

      let pageData = pageState.pageData.filter(
        element => element.sectionId !== sectionState.sectionId
      )
      let journeyData = journeyState.journeyData.filter(
        element => element.pageId !== props.pages[props.currentPageIndex].pageId
      )

      let LoadPaylod = [
        ...journeyData,
        {
          pageId: props.pages[props.currentPageIndex].pageId,
          pageData: [...pageData, sectionState],
        },
      ]

      let sendPayload = {
        applicationData: LoadPaylod,
        journeyData: {
          _id: journeyState.journeyId,
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex,
          applicationNo: journeyState.applicationNo,
          illustrationNumber: journeyState.illustrationNumber,
          planOption: journeyState.planOption,
          journeyIdFromStrapi: journeyState.journeyIdFromStrapi,
          proposalEntryId: journeyState.proposalEntryId,
          lastPageCode: props.pageId,
          premium: journeyState.premium,
          lastSectionCode: sections[currentSectionIndex].sectionId,
        },
      }
      saveApplication(sendPayload).then(async res => {
        let payload = {
          journeyId: journeyState.journeyId,
        }
        const biApiData = await generateBI(payload)
        console.info(biApiData);
        if (biApiData.data?.BIJson && journeyState.journeyIdFromStrapi === "guaranteedSavingsOption") {
          console.log(sectionState, "sections")
          let biJson = JSON.parse(biApiData.data?.BIJson)
          let premiumAmount = Math.floor(biJson[0]?.["MODAL_PREM"])
          let expectedBonusAmount =  Math.round(biJson[biJson.length -1]?.["ACCRUED_GUAR_ADDITIONS"] + biJson[biJson.length -1]?.["SURVIVAL_BENEFIT"])
          let gurantedSumAssured = Math.round(biJson[0]?.["SUM_ASSURED_MATURITY"])
          let total = expectedBonusAmount + gurantedSumAssured
          setJourneyState(prev => {
            return ({
              ...prev,
              "gurantedSavingsBiKeys": {
                "premiumAmount": premiumAmount,
                "gurantedSumAssured": gurantedSumAssured,
                "expectedBonusAmount": expectedBonusAmount,
                "total": total
              }
            })
          })
          setCurrentSectionIndex(prev => prev + 1)

        } else if (biApiData.data?.BIJson && journeyState.journeyIdFromStrapi === "guaranteedIncomeAdvantage") {
          console.log(sectionState, "sections")
          let biJson = JSON.parse(biApiData.data?.BIJson)
          let premiumAmountGIAP = Math.floor(biJson[0]?.["MODAL_PREM"])
          let guarantedIncomeGIAP = Math.floor(biJson[sectionState.sectionData["GIAPPolicyTerm"] - 1]?.["GAIP"])
          let gurantedSumAssuredGIAP = Math.floor(biJson[0]?.["SA"])
          let totalGIAP = guarantedIncomeGIAP + gurantedSumAssuredGIAP
          setJourneyState(prev => {
            return ({
              ...prev,
              "gurantedIncomeAdvantageBiKeys": {
                "premiumAmount": premiumAmountGIAP,
                "gurantedSumAssured": gurantedSumAssuredGIAP,
                "guarantedIncome": guarantedIncomeGIAP,
                "total": totalGIAP
              }
            })
          })
          setCurrentSectionIndex(prev => prev + 1)

        } else if (biApiData.data?.BIJson && journeyState.journeyIdFromStrapi === "moneyBackAdvantage") {
          console.log(sectionState, "sections")
          let biJson = JSON.parse(biApiData.data?.BIJson)
          let premiumAmount = Math.floor(biJson[0]?.["MODAL_PREM"])
          let totalMaturity4per = Math.floor(biJson[biJson.length - 1]?.["TOTAL_MB_BS_2"])
          let totalMaturity8per = Math.floor(biJson[biJson.length - 1]?.["TOTAL_MB_BS_1"])
          let gurantedPayout5th = Math.floor(biJson[4]?.["SB_G"])
          let gurantedPayout9th = Math.floor(biJson[8]?.["SB_G"])
          let gurantedPayout13th = Math.floor(biJson[12]?.["SB_G"])
          setJourneyState(prev => {
            return ({
              ...prev,
              "moneyBackAdvantageBiKeys": {
                "premiumAmount": premiumAmount,
                "totalMaturity4per": totalMaturity4per,
                "totalMaturity8per": totalMaturity8per,
                "gurantedPayout5th": gurantedPayout5th,
                "gurantedPayout9th": gurantedPayout9th,
                "gurantedPayout13th": gurantedPayout13th
              }
            })
          })
          setCurrentSectionIndex(prev => prev + 1)

        } else if (journeyState.journeyIdFromStrapi === "GuarateedOnePayJourney") {
          if (biApiData.data?.BIJson) {
            props.setCurrentPageIndex(prev => prev + 1)
            setCurrentSectionIndex(0)
          }
        }else if (journeyState.journeyIdFromStrapi === "invest4GJourney") {
          if (biApiData.data?.BIJson) {
          setErrorState({})
          setShowError(false)
          // this function runs on submit button click
          //handeling section movement
          if (currentSectionIndex >= sections.length - 1) {
            console.log("inside if")
            // condition to move to next page
    
            /*to remove duplicate page state */
            let foundSection = pageState.pageData.find(
              //to prevent duplicate section
              element => element.sectionId === sectionState.sectionId
            )
            //console.log(foundSection, "foundSection")
    
            if (foundSection) {
              // removing the old section to add new section
              let newPageData = pageState.pageData.filter(
                element => element.sectionId !== foundSection.sectionId
              )
              setPageState(prev => {
                return {
                  ...prev,
                  pageData: [...newPageData, sectionState], //newPageData has all sections except founded section
                }
              })
              foundSection = {}
            } else {
              setPageState(prev => {
                return {
                  ...prev,
                  pageData: [...prev.pageData, sectionState], // adding new section
                }
              })
            }
    
            let foundPage = journeyState.journeyData.find(
              element => element.pageId === pageState.pageId
            )
            console.log(foundPage, "foundPage")
            if (foundPage) {
              let newJourneyData = journeyState.journeyData.filter(
                element => element.pageId !== foundPage.pageId
              )
              let pageData = pageState.pageData.filter(
                element => element.sectionId !== sectionState.sectionId
              )
              setJourneyState(prev => {
                return {
                  ...prev,
                  journeyData: [
                    ...newJourneyData,
                    {
                      pageId: props.pages[props.currentPageIndex].pageId,
                      pageData: [...pageData, sectionState],
                    },
                  ],
                }
              })
              foundPage = {}
            } else {
              let pageData = pageState.pageData.filter(
                element => element.sectionId !== sectionState.sectionId
              )
    
              setJourneyState(prev => {
                return {
                  ...prev,
                  journeyData: [
                    ...prev.journeyData,
                    {
                      pageId: props.pages[props.currentPageIndex].pageId,
                      pageData: [...pageData, sectionState],
                    },
                  ],
                }
              })
            }
    
            setPageState(prev => {
              return {
                ...prev,
                pageId: null,
                pageData: [],
              }
            })
            setSectionState(prev => {
              return {
                ...prev,
                sectionId: null,
                sectionFirstPass: null,
                sectionData: {},
              }
            })
            /*to remove duplicate page state */
    
            journeyState.journeyData.map((element, index) => {
              // to get pageState if exists
              if (
                element.pageId === props.pages[props.currentPageIndex + 1].pageId
              ) {
                setPageState(prev => {
                  return {
                    ...prev,
                    pageId: element.pageId,
                    pageData: element.pageData,
                  }
                })
                element.pageData.map((section, index) => {
                  if (
                    section.sectionId ===
                    props.pages[props.currentPageIndex + 1].sections[0].sectionId
                  ) {
                    setSectionState(prev => {
                      return {
                        ...prev,
                        sectionId: section.sectionId,
                        sectionData: section.sectionData,
                      }
                    })
                  }
                })
              }
            })
    
            if (props.currentPageIndex < props.pages.length - 1) {
              // edge case condition for last page
              props.setCurrentPageIndex(prev => prev + 1)
              setCurrentSectionIndex(0)
              //console.log(journeyState, "journey state")
            }
          } else {
            // condition of same page
    
            //Handeling context change
            if (sectionState.sectionId !== null) {
              //console.log("is section ID null")
              if (pageState.pageId === props.pageId) {
                let foundSection = pageState.pageData.find(
                  //to prevent duplicate section
                  element => element.sectionId === sectionState.sectionId
                )
                //console.log(foundSection, "foundSection")
    
                if (foundSection) {
                  // removing the old section to add new section
                  const newPageData = pageState.pageData.filter(
                    element => element.sectionId !== foundSection.sectionId
                  )
                  setPageState(prev => {
                    return {
                      ...prev,
                      pageData: newPageData, //newPageData has all sections except founded section
                    }
                  })
                  foundSection = {}
                }
    
                setPageState(prev => {
                  return {
                    ...prev,
                    pageData: [...prev.pageData, sectionState], // adding new section
                  }
                })
              } else {
                setPageState(prev => {
                  // case of new page
                  return {
                    ...prev,
                    pageId: props.pageId,
                    pageData: [...prev.pageData, sectionState],
                  }
                })
              }
            }
    
            setSectionState(prev => {
              // making section data empty to load new sectionData
              return {
                ...prev,
                sectionId: null,
                sectionFirstPass: null,
                sectionData: {},
              }
            })
    
            pageState.pageData.map((element, index) => {
              if (
                element.sectionId === sections[currentSectionIndex + 1].sectionId
              ) {
                //loading section state if already present
                setSectionState(prev => {
                  return {
                    ...prev,
                    sectionId: element.sectionId,
                    sectionData: element.sectionData,
                  }
                })
              }
            })
    
            // console.log(sectionState, "section state")
            // console.log(pageState, "pageState")
            // console.log(journeyState, "journey state else")
            // console.log("setCurrentSectionIndex6");
            // setCurrentSectionIndex(prev => prev + 1)
            // props.sections[currentSectionIndex].class = "active"
          }
    
          // save application details
          setJourneyState(prev => {
            return {
              ...prev,
              lastPage: props.currentPageIndex,
              lastSection: currentSectionIndex,
              lastPageCode: props.pageId,
              lastSectionCode: sections[currentSectionIndex].sectionId,
              journeyCode: findCurrentJourneyCode(props.pageId, sections[currentSectionIndex].sectionId)
            }
          })
            setCurrentSectionIndex(prev => prev + 1)
            props.sections[currentSectionIndex].class = "active"
            setErrorState({})
          }
        } else if (journeyState.journeyIdFromStrapi === "insureSmart") {
          if (biApiData.data?.BIJson) {
            setCurrentSectionIndex(prev => prev + 1)
          }
        } else if (journeyState.journeyIdFromStrapi === "jeevanNivesh") {
          if (biApiData.data?.BIJson) {
            let biJson = JSON.parse(biApiData.data?.BIJson)
            let premiumAmount = Math.floor(biJson[0]?.["MODAL_PREM"])
            let totalMaturityBenifit8 = Math.floor(biJson[biJson.length - 1]?.["TOTAL_MB_BS_2"])
            let totalMaturityBenifit4 = Math.floor(biJson[biJson.length - 1]?.["TOTAL_MB_BS_1"])
            setJourneyState(prev => {
              return ({
                ...prev,
                "jeevanNiveshBiKeys": {
                  "premiumAmount": premiumAmount,
                  "totalMaturityBenifit8": totalMaturityBenifit8,
                  "totalMaturityBenifit4": totalMaturityBenifit4
                }
              })
            })
            setCurrentSectionIndex(prev => prev + 1)
          }
        } else if (journeyState.journeyIdFromStrapi === "smartJuniorPlan") {
          if (biApiData.data?.BIJson) {
            let biJson = JSON.parse(biApiData.data?.BIJson)
            setJourneyState(prev => {
              return ({
                ...prev,
                "smartJuniorBIJson": biJson
              })
            })
            setCurrentSectionIndex(prev => prev + 1)
          }
        } else if (journeyState.journeyIdFromStrapi === "secureBhavishyaJourney") {
          if (biApiData.data?.BIJson) {
            let biJson = JSON.parse(biApiData.data?.BIJson)
            let biJson2 = JSON.parse(biApiData.data?.BIJson2)
            let totalMaturityBenifit4 = Math.floor(biJson[0]?.["FINAL_FV"])
            let totalMaturityBenifit8 = Math.floor(biJson2[0]?.["FINAL_FV"])

            setJourneyState(prev => {
              return ({
                ...prev,
                "SecureBhavishyaBiKeys": {
                  "totalMaturityBenifit4": totalMaturityBenifit4,
                  "totalMaturityBenifit8": totalMaturityBenifit8
                }
              })
            })
            setCurrentSectionIndex(prev => prev + 1)
          }
        } else if (journeyState.journeyIdFromStrapi === "guaranteedFortuneJourney") {
          if (biApiData.data?.BIJson) {
            // console.info("biApiData.data?.BIJson",biApiData.data?.BIJson);
            let biJson = JSON.parse(biApiData.data?.BIJson)
            let premiumAmount = Math.floor(biJson[0]?.["MODAL_PREM"])
            let guaranteedSA = Math.round(biJson[biJson.length - 1]?.["GSAM"])
            let guaranteedAdd = Math.round(biJson[0]?.["ACC_GUAR_ADD_TOT"])
            setJourneyState(prev => {
              return ({
                ...prev,
                "guaranteedFortuneBiKeys": {
                  "premiumAmount": premiumAmount,
                  "guaranteedSA": guaranteedSA,
                  "guaranteedAdd": guaranteedAdd
                }
              })
            })
            setCurrentSectionIndex(prev => prev + 1)
          }
        }  else if (biApiData.data?.BIJson && journeyState.journeyIdFromStrapi === "guaranteedFutureJourney") {
          console.log(sectionState, "sections")
          let biJson = JSON.parse(biApiData.data?.BIJson)
          let guaranteedFutureInstallmentPremium = Math.floor(biJson[0]?.["MODAL_PREM"])
          let guaranteedFutureSumAssured = Math.floor(biJson[0]?.["GUARANTEED_SAM"])
          let guaranteedAdditionsGuaranteedFuture = Math.floor(biJson[0]?.["TOTAL_GURAN_ADD"])
          let totalGuaranteedIncome = guaranteedFutureSumAssured + guaranteedAdditionsGuaranteedFuture
          setJourneyState(prev => {
            return ({
              ...prev,
              "guaranteedFutureJourneyBiKeys": {
                "premiumAmount": guaranteedFutureInstallmentPremium,
                "guaranteedSumAssured": guaranteedFutureSumAssured,
                "guaranteedAdditions": guaranteedAdditionsGuaranteedFuture,
                "total": totalGuaranteedIncome
              }
            })
          })
          setCurrentSectionIndex(prev => prev + 1)
        } else if (journeyState.journeyIdFromStrapi === "guaranteedIncome4LifeJourney") {
          if (biApiData.data?.BIJson) {
            props.setCurrentPageIndex(prev => prev + 1)
            setCurrentSectionIndex(0)
          }
        } 
        else if (journeyState.journeyIdFromStrapi === "GAINjourney") {
          if (biApiData.data?.BIJson) {
            if(!sectionState.sectionData["GAINsumAssured"]){
              let biJson = JSON.parse(biApiData.data?.BIJson)
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionData: {
                    ...prev.sectionData,
                    ["GAINsumAssured"]: Math.round(Number(sectionState.sectionData["GAINmultipleFactor"]) * biJson[0]?.ANN_PREM_YEARLY)
                  },
                }
              })
              return
          }
            setErrorState({})
            setShowError(false)
            // this function runs on submit button click
            //handeling section movement
            if (currentSectionIndex >= sections.length - 1) {
              console.log("inside if")
              // condition to move to next page
      
              /*to remove duplicate page state */
              let foundSection = pageState.pageData.find(
                //to prevent duplicate section
                element => element.sectionId === sectionState.sectionId
              )
              //console.log(foundSection, "foundSection")
      
              if (foundSection) {
                // removing the old section to add new section
                let newPageData = pageState.pageData.filter(
                  element => element.sectionId !== foundSection.sectionId
                )
                setPageState(prev => {
                  return {
                    ...prev,
                    pageData: [...newPageData, sectionState], //newPageData has all sections except founded section
                  }
                })
                foundSection = {}
              } else {
                setPageState(prev => {
                  return {
                    ...prev,
                    pageData: [...prev.pageData, sectionState], // adding new section
                  }
                })
              }
      
              let foundPage = journeyState.journeyData.find(
                element => element.pageId === pageState.pageId
              )
              console.log(foundPage, "foundPage")
              if (foundPage) {
                let newJourneyData = journeyState.journeyData.filter(
                  element => element.pageId !== foundPage.pageId
                )
                let pageData = pageState.pageData.filter(
                  element => element.sectionId !== sectionState.sectionId
                )
                setJourneyState(prev => {
                  return {
                    ...prev,
                    journeyData: [
                      ...newJourneyData,
                      {
                        pageId: props.pages[props.currentPageIndex].pageId,
                        pageData: [...pageData, sectionState],
                      },
                    ],
                  }
                })
                foundPage = {}
              } else {
                let pageData = pageState.pageData.filter(
                  element => element.sectionId !== sectionState.sectionId
                )
      
                setJourneyState(prev => {
                  return {
                    ...prev,
                    journeyData: [
                      ...prev.journeyData,
                      {
                        pageId: props.pages[props.currentPageIndex].pageId,
                        pageData: [...pageData, sectionState],
                      },
                    ],
                  }
                })
              }
      
              setPageState(prev => {
                return {
                  ...prev,
                  pageId: null,
                  pageData: [],
                }
              })
              setSectionState(prev => {
                return {
                  ...prev,
                  sectionId: null,
                  sectionFirstPass: null,
                  sectionData: {},
                }
              })
              /*to remove duplicate page state */
      
              journeyState.journeyData.map((element, index) => {
                // to get pageState if exists
                if (
                  element.pageId === props.pages[props.currentPageIndex + 1].pageId
                ) {
                  setPageState(prev => {
                    return {
                      ...prev,
                      pageId: element.pageId,
                      pageData: element.pageData,
                    }
                  })
                  element.pageData.map((section, index) => {
                    if (
                      section.sectionId ===
                      props.pages[props.currentPageIndex + 1].sections[0].sectionId
                    ) {
                      setSectionState(prev => {
                        return {
                          ...prev,
                          sectionId: section.sectionId,
                          sectionData: section.sectionData,
                        }
                      })
                    }
                  })
                }
              })
      
              if (props.currentPageIndex < props.pages.length - 1) {
                // edge case condition for last page
                props.setCurrentPageIndex(prev => prev + 1)
                setCurrentSectionIndex(0)
                //console.log(journeyState, "journey state")
              }
            } else {
              // condition of same page
      
              //Handeling context change
              if (sectionState.sectionId !== null) {
                //console.log("is section ID null")
                if (pageState.pageId === props.pageId) {
                  let foundSection = pageState.pageData.find(
                    //to prevent duplicate section
                    element => element.sectionId === sectionState.sectionId
                  )
                  //console.log(foundSection, "foundSection")
      
                  if (foundSection) {
                    // removing the old section to add new section
                    const newPageData = pageState.pageData.filter(
                      element => element.sectionId !== foundSection.sectionId
                    )
                    setPageState(prev => {
                      return {
                        ...prev,
                        pageData: newPageData, //newPageData has all sections except founded section
                      }
                    })
                    foundSection = {}
                  }
      
                  setPageState(prev => {
                    return {
                      ...prev,
                      pageData: [...prev.pageData, sectionState], // adding new section
                    }
                  })
                } else {
                  setPageState(prev => {
                    // case of new page
                    return {
                      ...prev,
                      pageId: props.pageId,
                      pageData: [...prev.pageData, sectionState],
                    }
                  })
                }
              }
      
              setSectionState(prev => {
                // making section data empty to load new sectionData
                return {
                  ...prev,
                  sectionId: null,
                  sectionFirstPass: null,
                  sectionData: {},
                }
              })
      
              pageState.pageData.map((element, index) => {
                if (
                  element.sectionId === sections[currentSectionIndex + 1].sectionId
                ) {
                  //loading section state if already present
                  setSectionState(prev => {
                    return {
                      ...prev,
                      sectionId: element.sectionId,
                      sectionData: element.sectionData,
                    }
                  })
                }
              })
      
              // console.log(sectionState, "section state")
              // console.log(pageState, "pageState")
              // console.log(journeyState, "journey state else")
              // console.log("setCurrentSectionIndex6");
              // setCurrentSectionIndex(prev => prev + 1)
              // props.sections[currentSectionIndex].class = "active"
            }

             // save application details
          setJourneyState(prev => {
            return {
              ...prev,
              lastPage: props.currentPageIndex,
              lastSection: currentSectionIndex,
              lastPageCode: props.pageId,
              lastSectionCode: sections[currentSectionIndex].sectionId,
              journeyCode: findCurrentJourneyCode(props.pageId, sections[currentSectionIndex].sectionId)
            }
          })
            props.sections[currentSectionIndex].class = "active"
            setErrorState({})
            }
        } 
      }).catch(err => {
        console.log(err, "err in saveApplication componentButton")
      })
    } else {
      if ((sections[currentSectionIndex].sectionId === "SectionGOPAChooseYourPlan" && errorState["GOPAcpRelationshipwithLa"] && errorState["GOPAcpRelationshipwithLa"] === "This option is not available for this plan")
      ) {
        errorToastr(`Thank You for choosing Canara HSBC Life Insurance Company Limited -${lookup?.['errorToaster']?.[journeyState.journeyIdFromStrapi]}. Basis your input this Plan is not available.`)
      }
      setShowError(true)
    }
  }

  const handleJourneyProceedButton = async () => {
    if (sections[currentSectionIndex].proceedButtonFunctionToCall) {
      if (sections[currentSectionIndex].proceedButtonFunctionToCall === "handleCalculateGurantedSumGSP") {
        handleCalculateGurantedSumGSP()
      }
      else {
        return
      }
    } else {
      handleSubmit()
    }
  }

  // code of tab enter
  const handleEnterPrevious = (event) => {
    if (event?.key == 'Enter') {
      handlePreviousClick();
    }
  }

  return (
    <>
      <style>
        {`
            .journey-buttons{
              clear: both;
              margin: -20px 0px 0px 0px;
              padding: 0px;
              display: inline-block;
              width: 100%;
              text-align: center;
            }
            .middle{
              flex: 0 0 auto;
              width: 100%;
            }
            @media (max-width: 767px){
              .journey-buttons {
                padding: 15px 0px !important;
                margin: -20px 0px 0px 0px;
              }
            }
            // button{
            //   color: white;
            //   background-color: var(--lumiq-tertiary);
            //   height: 50px;
            //   width: 80px;
            //   margin-right: 20px;
            //   border-radius: 10px;
            //   border: none;
            // }  
          `}
      </style>
      {/* body-section */}
      {sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "provide-your-consent" ? (
        <ProvideYourConsent
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
          applicationDataInJourneyFormat={applicationDataInJourneyFormat}
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "provide-your-consent-proposer" ? (
        <ProvideYourConsentProposer
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
          applicationDataInJourneyFormat={applicationDataInJourneyFormat}
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "ekyc" ? (
        <Ekyc
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
          applicationDataInJourneyFormat={applicationDataInJourneyFormat}
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "ekycProposer" ? (
        <EkycProposer
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
          applicationDataInJourneyFormat={applicationDataInJourneyFormat}
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "ckyc" ? (
        <Ckyc
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
          applicationDataInJourneyFormat={applicationDataInJourneyFormat}
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "ckycProposer" ? (
        <CkycProposer
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
          applicationDataInJourneyFormat={applicationDataInJourneyFormat}
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "benefit-illustration" ? ( // for iselect star
        <BenefitIllustration
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "sectionGuaranteedSavingBenefitIllustration" ? ( // for flexi Edge
        <BenefitIllustrationGSP
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "SectionPOSBenefitIllustration" ? ( //For POS-EasyBachat
        <BenefitIllustrationPos
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "SectionPOSPremiumQuotation" ? ( //For POS-EasyBachat
        <EasyBachatPremium
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "SectionULIPBenefitIllustration" ? ( //For invest4g
        <BenefitIllustrationUlip
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "sectionTitaniumBenefitIllustration" ? ( //For titaniumPlus
        <BiTitaniumPlusPlan
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "SectionGuaranteedIncomeAdvantagePremiumQuotation" ? ( //For titaniumPlus
        <YourPremiumQuotationGIAP
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "sectionGOPABenefitIllustration" ? ( //For titaniumPlus
        <BIGopaLAPlan
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "SectionULIPYourFundValue" ? ( //For invest4g
        <Invest4GFundValue
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
      ) 
      : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "make-Payment" ? (
        <Payment
          channel={journeyState.channel}
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
          applicationDataInJourneyFormat={applicationDataInJourneyFormat}
        />
      )
       : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "UploadDocuments" ? (
        <UploadDocuments
          channel={journeyState.channel} 
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
          applicationDataInJourneyFormat={applicationDataInJourneyFormat}
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "sectionFlexiEdgeViewBenefitFlexiSaving" && journeyState.journeyIdFromStrapi === "insureSmart" ? (
        <BiYourFound
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "SectionInvest4GYourFundValue" ? (
        <PremiumQuoteInvest4g
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "SectionInvest4GBenefitIllustration" ? (
        <BIInvest4g
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "sectionFlexiEdgeViewBenefitFlexiSaving" && journeyState.journeyIdFromStrapi === "FlexiEdgeJourney" ? ( // FlexiEdge Plan
        <BIFlexiSaving
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "sectionsmartJuniorViewBenefitFlexiSaving" ? ( // smartJunior Plan
        <SmartJuniorBenefitIllustration
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "SectionSmartJuniorYourPremiumQuotation" ? ( // smartJunior Plan premium qoutation page
        <SmartJuniorPremiumQuotation
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "SectionSecureBhavishyaYourfundValue" ? ( // secureBhavishya Plan Fund value page
        <SecureBhavishyaFund
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "SectionSecureBhavishyaBenefitIllustration" ? ( // secureBhavishya Plan BI
        <Secure_Bhavishya_BI
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "sectionFlexiEdgeViewBenefitFlexiSaving" && journeyState.journeyIdFromStrapi === "guaranteedSavingsOption" ? ( //guareentedSavingsPlan
        <BiGsp
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "sectionFlexiEdgeViewBenefitFlexiSaving" && journeyState.journeyIdFromStrapi === "jeevanNivesh" ? ( // jeevanNivesh Plan
        <BiJeevanNivesh
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "CPChoosePlanSection" ? (
        <ChooseYourPlan
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          pages={props.pages}
          callBi={callBi}
          setCallBi={setCallBi}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "successful-transaction" ? (
        <SuccessfulTransactions
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          pages={props.pages}
          callBi={callBi}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
          applicationDataInJourneyFormat={applicationDataInJourneyFormat}
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "unsuccessful-transaction" ? (
        <UnsuccessfulTransaction
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
          applicationDataInJourneyFormat={applicationDataInJourneyFormat}
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "pending-transaction" ? (
        <PendingTransaction
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "pending-transaction-basba" ? (
        <PendingTransactionBasba
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "eNach-physicalMandate" ? (
        <ENachPhysicalMandate
          channel={journeyState.channel}
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
          applicationDataInJourneyFormat={applicationDataInJourneyFormat}
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "declaration" ? (
        <Declaration
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
          applicationDataInJourneyFormat={applicationDataInJourneyFormat}
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "salesConfidentialReport" ? (
        <SalesConfidentialReport
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pages={props.pages}
          pageId={props.pageId}
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "SectionInsureSmartYourFundValue" ? (
        <InsureSmartYourFundValue
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "SectionGuaranteedFortuneYourPremiumQuotation" ? (
        <GuaranteedFortunePQ
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "sectionGuaranteedFortuneViewBenefitIllustration" ? (
        <GuaranteedFortuneBI
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "SectionGuaranteedIncome4LifeViewBenefitIllustration" ? (
        <BiGI4L
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "SectionJeevanNiveshYourPremiumQuotation" ? (
        <YourPremiumQuotationJeevanNivesh
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "application-submission" ? (
        <Submission
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
          applicationDataInJourneyFormat={applicationDataInJourneyFormat}
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "reviewDetailsflexiEdge" ? (
        <ReviewDetailsflexiEdge
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
          applicationDataInJourneyFormat={applicationDataInJourneyFormat}
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "reviewDetails" ? (
        <ReviewDetails
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          saveApplicationCounter={saveApplicationCounter}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "CFYourFundValue" ? (
        <YourPremiumQuotation
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          saveApplicationCounter={saveApplicationCounter}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
        ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "AlphaWealthPlanYourFundValueSection" ? (
        <YourPremiumQuotationAlphaWealth
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          saveApplicationCounter={saveApplicationCounter}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
        ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "AlphaWealthPlanBenefitIllustrationSection" ? (
        <BIalphaWealthPlan
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          saveApplicationCounter={saveApplicationCounter}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "SectionGiapViewBenefitIllustration" ? (
        <BiGIAP
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "sectionGAINbenefitIllustration" ? (
        <BiGAIN
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "sectionMoneyBackViewBenefitIllustration" ? (
        <BiMoneyBack
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "SectionMoneyBackYourPremiumQuotation" ? (
        <YourPremiumMoneyBack
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
      ) : sections?.[currentSectionIndex] &&
        sections[currentSectionIndex].sectionId === "SectionGuaranteedSavingsYourPremiumQuatation" ? (
        <YourPremiumQuotationGSP
          currentPageIndex={props.currentPageIndex}
          currentSectionIndex={currentSectionIndex}
          setCurrentSectionIndex={setCurrentSectionIndex}
          setCurrentPageIndex={props.setCurrentPageIndex}
          sections={sections}
          pageId={props.pageId}
          saveApplicationCounter={saveApplicationCounter}
          showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
          setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        />
      ) : sections?.[currentSectionIndex] &&
      sections[currentSectionIndex].sectionId === "SectionGuaranteedFuturePremiumQuotation" ? (
      <YourPremiumQuotationGuaranteedFuture
        currentPageIndex={props.currentPageIndex}
        currentSectionIndex={currentSectionIndex}
        setCurrentSectionIndex={setCurrentSectionIndex}
        setCurrentPageIndex={props.setCurrentPageIndex}
        sections={sections}
        pageId={props.pageId}
        saveApplicationCounter={saveApplicationCounter}
        showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
        setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
        applicationDataInJourneyFormat={applicationDataInJourneyFormat}
      />
    ) : sections?.[currentSectionIndex] &&
    sections[currentSectionIndex].sectionId === "sectionGuaranteedFutureBenefitIllustration" ? (
    <BIGuaranteedFuture
      currentPageIndex={props.currentPageIndex}
      currentSectionIndex={currentSectionIndex}
      setCurrentSectionIndex={setCurrentSectionIndex}
      setCurrentPageIndex={props.setCurrentPageIndex}
      sections={sections}
      pageId={props.pageId}
      saveApplicationCounter={saveApplicationCounter}
      showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
      setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
      applicationDataInJourneyFormat={applicationDataInJourneyFormat}
    />
    ) : sections?.[currentSectionIndex] &&
    sections[currentSectionIndex].sectionId === "ThankYou" ? (
    <ThankYou
      currentPageIndex={props.currentPageIndex}
      currentSectionIndex={currentSectionIndex}
      setCurrentSectionIndex={setCurrentSectionIndex}
      setCurrentPageIndex={props.setCurrentPageIndex}
      sections={sections}
      pageId={props.pageId}
      showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
      setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan} 
      applicationDataInJourneyFormat={applicationDataInJourneyFormat}
    />
  ) :  sections?.[currentSectionIndex] &&
    sections[currentSectionIndex].sectionId === "sectionBookSlot" ? (
    <BookTPASlot
      currentPageIndex={props.currentPageIndex}
      currentSectionIndex={currentSectionIndex}
      setCurrentSectionIndex={setCurrentSectionIndex}
      setCurrentPageIndex={props.setCurrentPageIndex}
      sections={sections}
      pageId={props.pageId}
      saveApplicationCounter={saveApplicationCounter}
      applicationDataInJourneyFormat={applicationDataInJourneyFormat}
    />
    ) :  sections?.[currentSectionIndex] &&
    sections[currentSectionIndex].sectionId === "sectionBookSlotSA" ? (
    <BookTPASlotSA
      currentPageIndex={props.currentPageIndex}
      currentSectionIndex={currentSectionIndex}
      setCurrentSectionIndex={setCurrentSectionIndex}
      setCurrentPageIndex={props.setCurrentPageIndex}
      sections={sections}
      pageId={props.pageId}
      saveApplicationCounter={saveApplicationCounter}
      applicationDataInJourneyFormat={applicationDataInJourneyFormat}
    />
    ) : (
        <>
          <div className="landing-page1-design">
            <div className="container">
              <div className="row">
                {/* left-side */}

                <Section
                  section={sections?.[currentSectionIndex]}
                  currentSectionIndex={currentSectionIndex}
                  setCurrentSectionIndex={setCurrentSectionIndex}
                  currentPageIndex={props.currentPageIndex}
                  setCurrentPageIndex={props.setCurrentPageIndex}
                  pageId={props.pageId}
                  showError={showError}
                  setShowError={setShowError}
                  pages={props.pages}
                  sections={sections}
                  sectionId={sections?.[currentSectionIndex]?.sectionId}
                  nvestFilterResult={nvestFilterResult}
                  saveApplicationAndCallBi={saveApplicationAndCallBi}
                  showFirstSectionFields={props.showFirstSectionFields}
                  firstPassForPremiumPaymentBicall={firstPassForPremiumPaymentBicall}
                  setFirstPassForPremiumPaymentBicall={setFirstPassForPremiumPaymentBicall}
                  showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
                  setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan}
                  applicationDataInJourneyFormat={applicationDataInJourneyFormat}
                />
                {/* left-side */}

                {/* <!--right-side--> */}
                {
                  journeyState.journeySteps.showRideSideBar &&

                  <RightSideBar
                    sections={sections}
                    currentSectionIndex={currentSectionIndex} 
                    setCurrentSectionIndex={setCurrentSectionIndex}     
                    showMainButtonFlexiEdgePlan={showMainButtonFlexiEdgePlan}
                    setShowMainButtonFlexiEdgePlan={setShowMainButtonFlexiEdgePlan}    
                    channelForColorChange = {journeyState.channel}  
                  />
                }

                {/* <!--right-side--> */}
              </div>
            </div>
          </div>
          {showMainButtonFlexiEdgePlan && !sections?.[currentSectionIndex]?.notShowJourneyButtons &&
            <div className="container" >
              <div className="middle">
                <div className={`journey-buttons hidden-desktop-screen ${journeyState?.journeySteps?.showRideSideBar ? "w-75" : "w-100"}`}>
                  {/* {console.log("page indexing",props,props.currentPageIndex , currentSectionIndex )} */}
                  {!((props.currentPageIndex === 0 || props.pageId === "fillProposalForm" || props.pageId === "pageISelect360FillProposalForm" || props.pageId === "PageFlexiEdgeFillProposalForm") && currentSectionIndex === 0) && (
                    <div className="provider submit-btn cen" tabIndex="0"
                      onKeyPress={(e) => handleEnterPrevious(e)}
                    >
                      <a aria-hidden="true" onClick={handlePreviousClick}>{sections[currentSectionIndex]?.previousButtonName ? sections[currentSectionIndex]?.previousButtonName : "Previous"}</a>
                    </div>
                  )}
                  <input
                    type="submit"
                    className="provider previous-btn cen"
                    tabIndex="0"
                    style={{
                      color: "white",
                      padding: "14px 40px",
                      border: "none",
                    }}
                    onClick={handleJourneyProceedButton}
                    value={sections[currentSectionIndex]?.proceedButtonName ? sections[currentSectionIndex]?.proceedButtonName : "Proceed"}
                  />
                </div>
              </div>
            </div>
          }

          {/* <!--mobile view button--> */}
          {showMainButtonFlexiEdgePlan && !sections?.[currentSectionIndex]?.notShowJourneyButtons &&
            <div className="mobile-view-btn-Q1 pd-mobile-space-structure">
              <div className="iselect-mg-bottom">
                <div className="col-md-12">
                  <div className="but-center text-center">
                    {!(
                      (props.currentPageIndex === 0 || props.pageId === "fillProposalForm" || props.pageId === "pageISelect360FillProposalForm") && currentSectionIndex === 0
                    ) && (
                        <div className="submit-btn cen">
                          <a aria-hidden="true" onClick={handlePreviousClick}>{sections[currentSectionIndex]?.previousButtonName ? sections[currentSectionIndex]?.previousButtonName : "Previous"}</a>
                        </div>
                      )}
                    <input
                      type="submit"
                      className="previous-btn cen"
                      style={{
                        color: "white",
                        padding: "14px 40px",
                        border: "none",
                        marginLeft: "8px",
                      }}
                      onClick={handleJourneyProceedButton}
                      value={sections[currentSectionIndex]?.proceedButtonName ? sections[currentSectionIndex]?.proceedButtonName : "Proceed"}
                    />
                  </div>
                </div>
              </div>
            </div>
          }
          {/* <!--mobile view button-->   */}
          {/* body-section */}
        </>
      )}
    </>
  )
}

export default Page
